'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var ReactDOM = _interopDefault(require('react-dom'));
var FastClick = _interopDefault(require('fastclick'));
var createHistory = _interopDefault(require('history/createBrowserHistory'));
var redux = require('redux');
var reduxThunk = _interopDefault(require('redux-thunk'));
var cx = _interopDefault(require('classnames'));
var Bugsnag$1 = _interopDefault(require('bugsnag-js'));
var reactRedux = require('react-redux');
var reselect = require('reselect');
var MaskedInput = _interopDefault(require('@musicglue/react-maskedinput'));

// eslint-disable-next-line space-before-function-paren
function createReducer(reducers, defaultState) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (reducers[action.type]) return reducers[action.type](state, action);
    return state;
  };
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();









var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();











var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var assoc = function assoc(object, key, value) {
  return _extends({}, object, defineProperty({}, key, value));
};


var assign = function assign(object, values) {
  return _extends({}, object, values);
};

var append = function append(base) {
  for (var _len = arguments.length, items = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    items[_key - 1] = arguments[_key];
  }

  return [].concat(toConsumableArray(base), toConsumableArray(items));
};



var dropLast = function dropLast(base) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return base.slice(0, -count);
};

var UPDATE_VIEWER = 'CONFIG:UPDATE_VIEWER';



var UPDATE_PIXEL_TRACKING = 'CONFIG:UPDATE_PIXEL_TRACKING';



var UPDATE_PROFILE = 'CONFIG:UPDATE_PROFILE';




var UPDATE_PAGE = 'CONFIG:UPDATE_PAGE';




var UPDATE_CONFIG = 'CONFIG:UPDATE';


var updateConfig = function updateConfig(config) {
  return {
    type: UPDATE_CONFIG,
    page: config.page || {},
    pixelTracking: config.pixelTrackingConfig || {},
    profile: config.profile || {},
    viewer: config.viewer || {}
  };
};

var _reducers;

var defaultState$1 = {
  page: {
    themePreview: null
  },
  pixelTracking: {
    googleAnalytics: null,
    facebookPixel: null,
    twitterTag: null
  },
  profile: {
    uuid: null,
    slug: '',
    name: '',
    websiteMode: false
  },
  viewer: {
    country: {},
    currency: null,
    language: null
  }
};

var reducers = (_reducers = {}, defineProperty(_reducers, UPDATE_CONFIG, function (state, action) {
  return assign(state, {
    page: assign(state.page, action.page),
    pixelTracking: assign(state.pixelTracking, action.pixelTracking),
    profile: assign(state.profile, action.profile),
    viewer: assign(state.viewer, action.viewer)
  });
}), defineProperty(_reducers, UPDATE_PAGE, function (state, _ref) {
  var config = _ref.config;
  return assign(state, { page: assign(state.page, config) });
}), defineProperty(_reducers, UPDATE_PIXEL_TRACKING, function (state, _ref2) {
  var config = _ref2.config;
  return assign(state, { pixelTracking: assign(state.pixelTracking, config) });
}), defineProperty(_reducers, UPDATE_PROFILE, function (state, _ref3) {
  var profile = _ref3.profile;
  return assign(state, { profile: assign(state.profile, profile) });
}), defineProperty(_reducers, UPDATE_VIEWER, function (state, _ref4) {
  var viewer = _ref4.viewer;
  return assign(state, { viewer: assign(state.viewer, viewer) });
}), _reducers);

var config = createReducer(reducers, defaultState$1);

/* eslint-disable max-len */

var compose$1 = function compose$1() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (arg) {
    return (
      // $FlowFixMe don't worry flow, everything is OK
      fns.reduceRight(function (val, fn) {
        return fn(val);
      }, arg)
    );
  };
};

var pipe = function pipe() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (arg) {
    return (
      // $FlowFixMe seriously, don't worry about it
      fns.reduce(function (val, fn) {
        return fn(val);
      }, arg)
    );
  };
};

// eslint-disable-next-line flowtype/require-return-type, flowtype/require-parameter-type
var curried = function curried(fn, arity, acc) {
  return function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var combined = acc.concat(args);

    // $FlowFixMe ssshhhhhh
    return combined.length >= arity ? fn.apply(undefined, toConsumableArray(combined)) : curried(fn, arity, combined);
  };
};

// $FlowFixMe hush now
var curry = function curry(fn) {
  return curried(fn, fn.length, []);
};

// Like Object.values, but only works on objects where all the keys are of the same type.
// Keeps flow happy.
var values = function values(object) {
  return Object.keys(object).map(function (key) {
    return object[key];
  });
};

var compact = function compact(array) {
  return array.filter(function (v) {
    return !!v;
  });
};

var entries = function entries(object) {
  return Object.keys(object).map(function (key) {
    return [key, object[key]];
  });
};

var toArray$1 = function toArray$1(arrayLike) {
  return Array.prototype.slice.call(arrayLike);
};

var fromPairs = function fromPairs(pairs) {
  return pairs.reduce(function (obj, _ref) {
    var _ref2 = slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return Object.assign(obj, defineProperty({}, key, value));
  }, {});
};

var mapObj = function mapObj(object, fn) {
  return fromPairs(entries(object).map(function (_ref3) {
    var _ref4 = slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return [key, fn(value, key)];
  }));
};

var filterObj = function filterObj(object, fn) {
  return fromPairs(entries(object).filter(function (_ref5) {
    var _ref6 = slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return fn(value, key);
  }));
};

var flatten = function flatten(array) {
  return array.reduce(function (memo, value) {
    return memo.concat(Array.isArray(value) ? value : [value]);
  }, []);
};

var flatMap = function flatMap(array, fn) {
  return flatten(array.map(fn));
};

var last = function last(array) {
  return array[array.length - 1];
};

var omit = function omit(object, keys) {
  return filterObj(object, function (val, key) {
    return !keys.includes(key);
  });
};

var pick = function pick(object, keys) {
  return filterObj(object, function (val, key) {
    return keys.includes(key);
  });
};

var partition = function partition(array, fn) {
  return array.reduce(function (memo, value) {
    memo[fn(value) ? 0 : 1].push(value);
    return memo;
  }, [[], []]);
};

var noop = function noop() {};

var identity = function identity(val) {
  return val;
};

var times = function times(count, fn) {
  var result = [];
  for (var i = 0; i < count; i += 1) {
    result.push(fn(i));
  }return result;
};

var compare = function compare(a, b) {
  if (a === b) return 0;
  if (a < b) return -1;
  return 1;
};

var sortBy = function sortBy(array, fn) {
  return array.slice().sort(function (a, b) {
    return compare(fn(a), fn(b));
  });
};

var memoize = function memoize(fn) {
  var cache = new Map();

  return function (arg) {
    if (!cache.has(arg)) cache.set(arg, fn(arg));
    // $FlowFixMe we know that arg is there as we just did `has`
    return cache.get(arg);
  };
};

var uniqueBy = function uniqueBy(field, arr) {
  return arr.reduce(function (acc, curr) {
    return acc.find(function (v) {
      return v[field] === curr[field];
    }) ? acc : acc.concat(curr);
  }, []);
};

var hasOwnProperty = function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};

var shallowEqual = function shallowEqual(a, b) {
  if (Object.is(a, b)) return true;

  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i += 1) {
    var _key = keysA[i];
    if (!hasOwnProperty(b, _key) || !Object.is(a[_key], b[_key])) return false;
  }

  return true;
};

var groupBy = function groupBy(arr, fn) {
  return arr.map(function (item) {
    return [fn(item), item];
  }).reduce(function (grouped, _ref7) {
    var _ref8 = slicedToArray(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return Object.assign(grouped, defineProperty({}, key, grouped[key] ? [].concat(toConsumableArray(grouped[key]), [value]) : [value]));
  }, {});
};

var debounce = function debounce(delay, fn) {
  var timeout = null;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return fn.apply(undefined, toConsumableArray(args));
    }, delay);
  };
};

var getProp = curry(function (a, b) {
  return b == null ? null : b[a];
});

var toBool = function toBool(v) {
  return !!v;
};

var match = function match(re) {
  return function (str) {
    return re.test(str);
  };
};

var not = function not(v) {
  return !v;
};

var trim = function trim(s) {
  return s.trim();
};

var tap$1 = function tap$1(f) {
  return function (arg) {
    f(arg);
    return arg;
  };
};

var ifNotNull = curry(function (f, a) {
  return a == null ? null : f(a);
});

var FIELD_BLUR = 'FORM:FIELD_BLUR';


var fieldBlur = function fieldBlur(form, name, value) {
  return {
    type: FIELD_BLUR,
    form: form,
    name: name,
    value: value
  };
};

var FIELD_CHANGE = 'FORM:FIELD_CHANGE';

var fieldChange = function fieldChange(form, name, value) {
  return {
    type: FIELD_CHANGE,
    form: form,
    name: name,
    value: value
  };
};

var FIELD_FOCUS = 'FORM:FIELD_FOCUS';

var fieldFocus = function fieldFocus(form, name) {
  return {
    type: FIELD_FOCUS,
    form: form,
    name: name
  };
};

var INITIAL_VALUES = 'FORM:INITIAL_VALUES';

var initialValues$1 = function initialValues$1(form, values) {
  return {
    type: INITIAL_VALUES,
    form: form,
    values: values
  };
};

var VALIDATION_REQUEST = 'FORM:VALIDATION_REQUEST';

var validationRequest = function validationRequest(form, requestId) {
  return {
    type: VALIDATION_REQUEST,
    form: form,
    requestId: requestId
  };
};

var VALIDATION_COMPLETE = 'FORM:VALIDATION_COMPLETE';

var validationComplete = function validationComplete(form, errors) {
  return {
    type: VALIDATION_COMPLETE,
    form: form,
    errors: errors
  };
};

var SUBMIT_START = 'FORM:SUBMIT_START';

var submitStart = function submitStart(form) {
  return {
    type: SUBMIT_START,
    form: form
  };
};

var SUBMIT_COMPLETE = 'FORM:SUBMIT_COMPLETE';

var submitComplete = function submitComplete(form) {
  return {
    type: SUBMIT_COMPLETE,
    form: form
  };
};

var SUBMIT_ERROR = 'FORM:SUBMIT_ERROR';

var submitError = function submitError(form) {
  return {
    type: SUBMIT_ERROR,
    form: form
  };
};

var submit$1 = function submit$1(form, submitFn, props) {
  return function (dispatch, getState) {
    var formState = getState().form[form];
    if (!formState || formState.submitting) return Promise.resolve();

    dispatch(submitStart(form));
    return submitFn(formState, props).then(function () {
      return dispatch(submitComplete(form));
    }).catch(function (error) {
      return Promise.resolve(dispatch(submitError(form))).then(function () {
        return Promise.reject(error);
      });
    });
  };
};

var _reducers$1;

var defaultState$2 = {};

var defaultForm = function defaultForm(name) {
  return {
    errors: [],
    fields: {},
    hasValidated: false,
    lastInitialValues: null,
    name: name,
    submitting: false,
    submitSuccess: null,
    valid: null,
    validationRequest: null
  };
};

var defaultField = function defaultField(name) {
  return {
    active: false,
    dirty: false,
    errors: [],
    name: name,
    touched: false,
    value: null
  };
};

var fieldUpdate = function fieldUpdate(state, form, name, update, formUpdate) {
  var originalFormState = state[form] || defaultForm(form);
  var formState = formUpdate ? assign(originalFormState, formUpdate) : originalFormState;

  var fieldState = assign(formState.fields[name] || defaultField(name), update);

  return assoc(state, form, assign(formState, {
    fields: assoc(formState.fields, name, fieldState)
  }));
};

var getField = function getField(state, form, name) {
  return state[form] && state[form].fields[name] || defaultField(name);
};

var reducers$1 = (_reducers$1 = {}, defineProperty(_reducers$1, FIELD_BLUR, function (state, _ref) {
  var form = _ref.form,
      name = _ref.name;
  return fieldUpdate(state, form, name, {
    touched: true,
    active: false
  });
}), defineProperty(_reducers$1, FIELD_CHANGE, function (state, _ref2) {
  var form = _ref2.form,
      name = _ref2.name,
      value = _ref2.value;
  return fieldUpdate(state, form, name, {
    value: value,
    touched: true,
    dirty: true
  });
}), defineProperty(_reducers$1, FIELD_FOCUS, function (state, _ref3) {
  var form = _ref3.form,
      name = _ref3.name;
  return fieldUpdate(state, form, name, {
    touched: true,
    active: true
  });
}), defineProperty(_reducers$1, INITIAL_VALUES, function (state, _ref4
// With each value, update the field value if the field value hasn't been changed by the user
) {
  var form = _ref4.form,
      values$$1 = _ref4.values;
  return entries(values$$1).reduce(function (nextState, _ref5) {
    var _ref6 = slicedToArray(_ref5, 2),
        name = _ref6[0],
        value = _ref6[1];

    return getField(nextState, form, name).dirty ? nextState : fieldUpdate(nextState, form, name, { value: value });
  },

  // Associate `lastInitialValues` with the form, creating it if it doesnt exist
  assoc(state, form, assign(state[form] || defaultForm(form), { lastInitialValues: values$$1 })));
}), defineProperty(_reducers$1, VALIDATION_REQUEST, function (state, _ref7) {
  var form = _ref7.form,
      requestId = _ref7.requestId;
  return assoc(state, form, assign(state[form] || defaultForm(form), { validationRequest: requestId }));
}), defineProperty(_reducers$1, VALIDATION_COMPLETE, function (state, _ref8) {
  var form = _ref8.form,
      errors = _ref8.errors;

  var formState = state[form] || defaultForm(form);
  var groupedErrors = groupBy(errors.filter(function (error) {
    return error.field;
  }), function (e) {
    return e.field || '';
  });
  var allFields = Object.keys(formState.fields).concat(Object.keys(groupedErrors));

  return allFields.reduce(function (nextState, fieldName) {
    var fieldState = getField(nextState, form, fieldName);
    var fieldErrors = groupedErrors[fieldName];
    return fieldState.errors.length === 0 && !fieldErrors ? nextState : fieldUpdate(nextState, form, fieldName, { errors: fieldErrors || [] });
  }, assoc(state, form, assign(formState, {
    errors: errors,
    hasValidated: true,
    valid: errors.length === 0
  })));
}), defineProperty(_reducers$1, SUBMIT_START, function (state, _ref9) {
  var form = _ref9.form;
  return assoc(state, form, assign(state[form] || defaultForm(form), { submitting: true }));
}), defineProperty(_reducers$1, SUBMIT_COMPLETE, function (state, _ref10) {
  var form = _ref10.form;
  return assoc(state, form, assign(state[form] || defaultForm(form), { submitting: false, submitSuccess: true }));
}), defineProperty(_reducers$1, SUBMIT_ERROR, function (state, _ref11) {
  var form = _ref11.form;
  return assoc(state, form, assign(state[form] || defaultForm(form), { submitting: false, submitSuccess: false }));
}), _reducers$1);

var form = createReducer(reducers$1, defaultState$2);

function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['children', 'className']);

  return React.createElement(
    'button',
    _extends({ className: cx('Button', className) }, props),
    children
  );
}

// A teeny tiny thing for doing translations. If we need something more, we can add it later.

var lookup = function lookup(_ref) {
  var _ref2 = toArray(_ref),
      first = _ref2[0],
      path = _ref2.slice(1);

  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.LOCALE;

  if (!target) return null;
  if (!path.length) return target[first];
  return lookup(path, target[first]);
};

var t = (function (key, options) {
  var localeString = lookup(key.split('.'));

  if (localeString == null) {
    return process.env.NODE_ENV !== 'production' ? 'No translation key ' + key + '. Make sure you\'ve added it to the whitelist in i18n.js.' : key;
  }

  if (!options) return localeString;

  return entries(options).reduce(function (str, _ref3) {
    var _ref4 = slicedToArray(_ref3, 2),
        name = _ref4[0],
        value = _ref4[1];

    return str.replace(new RegExp('%{' + name + '}', 'g'), value);
  }, localeString);
});

function SimpleModal(props) {
  var title = props.title,
      content = props.content,
      onDismiss = props.onDismiss;


  return jsx('div', {
    className: 'SimpleModal'
  }, void 0, title && jsx('h2', {}, void 0, title), jsx('p', {}, void 0, content), jsx(Button, {
    className: 'SimpleModal-close',
    onClick: onDismiss
  }, void 0, t('alerts.buttons.close')));
}

var fetch$1 = (function (query, variables) {
  var options = {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({ query: query, variables: variables }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      'x-breakwater': 'yes',
      'x-profile-id': window.PROFILE_ID,
      'x-torrent-stem': window.PROFILE_URL
    }
  };

  return fetch(window.GRAPH_URL, options).then(function (response) {
    return response.json();
  });
});

var check = function check(mut) {
  if (!mut.type) throw new Error('Mutation must have `type` property');
  if (!mut.mutation) throw new Error('Mutation must have `mutation` property');
};

var MutationError = function (_Error) {
  inherits(MutationError, _Error);

  function MutationError(_ref) {
    var message = _ref.message,
        name = _ref.name;
    classCallCheck(this, MutationError);

    var _this = possibleConstructorReturn(this, (MutationError.__proto__ || Object.getPrototypeOf(MutationError)).call(this, 'MutationError: ' + message));

    _this.name = name;
    return _this;
  }

  return MutationError;
}(Error);

var Mutation = function () {
  function Mutation(input) {
    classCallCheck(this, Mutation);
    this.query = '';

    this.input = input;
  }

  createClass(Mutation, [{
    key: 'send',
    value: function send() {
      var _this2 = this;

      check(this);

      var input = _extends({}, this.input, {
        clientMutationId: 'X'
      });

      var mut = this.type + '($input:' + this.type + 'Input!)';
      var payloadQuery = '{clientMutationId,' + this.query + '}';
      var query = 'mutation ' + mut + '{' + this.mutation + '(input: $input)' + payloadQuery + '}';

      return fetch$1(query, { input: input }).then(function (_ref2) {
        var data = _ref2.data,
            errors = _ref2.errors;

        if (errors) {
          return Promise.reject(Array.isArray(errors) ? new MutationError(errors[0]) : errors);
        }

        return data && data[_this2.mutation];
      }).then(tap$1(function (res) {
        return;
      }));
    }
  }, {
    key: 'invalidateQueries',
    value: function invalidateQueries(payload, queryIds) {
      // eslint-disable-line no-unused-vars, max-len
      throw new Error('Mutation ' + this.mutation + ' must implement invalidateQueries');
    }
  }, {
    key: 'invalidatePartials',
    value: function invalidatePartials(payload) {
      // eslint-disable-line no-unused-vars
      return [];
    }
  }]);
  return Mutation;
}();

var Query = function () {
  function Query(id, variables) {
    classCallCheck(this, Query);

    this.id = id;
    this.variables = variables;
  }

  createClass(Query, [{
    key: 'toString',
    value: function toString() {
      var _this = this;

      return this.query.replace(/\$([a-z][a-z0-9]*)/ig, function (_, name) {
        if (_this.variables && hasOwnProperty(_this.variables, name)) {
          return JSON.stringify(_this.variables[name]);
        }

        throw new Error('Cannot find variable ' + name);
      });
    }
  }, {
    key: 'resolve',
    value: function resolve(response) {
      return response;
    }
  }]);
  return Query;
}();

var headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Breakwater-Profile-Domain': window.PROFILE_DOMAIN
};

var START_NAVIGATION = 'PAGE:START_NAVIGATION';


var startNavigation = function startNavigation(path) {
  return {
    type: START_NAVIGATION,
    path: path
  };
};

var COMPLETE_NAVIGATION = 'PAGE:COMPLETE_NAVIGATION';


var completeNavigation = function completeNavigation(content, title, secret, bodyAttrs) {
  return {
    type: COMPLETE_NAVIGATION,
    content: content,
    title: title,
    secret: secret,
    bodyAttrs: bodyAttrs
  };
};

var navigate = function navigate(path) {
  return function (dispatch, getState) {
    dispatch(startNavigation(path));

    var state = getState();
    var variables = state.page.overrides;
    var themePreview = state.config.page.themePreview;

    var _ref = variables == null ? { method: 'GET', body: null } : { method: 'POST', body: JSON.stringify({ variables: variables }) },
        method = _ref.method,
        body = _ref.body;

    var url = themePreview ? path + '?__pjax=1&themePreview=' + themePreview : path + '?__pjax=1';

    return fetch(url, { headers: headers, credentials: 'include', method: method, body: body }).then(function (response) {
      return response.json();
    }).then(function (_ref2) {
      var content = _ref2.content,
          title = _ref2.title,
          secret = _ref2.secret,
          bodyAttrs = _ref2.bodyAttrs;

      dispatch(completeNavigation(content, title, secret, bodyAttrs));
    });
  };
};

var START_FETCH_PARTIAL = 'PAGE:START_FETCH_PARTIAL';


var startFetchPartial = function startFetchPartial(name) {
  return {
    type: START_FETCH_PARTIAL,
    name: name
  };
};

var COMPLETE_FETCH_PARTIAL = 'PAGE:COMPLETE_FETCH_PARTIAL';


var completeFetchPartial = function completeFetchPartial(name, content) {
  return {
    type: COMPLETE_FETCH_PARTIAL,
    name: name,
    content: content
  };
};

var INVALIDATE_PARTIALS = 'PAGE:INVALIDATE_PARTIALS';


var invalidatePartials$1 = function invalidatePartials$1(names) {
  return {
    type: INVALIDATE_PARTIALS,
    names: names
  };
};

var fetchPartial = function fetchPartial(name, identifier, query) {
  return function (dispatch, getState) {
    var state = getState();

    var themePreview = state.config.page.themePreview;
    var profileId = state.config.profile.uuid;
    if (!profileId) return Promise.reject(new Error('cannot fetch partial without profile id'));

    var partial = state.page.partials[identifier];
    if (partial && partial.fetching) return Promise.resolve();

    dispatch(startFetchPartial(identifier));

    var variables = state.page.overrides;
    var queryString = themePreview ? '?themePreview=' + themePreview : '';

    var url = '/__partial/' + profileId + '/' + name + queryString;
    var body = JSON.stringify({ variables: variables, query: query });

    return fetch(url, {
      body: body,
      credentials: 'include',
      headers: _extends({}, headers, {
        'x-profile-id': window.PROFILE_ID,
        'x-breakwater': 'true',
        'x-torrent-stem': window.PROFILE_URL
      }),
      method: 'POST'
    }).then(function (response) {
      return response.json();
    }).then(function (_ref3) {
      var content = _ref3.content;

      dispatch(completeFetchPartial(identifier, content));
    });
  };
};

var REPLACE_THEME_OVERRIDES = 'PAGE:REPLACE_THEME_OVERRIDES';




var ADD_SECRET = 'PAGE:ADD_SECRET';


var addSecret = function addSecret(secret) {
  return {
    type: ADD_SECRET,
    secret: secret
  };
};

var SHOW_MODAL = 'MODAL:SHOW';


var showModal$1 = function showModal$1(modal, props) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: SHOW_MODAL,
    modal: modal,
    props: props,
    options: options
  };
};

var REPLACE_MODAL = 'MODAL:REPLACE';

var replaceModal = function replaceModal(modal, props) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: REPLACE_MODAL,
    modal: modal,
    props: props,
    options: options
  };
};

var DISMISS_MODAL = 'MODAL:DISMISS';

var dismissModal$1 = function dismissModal$1() {
  return {
    type: DISMISS_MODAL
  };
};

var BATCH_START_TIMEOUT = 10;

var START_QUERY_BATCH = 'GRAPHQL:START_QUERY_BATCH';

var startBatch = function startBatch(queryIds) {
  return {
    type: START_QUERY_BATCH,
    queryIds: queryIds
  };
};

var COMPLETE_QUERY_BATCH = 'GRAPHQL:COMPLETE_QUERY_BATCH';

var completeBatch = function completeBatch(_ref) {
  var data = _ref.data;
  return {
    type: COMPLETE_QUERY_BATCH,
    responses: data
  };
};

var processWaiting = function processWaiting() {
  return function (dispatch, getState) {
    var queries = values(getState().graphql.queries);
    var waiting = queries.filter(function (q) {
      return q.state === 'waiting';
    });
    if (waiting.length === 0) return;

    dispatch(startBatch(waiting.map(function (q) {
      return q.id;
    })));
    var fullQuery = 'query {' + waiting.map(function (q) {
      return q.requestId + ': ' + q.query;
    }).join('\n') + '}';

    fetch$1(fullQuery, {}).then(function (json) {
      return dispatch(completeBatch(json));
    }).catch(function (err) {
      dispatch(showModal$1(SimpleModal, {
        title: t('alerts.titles.error'),
        content: t('alerts.content.error')
      }));
      return Promise.reject(err);
    });
  };
};

var ADD_QUERY = 'GRAPHQL:ADD_QUERY';

var addQuery = function addQuery(query) {
  return {
    type: ADD_QUERY,
    query: query
  };
};

var addQueries = function addQueries(queries) {
  return function (dispatch, getState) {
    var inStore = getState().graphql.queries;

    queries.forEach(function (query) {
      if (!inStore[query.id]) dispatch(addQuery(query));
    });

    setTimeout(function () {
      return dispatch(processWaiting());
    }, BATCH_START_TIMEOUT);
  };
};

var REFETCH_QUERIES = 'GRAPHQL:REFETCH_QUERIES';

var markQueriesForRefetch = function markQueriesForRefetch(queryIds) {
  return {
    type: REFETCH_QUERIES,
    queryIds: queryIds
  };
};

var refetchQueries = function refetchQueries(queryIds) {
  return function (dispatch) {
    dispatch(markQueriesForRefetch(queryIds));
    setTimeout(function () {
      return dispatch(processWaiting());
    }, BATCH_START_TIMEOUT);
  };
};

var fireMutation = function fireMutation(mutation) {
  return function (dispatch, getState) {
    return mutation.send().then(function (payload) {
      var queryIds = Object.keys(getState().graphql.queries);

      var invalidateQueries = mutation.invalidateQueries(payload, queryIds);
      if (invalidateQueries.length) dispatch(refetchQueries(invalidateQueries));

      var invalidatePartials$$1 = mutation.invalidatePartials(payload);
      if (invalidatePartials$$1.length) dispatch(invalidatePartials$1(invalidatePartials$$1));

      if (typeof mutation.after === 'function') {
        return Promise.resolve(mutation.after(payload, dispatch)).then(function () {
          return payload;
        });
      }

      return Promise.resolve(payload);
    }).catch(function (err) {
      if (typeof mutation.error === 'function') {
        mutation.error(err, dispatch);
      }

      return Promise.reject(err);
    });
  };
};

var _reducers$2;

var defaultState$3 = {
  queries: {},
  requestIds: {}
};

var nextRequestId = function nextRequestId(state) {
  return 'q' + Object.keys(state.requestIds).length;
};

var reducers$2 = (_reducers$2 = {}, defineProperty(_reducers$2, ADD_QUERY, function (state, action) {
  if (state.queries[action.query.id]) return state;
  var requestId = nextRequestId(state);
  return assign(state, {
    requestIds: assoc(state.requestIds, requestId, action.query.id),
    queries: assoc(state.queries, action.query.id, {
      id: action.query.id,
      state: 'waiting',
      hasData: false,
      query: action.query.toString(),
      response: null,
      requestId: requestId
    })
  });
}), defineProperty(_reducers$2, START_QUERY_BATCH, function (state, action) {
  return assign(state, {
    queries: action.queryIds.reduce(function (qs, id) {
      return assoc(qs, id, assign(qs[id], { state: 'fetching' }));
    }, state.queries)
  });
}), defineProperty(_reducers$2, COMPLETE_QUERY_BATCH, function (state, action) {
  return assign(state, {
    queries: entries(action.responses).map(function (_ref) {
      var _ref2 = slicedToArray(_ref, 2),
          requestId = _ref2[0],
          response = _ref2[1];

      return [state.requestIds[requestId], response];
    }).reduce(function (qs, _ref3) {
      var _ref4 = slicedToArray(_ref3, 2),
          id = _ref4[0],
          response = _ref4[1];

      return assoc(qs, id, assign(qs[id], {
        state: 'done',
        hasData: true,
        response: response
      }));
    }, state.queries)
  });
}), defineProperty(_reducers$2, REFETCH_QUERIES, function (state, _ref5) {
  var queryIds = _ref5.queryIds;
  return assign(state, {
    queries: queryIds.reduce(function (qs, id) {
      return qs[id] ? assoc(qs, id, assign(qs[id], { state: 'waiting' })) : qs;
    }, state.queries)
  });
}), _reducers$2);

var graphql = createReducer(reducers$2, defaultState$3);

var _reducers$3;

var defaultState$4 = [];

var reducers$3 = (_reducers$3 = {}, defineProperty(_reducers$3, SHOW_MODAL, function (state, _ref) {
  var modal = _ref.modal,
      props = _ref.props,
      options = _ref.options;
  return append(state, { modal: modal, props: props, options: options });
}), defineProperty(_reducers$3, REPLACE_MODAL, function (state, _ref2) {
  var modal = _ref2.modal,
      props = _ref2.props,
      options = _ref2.options;
  return append(dropLast(state), { modal: modal, props: props, options: options });
}), defineProperty(_reducers$3, DISMISS_MODAL, function (state) {
  return dropLast(state);
}), _reducers$3);

var modals = createReducer(reducers$3, defaultState$4);

var _reducers$4;

var defaultPartial = {
  content: null,
  ready: false,
  fetching: false
};

var defaultState$5 = {
  loading: false,
  path: window.location.pathname,
  title: document.title,
  content: document.getElementById('root').innerHTML,
  bodyAttrs: {},
  partials: {},
  overrides: null,
  secret: null
};

var updatePartial = function updatePartial(state, name, update) {
  return assign(state, {
    partials: assoc(state.partials, name, assign(state.partials[name] || defaultPartial, update))
  });
};

var reducers$4 = (_reducers$4 = {}, defineProperty(_reducers$4, START_NAVIGATION, function (state, _ref) {
  var path = _ref.path;
  return assign(state, { loading: true, path: path });
}), defineProperty(_reducers$4, COMPLETE_NAVIGATION, function (state, _ref2) {
  var content = _ref2.content,
      title = _ref2.title,
      secret = _ref2.secret,
      bodyAttrs = _ref2.bodyAttrs;
  return assign(state, { loading: false, content: content, title: title, secret: secret, bodyAttrs: bodyAttrs });
}), defineProperty(_reducers$4, START_FETCH_PARTIAL, function (state, _ref3) {
  var name = _ref3.name;
  return updatePartial(state, name, { fetching: true });
}), defineProperty(_reducers$4, COMPLETE_FETCH_PARTIAL, function (state, _ref4) {
  var name = _ref4.name,
      content = _ref4.content;
  return updatePartial(state, name, { fetching: false, ready: true, content: content });
}), defineProperty(_reducers$4, INVALIDATE_PARTIALS, function (state, _ref5) {
  var names = _ref5.names;
  return names.reduce(function (nextState, name) {
    return updatePartial(nextState, name, { ready: false });
  }, state);
}), defineProperty(_reducers$4, REPLACE_THEME_OVERRIDES, function (state, _ref6) {
  var variables = _ref6.variables;
  return assign(state, { overrides: variables });
}), defineProperty(_reducers$4, ADD_SECRET, function (state, _ref7) {
  var secret = _ref7.secret;
  return assign(state, { secret: secret });
}), _reducers$4);

var page = createReducer(reducers$4, defaultState$5);

var PLAY_TRACK = 'PLAYER:PLAY_TRACK';


var playTrack = function playTrack(playlist, streamId) {
  return {
    type: PLAY_TRACK,
    playlist: playlist,
    streamId: streamId
  };
};

var INITIAL_LOAD = 'PLAYER:INITIAL_LOAD';


var initialLoad$1 = function initialLoad$1(_ref) {
  var tracks = _ref.tracks,
      playback = _ref.playback;
  return {
    type: INITIAL_LOAD,
    tracks: tracks,
    playback: playback
  };
};

var LOADED_TRACK = 'PLAYER:LOADED_TRACK';

var loadedTrack = function loadedTrack() {
  return { type: LOADED_TRACK };
};

var NEXT_TRACK = 'PLAYER:NEXT_TRACK';


var nextTrack$1 = function nextTrack$1() {
  return { type: NEXT_TRACK };
};

var PREVIOUS_TRACK = 'PLAYER:PREVIOUS_TRACK';


var previousTrack$1 = function previousTrack$1() {
  return { type: PREVIOUS_TRACK };
};

var TOGGLE_PLAYBACK = 'PLAYER:TOGGLE_PLAYBACK';


var togglePlayback = function togglePlayback() {
  return { type: TOGGLE_PLAYBACK };
};

var _reducers$5;

var streamToTrack = function streamToTrack(_ref) {
  var streamId = _ref.id,
      type = _ref.type,
      track = _ref.track;
  return track.result == null ? null : {
    streamId: streamId,
    type: type,
    next: null,
    prev: null,
    title: track.result.title,
    author: track.result.author
  };
};

var assignNextProps = function assignNextProps(_ref2) {
  var _ref3 = toArray(_ref2),
      head = _ref3[0],
      tracks = _ref3.slice(1);

  return tracks.reduce(function (playlist, track, i) {
    return playlist.slice(0, i).concat([Object.assign(playlist[i], { next: track.streamId }), Object.assign(track, { prev: playlist[i].streamId, next: null })]);
  }, [assign(head, { prev: null, next: null })]);
};

var defaultState$6 = {
  playlists: {},
  playback: {
    playlistId: null,
    streamId: null,
    hasNext: false,
    hasPrev: false,
    active: false,
    pending: false
  }
};

var getPlaylist = function getPlaylist(playlists, playlistId) {
  if (!playlistId) throw new Error('Expected playlistId');
  var playlist = playlists[playlistId];
  if (!playlist) throw new Error('Unknown playlist ' + playlistId);
  return playlist;
};

var importPlaylist = function importPlaylist(state, _ref4) {
  var playlist = _ref4.playlist,
      playlistId = _ref4.playlist.playlistId;
  return state.playlists[playlistId] == null ? assign(state, { playlists: assoc(state.playlists, playlistId, playlist) }) : state;
};

var assignPlayback = function assignPlayback(state, _ref5) {
  var playlistId = _ref5.playlist.playlistId,
      streamId = _ref5.streamId;

  var currentTrack = state.playlists[playlistId].tracks.find(function (tr) {
    return tr.streamId === streamId;
  });
  var hasNext = currentTrack && currentTrack.next !== null;
  var hasPrev = currentTrack && currentTrack.prev !== null;

  return assign(state, {
    playback: assign(state.playback, {
      pending: true,
      active: true,
      playlistId: playlistId,
      streamId: streamId,
      hasNext: hasNext,
      hasPrev: hasPrev
    })
  });
};

var clearPlaybackPending = function clearPlaybackPending(state) {
  return assign(state, { playback: assign(state.playback, { pending: false }) });
};

var togglePlaystate = function togglePlaystate(state) {
  return assign(state, { playback: assign(state.playback, { active: !state.playback.active }) });
};

var nextTrack$$1 = function nextTrack$$1(_ref6, currentTrack) {
  var playback = _ref6.playback,
      state = objectWithoutProperties(_ref6, ['playback']);

  if (!playback.hasNext) {
    throw new Error('Attempted to dispatch forward track to the store, ' + 'but there is no next track available for play. ' + 'Use the `hasNext` property to disable that action instead.');
  }

  return assign(state, {
    playback: assign(playback, {
      pending: true,
      streamId: currentTrack.next,
      hasPrev: true,
      hasNext: getPlaylist(state.playlists, playback.playlistId).tracks.find(function (_ref7) {
        var streamId = _ref7.streamId;
        return streamId === currentTrack.next;
      }).next !== null
    })
  });
};

var previousTrack$$1 = function previousTrack$$1(_ref8, currentTrack) {
  var playback = _ref8.playback,
      state = objectWithoutProperties(_ref8, ['playback']);

  if (!playback.hasPrev) {
    throw new Error('Attempted to dispatch previous track to the store, ' + 'but there is no previous track available for play. ' + 'Use the `hasPrev` property to disable that action instead.');
  }

  return assign(state, {
    playback: assign(playback, {
      pending: true,
      streamId: currentTrack.prev,
      hasNext: true,
      hasPrev: getPlaylist(state.playlists, playback.playlistId).tracks.find(function (_ref9) {
        var streamId = _ref9.streamId;
        return streamId === currentTrack.prev;
      }).prev !== null
    })
  });
};

var streamifyTracks = function streamifyTracks(tracks) {
  return assignNextProps(tracks.filter(function (track) {
    return track != null;
  }).map(streamToTrack));
};

var initialLoad$$1 = function initialLoad$$1(state, _ref10) {
  var tracks = _ref10.tracks,
      playback = _ref10.playback;
  return assign(state, {
    playlists: {
      page: { displayName: 'Suggested tracks', tracks: streamifyTracks(tracks) },
      empty: { displayName: '', tracks: [] },
      embed: { displayName: '', tracks: [] }
    },
    playback: assign(state.playback, playback)
  });
};

var reducers$5 = (_reducers$5 = {}, defineProperty(_reducers$5, INITIAL_LOAD, initialLoad$$1), defineProperty(_reducers$5, LOADED_TRACK, clearPlaybackPending), defineProperty(_reducers$5, TOGGLE_PLAYBACK, togglePlaystate), defineProperty(_reducers$5, PLAY_TRACK, function (state, action) {
  return assignPlayback(importPlaylist(state, action), action);
}), defineProperty(_reducers$5, NEXT_TRACK, function (state) {
  return nextTrack$$1(state, getPlaylist(state.playlists, state.playback.playlistId).tracks.find(function (_ref11) {
    var streamId = _ref11.streamId;
    return streamId === state.playback.streamId;
  }));
}), defineProperty(_reducers$5, PREVIOUS_TRACK, function (state) {
  return previousTrack$$1(state, getPlaylist(state.playlists, state.playback.playlistId).tracks.find(function (_ref12) {
    var streamId = _ref12.streamId;
    return streamId === state.playback.streamId;
  }));
}), _reducers$5);

var streamPlayer = createReducer(reducers$5, defaultState$6);

var defaultState$$1 = {
  config: defaultState$1,
  form: defaultState$2,
  graphql: defaultState$3,
  modals: defaultState$4,
  page: defaultState$5,
  streamPlayer: defaultState$6
};

var mainReducer = redux.combineReducers({
  config: config,
  form: form,
  graphql: graphql,
  modals: modals,
  page: page,
  streamPlayer: streamPlayer
});

var reducer = (function (state, action) {
  if (action.type === 'RESET') return defaultState$$1;
  return mainReducer(state, action);
});

/* eslint-disable no-param-reassign */
Bugsnag$1.apiKey = process.env.BUGSNAG_API_KEY;
Bugsnag$1.context = window.location.toString();
Bugsnag$1.enableAutoBreadcrumbs();
Bugsnag$1.releaseStage = process.env.TARGET_ENV || 'local';

var lastState = null;

var badKey = /card/i;

var redact = function redact(val) {
  return val ? '*** REDACTED ' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)).toUpperCase() + ' ***' : null;
};

var sanitise = function sanitise(val) {
  if (Array.isArray(val)) return val.map(sanitise);
  if (val == null || (typeof val === 'undefined' ? 'undefined' : _typeof(val)) !== 'object') return val;

  var filtered = mapObj(val, function (value, key) {
    return badKey.test(key) ? redact(value) : sanitise(value);
  });

  if (typeof filtered.name === 'string' && badKey.test(filtered.name) && filtered.value) {
    filtered.value = redact(filtered.value);
  }

  return filtered;
};

Bugsnag$1.beforeNotify = function (payload, metadata) {
  var json = JSON.stringify({ payload: payload, metadata: metadata });

  metadata.store = mapObj(sanitise(lastState || {}), function (val) {
    return JSON.stringify(val, null, 2);
  });
  metadata.groupingHash = payload.stacktrace;
  metadata.raw = json;

  return metadata;
};

window.addEventListener('unhandledrejection', function (_ref) {
  var reason = _ref.reason;
  return Bugsnag$1.notifyException(reason);
});

var navigationListener = function navigationListener() {
  Bugsnag$1.context = window.location.toString();
};

var middleware = function middleware() {
  return function (next) {
    return function (action) {
      if ((typeof action === 'undefined' ? 'undefined' : _typeof(action)) === 'object' && action.type) {
        Bugsnag$1.leaveBreadcrumb('Redux Action', mapObj(sanitise(action), function (val) {
          return JSON.stringify(val);
        }));
      }

      return next(action);
    };
  };
};

var subscribeStore = function subscribeStore(store) {
  return store.subscribe(function () {
    lastState = store.getState();
  });
};

var store = redux.createStore(reducer, defaultState$$1, redux.compose(redux.applyMiddleware(reduxThunk, middleware), window && window.devToolsExtension ? window.devToolsExtension() : function (f) {
  return f;
}));

subscribeStore(store);

/* eslint-disable no-use-before-define */

var dispatch = function dispatch(action) {
  return (
    // $FlowFixMe flow-typed redux types don't play nice with redux-thunk
    store.dispatch(action)
  );
};

var getState = function getState() {
  return store.getState();
};

// We're using event delegation - one listener on the top level element. So whenever we get a click,
// we need to walk up the DOM tree from our original target and check if it's inside a link
var findTarget = function findTarget(tagName, el) {
  if (el instanceof Element) {
    if (el.nodeName.toLocaleLowerCase() === tagName) return el;
    if (el.parentNode) return findTarget(tagName, el.parentNode);
  }

  return null;
};

var PROFILE_SLUG = /^\/([^/]+)(\/|$)/;

var getProfileSlug = function getProfileSlug(pathname) {
  var matches = pathname.match(PROFILE_SLUG);
  if (!matches) {
    return null;
  }
  return matches[1];
};

var originMismatches = function originMismatches(el, loc) {
  return el.protocol !== loc.protocol || el.host !== loc.host;
};
var profileMismatches = function profileMismatches(el, loc) {
  return getProfileSlug(el.pathname) !== getProfileSlug(loc.pathname);
};

var Navigation = function () {
  function Navigation() {
    var _this = this;

    classCallCheck(this, Navigation);

    this.handleLinkAction = function (event, el) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (originMismatches(el, window.location) || profileMismatches(el, window.location)) return;
      if (el.dataset.nohandle || el.target && el.target !== '_self') return;

      event.preventDefault();

      if (el.pathname === _this.history.location.pathname) return;

      _this.navigate(el.pathname);
    };

    this.history = createHistory();
    this.scrollPositions = {};
    this.navigationListeners = new Set();
    this.lastLocation = this.history.location;

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented) return;

      var el = findTarget('a', event.target);
      if (el instanceof HTMLAnchorElement) _this.handleLinkAction(event, el);
    });

    document.addEventListener('keyup', function (event) {
      if (event.defaultPrevented) return;

      var el = findTarget('a', event.target);
      if (event.keyCode === 13 && el instanceof HTMLAnchorElement) _this.handleLinkAction(event, el);
    });

    this.history.listen(function (location) {
      _this.scrollPositions[_this.lastLocation.key] = document.body.scrollTop;
      _this.lastLocation = location;
      _this.loadPage(location);

      // Notify navigation listeners
      _this.navigationListeners.forEach(function (f) {
        return f(_extends({}, location));
      });
    });
  }

  createClass(Navigation, [{
    key: 'loadPage',
    value: function loadPage(location) {
      var _this2 = this;

      return dispatch(navigate(location.pathname)).then(function () {
        document.body.scrollTop = _this2.scrollPositions[location.key] || 0;
      });
    }
  }, {
    key: 'onNavigate',
    value: function onNavigate(listener) {
      var _this3 = this;

      this.navigationListeners.add(listener);
      return function () {
        return _this3.navigationListeners.delete(listener);
      };
    }
  }, {
    key: 'navigate',
    value: function navigate(path) {
      var themePreview = getState().config.page.themePreview;

      var url = themePreview ? path + '?themePreview=' + themePreview : path;

      this.history.push(url);
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      return this.loadPage(this.history.location);
    }
  }]);
  return Navigation;
}();

var b64DecodeUnicode = function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).split('').map(function (x) {
    return '%' + x.charCodeAt(0).toString(16);
  }).join(''));
};

var parseProps = (function (encoded) {
  if (!encoded || encoded === '') return {};

  try {
    // I am so sorry:
    // https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem

    var props = JSON.parse(b64DecodeUnicode(encoded));
    return props && (typeof props === 'undefined' ? 'undefined' : _typeof(props)) === 'object' ? props : {};
  } catch (e) {
    Bugsnag.notifyException(e);

    return {};
  }
});

var replaceElement = function replaceElement(oldEl, newEl) {
  if (oldEl.parentNode) oldEl.parentNode.replaceChild(newEl, oldEl);
};

var detachElement = function detachElement(el) {
  if (el.parentNode) el.parentNode.removeChild(el);
};



var insertAfter = function insertAfter(reference, newEl) {
  if (reference.parentNode) {
    if (reference.nextSibling) {
      reference.parentNode.insertBefore(newEl, reference.nextSibling);
    } else {
      reference.parentNode.appendChild(newEl);
    }
  }
};

function BasketError(_ref) {
  var messageKey = _ref.messageKey,
      errors = _ref.errors;

  if (!errors.length) return null;

  return jsx('div', {
    className: 'FailureToReserveError'
  }, void 0, t('basket.error.' + messageKey), jsx('div', {
    className: 'FailureToReserveError-list'
  }, void 0, errors.map(function (error) {
    return jsx('div', {
      className: 'FailureToReserveError-error'
    }, error.id, error.name);
  })));
}

function FailureToReserveAlert(props) {
  var reservationErrors = props.reservationErrors,
      onDismiss = props.onDismiss;

  var _partition = partition(reservationErrors, function (_ref2) {
    var type = _ref2.type;
    return type === 'FAILURE_TO_RESERVE_ANY';
  }),
      _partition2 = slicedToArray(_partition, 2),
      any = _partition2[0],
      all = _partition2[1];

  return jsx('div', {
    className: 'FailureToReserveAlert'
  }, void 0, jsx(BasketError, {
    messageKey: 'FAILURE_TO_RESERVE_ANY',
    errors: any
  }), jsx(BasketError, {
    messageKey: 'FAILURE_TO_RESERVE_ALL',
    errors: all
  }), jsx(Button, {
    onClick: onDismiss
  }, void 0, t('alerts.buttons.okay')));
}

var idCounter = 0;
function nextId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'grapevine-';

  idCounter += 1;
  return '' + prefix + idCounter;
}

function attempt(fn) {
  return function () {
    try {
      fn.apply(undefined, arguments);
    } catch (e) {} // eslint-disable-line no-empty
  };
}

function pause$1(stream) {
  stream.paused = true;

  return stream;
}
/* eslint no-param-reassign: ["error", { "props": false }] */

/* eslint no-param-reassign: ["error", { "props": false }] */


function subscribe$1(stream, callback) {
  if (!stream.subscribers.includes(callback)) {
    stream.subscribers = stream.subscribers.concat(callback);
  }

  if (stream.options.autoPause && stream.subscribers.length === 1) {
    stream.unpause();
  }

  return function () {
    stream.subscribers = stream.subscribers.filter(function (c) {
      return c !== callback;
    });

    if (stream.options.autoPause && stream.subscribers.length === 0) {
      pause$1(stream);
    }
  };
}

function filter$1(source, filterFn) {
  var filteredStream = track$2();

  subscribe$1(source, function (message) {
    return filterFn(message) && filteredStream.push(message);
  });

  return filteredStream;
}

function truncate$1(stream) {
  stream.messages = [];

  return stream;
}
/* eslint no-param-reassign: ["error", { "props": false }] */

function transmit(receivers, messages) {
  messages.forEach(function (message) {
    return receivers.forEach(attempt(function (cb) {
      return cb(message);
    }));
  });
}

function flush$1(stream) {
  if (stream.paused) {
    return stream;
  }

  var messages = stream.messages.slice(0, stream.messages.length);
  var subscribers = stream.subscribers.slice(0);

  truncate$1(stream);

  if (messages.length > 0 && subscribers.length > 0) {
    if (stream.options.async) {
      setTimeout(function () {
        return transmit(subscribers, messages);
      }, stream.options.delay);
    } else {
      transmit(subscribers, messages);
    }
  }

  return stream;
}

var push$1 = (function (stream, message) {
  stream.messages.push(message);

  return flush$1(stream);
});

function map$1(source, mapFn) {
  var mappedStream = track$2();

  subscribe$1(source, function (message) {
    return push$1(mappedStream, mapFn(message));
  });

  return mappedStream;
}

function merge$1(sources) {
  var combined = track$2();

  sources.forEach(function (s) {
    return subscribe$1(s, push$1.bind(null, combined));
  });

  return combined;
}

var dedupeDefault = function dedupeDefault(next, prev) {
  return next !== prev;
};

function skipDuplicates$1(stream, initialValue) {
  var dedupeFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : dedupeDefault;

  var prev = initialValue;

  var filteredStream = filter$1(stream, function (next) {
    if (dedupeFilter(next, prev)) {
      prev = next;
      return true;
    }

    return false;
  });

  return filteredStream;
}

function tap$2(stream, fn) {
  subscribe$1(stream, attempt(fn));

  return stream;
}

/* eslint no-param-reassign: ["error", { "props": false }] */
function unpauseStream(stream) {
  stream.paused = false;

  return stream;
}

var _unpause = compose$1(flush$1, unpauseStream);

var defaultOptions = {
  autoPause: false,
  paused: false,
  async: false,
  delay: 0
};

var GrapevineStream = function () {
  function GrapevineStream() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref$paused = _ref.paused,
        paused = _ref$paused === undefined ? false : _ref$paused,
        options = objectWithoutProperties(_ref, ['paused']);
    classCallCheck(this, GrapevineStream);
    this.id = nextId();
    this.messages = [];
    this.subscribers = [];

    this.paused = paused;
    this.options = _extends({}, defaultOptions, options);

    if (this.options.autoPause) {
      this.pause();
    }
  }

  createClass(GrapevineStream, [{
    key: 'filter',
    value: function filter(fn) {
      return filter$1(this, fn);
    }
  }, {
    key: 'flush',
    value: function flush() {
      return flush$1(this);
    }
  }, {
    key: 'map',
    value: function map(fn) {
      return map$1(this, fn);
    }
  }, {
    key: 'merge',
    value: function merge(mergeWith) {
      return merge$1([this].concat(mergeWith));
    }
  }, {
    key: 'pause',
    value: function pause() {
      return pause$1(this);
    }
  }, {
    key: 'push',
    value: function push(m) {
      return push$1(this, m);
    }
  }, {
    key: 'skipDuplicates',
    value: function skipDuplicates(initialValue, fn) {
      return skipDuplicates$1(this, initialValue, fn);
    }
  }, {
    key: 'subscribe',
    value: function subscribe(fn) {
      return subscribe$1(this, fn);
    }
  }, {
    key: 'tap',
    value: function tap(fn) {
      return tap$2(this, fn);
    }
  }, {
    key: 'truncate',
    value: function truncate() {
      return truncate$1(this);
    }
  }, {
    key: 'unpause',
    value: function unpause() {
      return _unpause(this);
    }
  }]);
  return GrapevineStream;
}();

var track$2 = function (options) {
  return new GrapevineStream(options);
};

var trackingEvents = {
  ADD_TO_BASKET: 'ADD_TO_BASKET',
  APPLY_TO_PLAY_SIGNUP: 'APPLY_TO_PLAY_SIGNUP',
  CHECKOUT: 'CHECKOUT',
  CONFIRM_LOCATION: 'CONFIRM_LOCATION',
  INITIATE_CHECKOUT: 'INITIATE_CHECKOUT',
  MAILING_LIST_SUBSCRIBE: 'MAILING_LIST_SUBSCRIBE',
  PAGE_VIEW: 'PAGE_VIEW',
  PERFORMANCE: 'PERFORMANCE',
  SOCIAL_SHARE: 'SOCIAL_SHARE',
  TIMING: 'TIMING',
  VIEW_EVENT_DETAIL: 'VIEW_EVENT_DETAIL',
  VIEW_PRODUCT_DETAIL: 'VIEW_PRODUCT_DETAIL'
};

var streamNames = {
  CHECKOUTS: 'CHECKOUTS',
  PAGE_VIEWS: 'PAGE_VIEWS',
  PERF_EVENTS: 'PERF_EVENTS',
  SOCIAL_SHARES: 'SOCIAL_SHARES',
  TIMING_EVENTS: 'TIMING_EVENTS',
  TRACKING_EVENTS: 'TRACKING_EVENTS'
};

var _CHECKOUTS$PAGE_VIEWS;

var CHECKOUT = trackingEvents.CHECKOUT;
var SOCIAL_SHARE = trackingEvents.SOCIAL_SHARE;
var PAGE_VIEW = trackingEvents.PAGE_VIEW;
var PERFORMANCE = trackingEvents.PERFORMANCE;
var TIMING = trackingEvents.TIMING;
var CHECKOUTS = streamNames.CHECKOUTS;
var PAGE_VIEWS = streamNames.PAGE_VIEWS;
var PERF_EVENTS = streamNames.PERF_EVENTS;
var SOCIAL_SHARES = streamNames.SOCIAL_SHARES;
var TIMING_EVENTS = streamNames.TIMING_EVENTS;
var TRACKING_EVENTS = streamNames.TRACKING_EVENTS;


var eventFilter = function eventFilter(search) {
  return function (_ref) {
    var name = _ref.name;
    return name === search;
  };
};

var notEmpty = function notEmpty(v) {
  return v != null && v !== '';
};

var hasFilledProps = function hasFilledProps(propPaths) {
  var ps = propPaths.map(function (path) {
    return path.indexOf('.') === -1 ? getProp(path) : path.split('.').reduce(function (f, m) {
      return pipe(f, getProp(m));
    }, identity);
  });

  return function (v) {
    return v != null && ps.every(function (p) {
      return p(v) != null;
    });
  };
};

var allEvents = track$2({ async: true, autoPause: true });

var timingEvents = allEvents.filter(eventFilter(TIMING));

var perfEvents = allEvents.filter(eventFilter(PERFORMANCE));

var checkouts = allEvents.filter(eventFilter(CHECKOUT));

var pageViews = allEvents.filter(eventFilter(PAGE_VIEW)).map(function (_ref2) {
  var href = _ref2.href,
      pathname = _ref2.pathname;
  return pathname || href;
}).filter(notEmpty).skipDuplicates(window.location.pathname);

var socialShares = allEvents.filter(eventFilter(SOCIAL_SHARE)).filter(hasFilledProps(['action', 'network', 'url']));

var track$1 = push$1.bind(null, allEvents);
var tracker = function tracker(staticEvent) {
  return track$1.bind(null, staticEvent);
};

var withTracking = function withTracking(Child, tracking) {
  return function (_React$Component) {
    inherits(_class, _React$Component);

    function _class() {
      classCallCheck(this, _class);
      return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        tracking(this.props);
      }
    }, {
      key: 'render',
      value: function render() {
        return React.createElement(Child, this.props);
      }
    }]);
    return _class;
  }(React.Component);
};

var grapevineStreams = (_CHECKOUTS$PAGE_VIEWS = {}, defineProperty(_CHECKOUTS$PAGE_VIEWS, CHECKOUTS, checkouts), defineProperty(_CHECKOUTS$PAGE_VIEWS, PAGE_VIEWS, pageViews), defineProperty(_CHECKOUTS$PAGE_VIEWS, PERF_EVENTS, perfEvents), defineProperty(_CHECKOUTS$PAGE_VIEWS, SOCIAL_SHARES, socialShares), defineProperty(_CHECKOUTS$PAGE_VIEWS, TIMING_EVENTS, timingEvents), defineProperty(_CHECKOUTS$PAGE_VIEWS, TRACKING_EVENTS, allEvents), _CHECKOUTS$PAGE_VIEWS);

var AlterQuantityInBasketMutation = function (_Mutation) {
  inherits(AlterQuantityInBasketMutation, _Mutation);

  function AlterQuantityInBasketMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AlterQuantityInBasketMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AlterQuantityInBasketMutation.__proto__ || Object.getPrototypeOf(AlterQuantityInBasketMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'AlterQuantityInBasket', _this.mutation = 'alterQuantityInBasket', _this.query = 'reservationErrors{id,type,name,offender{name}},outcome', _this.invalidateQueries = function (_, queryIds) {
      return [].concat(toConsumableArray(queryIds.filter(match(/^basket\./))), ['productPurchasables.' + _this.input.productId]);
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _this.after = function (payload, dispatch) {
      var reservationErrors = payload.reservationErrors,
          outcome = payload.outcome;

      if (reservationErrors) {
        dispatch(showModal$1(FailureToReserveAlert, { reservationErrors: reservationErrors }));
      } else if (outcome !== 'SUCCESSFUL') {
        dispatch(showModal$1(SimpleModal, {
          title: t('alerts.titles.error'),
          content: t('basket.error.reservationFailed')
        }));
      }

      var event = _extends({ purchasables: _this.input.purchasables }, payload);
      track$1({ name: trackingEvents.ADD_TO_BASKET, event: event });
    }, _this.error = function (err, dispatch) {
      return dispatch(showModal$1(SimpleModal, {
        title: t('alerts.titles.error'),
        content: t('basket.error.reservationFailed')
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return AlterQuantityInBasketMutation;
}(Mutation);

var BasketPurchasableQuantitiesQuery = function (_Query) {
  inherits(BasketPurchasableQuantitiesQuery, _Query);

  function BasketPurchasableQuantitiesQuery() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, BasketPurchasableQuantitiesQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = BasketPurchasableQuantitiesQuery.__proto__ || Object.getPrototypeOf(BasketPurchasableQuantitiesQuery)).call.apply(_ref, [this].concat(args))), _this), _this.query = 'viewer{basket{result{lines{id,quantity,items{result{purchasable{id}}}}}}}', _this.resolve = memoize(function (response) {
      var pairs = flatMap(response.basket.result.lines || [], function (_ref2) {
        var quantity = _ref2.quantity,
            items = _ref2.items;
        return items.result.map(function (_ref3) {
          var purchasable = _ref3.purchasable;
          return [purchasable.id, quantity];
        });
      });

      return pairs.reduce(function (quantities, _ref4) {
        var _ref5 = slicedToArray(_ref4, 2),
            id = _ref5[0],
            quantity = _ref5[1];

        return Object.assign(quantities, defineProperty({}, id, (quantities[id] || 0) + quantity));
      }, {});
    }), _temp), possibleConstructorReturn(_this, _ret);
  }

  return BasketPurchasableQuantitiesQuery;
}(Query);

var basketPurchasableQuantitiesQuery = new BasketPurchasableQuantitiesQuery('basket.purchasableQuantities');

var getDisplayName = (function (component) {
  return component.displayName || component.name || 'Component';
});

var setName = function setName(name, thang) {
  thang.displayName = name; // eslint-disable-line
  return thang;
};

var createHOC = (function (name, createClass
// $FlowFixMe erggggghh
) {
  return function (component, options) {
    return setName(name + '(' + getDisplayName(component) + ')', createClass(component, options));
  };
});

var encodePart = function encodePart(key, value) {
  return value != null ? encodeURIComponent(key) + '=' + encodeURIComponent(value) : null;
};

var encodeParts = function encodeParts(obj) {
  return Object.keys(obj).sort().map(function (key) {
    return encodePart(key, obj[key]);
  });
};

var assembleQueryString = (function (obj) {
  return compact(encodeParts(obj)).join('&');
});

/* eslint-disable react/no-danger */
/* eslint-disable no-underscore-dangle */

var getIdentifier = function getIdentifier(props) {
  var _props$query = props.query,
      query = _props$query === undefined ? {} : _props$query,
      name = props.name;


  var queryString = assembleQueryString(query);

  return queryString ? name + '?' + queryString : name;
};

var Partial = function (_React$Component) {
  inherits(Partial, _React$Component);

  function Partial() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Partial);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Partial.__proto__ || Object.getPrototypeOf(Partial)).call.apply(_ref, [this].concat(args))), _this), _this.state = { content: { __html: '' } }, _this.markedReady = false, _this.setRef = function (element) {
      _this.element = element;
    }, _temp), possibleConstructorReturn(_this, _ret);
  } // eslint-disable-line react/sort-comp


  createClass(Partial, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.handleReady(this.props);
      this.fetchContentIfNeeded(this.props);
      this.setContent(this.props.content);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.interactions = new Interactions(store, this.element);
      this.interactions.attach();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.markedReady) this.handleReady(nextProps);

      var idChanged = getIdentifier(this.props) !== getIdentifier(nextProps);

      if (idChanged || this.props.ready !== nextProps.ready) {
        this.fetchContentIfNeeded(nextProps);
      }
      if (this.props.content !== nextProps.content) this.setContent(nextProps.content);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (this.state.content.__html !== nextState.content.__html) {
        this.interactions.detach();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.content.__html !== this.state.content.__html) {
        this.interactions.attach();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.interactions.teardown();
    }
  }, {
    key: 'fetchContentIfNeeded',
    value: function fetchContentIfNeeded(props) {
      var ready = props.ready,
          name = props.name,
          query = props.query,
          onRequestFetch = props.onRequestFetch;

      if (!ready) onRequestFetch(name, getIdentifier(props), query);
    }
  }, {
    key: 'setContent',
    value: function setContent(content) {
      this.setState({ content: { __html: content || '' } });
    }
  }, {
    key: 'handleReady',
    value: function handleReady(props) {
      if (!this.markedReady && props.ready) {
        this.markedReady = true;
        if (this.props.onReady) this.props.onReady();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = cx('Partial', {
        Partial_ready: this.props.ready,
        Partial_fetching: this.props.fetching
      });

      return React.createElement('div', {
        ref: this.setRef,
        dangerouslySetInnerHTML: this.state.content,
        className: className
      });
    }
  }]);
  return Partial;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  var partial = state.page.partials[getIdentifier(props)];
  if (!partial) return { content: null, ready: false, fetching: false };
  return partial;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch$$1) {
  return {
    onRequestFetch: function onRequestFetch(name, identifier, query) {
      return dispatch$$1(fetchPartial(name, identifier, query));
    }
  };
};

var Partial$1 = reactRedux.connect(mapStateToProps, mapDispatchToProps)(Partial);

function PartialModal(_ref) {
  var name = _ref.name,
      query = _ref.query;

  return jsx(Partial$1, {
    name: name,
    query: query
  });
}

var purchasableTypes = new Set(['Ticket', 'Digital', 'Subscription']);

var ProductPurchasablesQuery = function (_Query) {
  inherits(ProductPurchasablesQuery, _Query);

  function ProductPurchasablesQuery() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ProductPurchasablesQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ProductPurchasablesQuery.__proto__ || Object.getPrototypeOf(ProductPurchasablesQuery)).call.apply(_ref, [this].concat(args))), _this), _this.query = 'node(id:$productId){type:__typename,...on Purchasable{type:__typename,id,name,maxPerTransaction,stock{result{status{result,error},remaining{result,error}},error}},...on Varianted{variant{type:__typename,id,name,maxPerTransaction,stock{result{status{result,error},remaining{result,error}},error},options{name,value}},variants{type:__typename,id,name,maxPerTransaction,stock{result{status{result,error},remaining{result,error}},error},options{name,value}}}}', _this.resolve = memoize(function (response) {
      if (!response) return null;
      if (response.variant) return [response.variant];
      if (response.variants) return response.variants;
      if (purchasableTypes.has(response.type)) return [response];
      return null;
    }), _temp), possibleConstructorReturn(_this, _ret);
  }

  return ProductPurchasablesQuery;
}(Query);

var productPurchasablesQuery = memoize(function (productId) {
  return new ProductPurchasablesQuery('productPurchasables.' + productId, { productId: productId });
});

var readyOnGraphData = createHOC('readyOnGraphData', function (Component) {
  return function (_React$Component) {
    inherits(_class2, _React$Component);

    function _class2() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.handleReadyChange = function (ready) {
        if (ready) _this.props.onReady();
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(_class2, [{
      key: 'render',
      value: function render() {
        return React.createElement(Component, _extends({}, omit(this.props, ['onReady']), { onReadyChange: this.handleReadyChange }));
      }
    }]);
    return _class2;
  }(React.Component);
});

// Takes an object type with queries as values, returns an object type with the results of those
// queries as values


function withQueries(component, rawQueries) {
  var requestedQueries = entries(rawQueries);

  var resolveQuery = function resolveQuery(query, props) {
    return typeof query === 'function' ? query(props) : query;
  };

  var mapStateToProps = function mapStateToProps(state, props) {
    var storeQueries = requestedQueries.map(function (_ref) {
      var _ref2 = slicedToArray(_ref, 2),
          prop = _ref2[0],
          rawQuery = _ref2[1];

      return [prop, resolveQuery(rawQuery, props)];
    }).map(function (_ref3) {
      var _ref4 = slicedToArray(_ref3, 2),
          prop = _ref4[0],
          query = _ref4[1];

      return [prop, state.graphql.queries[query.id], query];
    });

    var queryDataReady = storeQueries.every(function (_ref5) {
      var _ref6 = slicedToArray(_ref5, 2),
          query = _ref6[1];

      return query && (query.hasData || query.state === 'error');
    });

    // $FlowFixMe this bit does the mapping described by $Result, but flow doesn't understand
    return storeQueries.reduce(function (qProps, _ref7) {
      var _ref8 = slicedToArray(_ref7, 3),
          prop = _ref8[0],
          storeQuery = _ref8[1],
          originalQuery = _ref8[2];

      return Object.assign(qProps, defineProperty({}, prop, storeQuery && storeQuery.hasData ? originalQuery.resolve(storeQuery.response) : null));
    }, { queryDataReady: queryDataReady });
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
    return {
      onComponentWillMount: function onComponentWillMount() {
        return dispatch(addQueries(values(rawQueries).map(function (query) {
          return resolveQuery(query, props);
        })));
      }
    };
  };

  // $FlowFixMe pfffttt it's probably fine
  var connecter = reactRedux.connect(mapStateToProps, mapDispatchToProps);

  var wrapped = function (_React$Component) {
    inherits(wrapped, _React$Component);

    function wrapped() {
      classCallCheck(this, wrapped);
      return possibleConstructorReturn(this, (wrapped.__proto__ || Object.getPrototypeOf(wrapped)).apply(this, arguments));
    }

    createClass(wrapped, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.props.onComponentWillMount();
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.onReadyChange) {
          this.props.onReadyChange(this.props.queryDataReady);
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.onReadyChange && prevProps.queryDataReady !== this.props.queryDataReady) {
          this.props.onReadyChange(this.props.queryDataReady);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return this.props.queryDataReady ? React.createElement(component, this.props) : null;
      }
    }]);
    return wrapped;
  }(React.Component);

  return connecter(wrapped);
}

var withQueries$1 = createHOC('WithQueries', withQueries);

function addExtraActions(Component) {
  var wrapped = function (_React$Component) {
    inherits(wrapped, _React$Component);

    function wrapped() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, wrapped);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = wrapped.__proto__ || Object.getPrototypeOf(wrapped)).call.apply(_ref, [this].concat(args))), _this), _this.state = { submitting: false }, _this.onClick = function () {
        var _this$props = _this.props,
            child = _this$props.context.child,
            purchasables = _this$props.purchasables;

        if (!child) throw new Error('Missing context.child!');
        var isComplexMerch = purchasables.length > 1;

        if (isComplexMerch) {
          _this.props.onComplexClick(child.props.productUuid);
        } else {
          _this.addExtraToBasket();
        }
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(wrapped, [{
      key: 'addExtraToBasket',
      value: function addExtraToBasket() {
        // $FlowFixMe sorry, but this.props.context is totally fine to use here
        var _props = this.props,
            currency = _props.currency,
            context = _props.context;

        if (!context.child) throw new Error('Missing context.child!');

        this.setState({ submitting: true });

        var purchasables = context.props.purchasables,
            _context$child$props = context.child.props,
            itemId = _context$child$props.itemId,
            productId = _context$child$props.productId;

        var item = purchasables.find(function (_ref2) {
          var purchasableId = _ref2.purchasableId;
          return purchasableId === itemId;
        });

        this.props.onClick({
          delta: 1,
          productId: productId || itemId,
          purchasables: [{
            currency: currency,
            id: item.purchasableId,
            offeredCents: item.offeredCents
          }]
        });
      }
    }, {
      key: 'isHidden',
      value: function isHidden() {
        var purchasables = this.props.purchasables;

        if (!purchasables) return true;

        return purchasables.length === 1 && purchasables[0].type === 'Digital';
      }
    }, {
      key: 'isValid',
      value: function isValid() {
        var _props2 = this.props,
            purchasables = _props2.purchasables,
            quantities = _props2.quantities;

        if (!purchasables) return false;

        return Math.max.apply(Math, toConsumableArray(purchasables.map(function (p) {
          return p.maxPerTransaction - (quantities[p.id] || 0);
        }))) > 0;
      }
    }, {
      key: 'render',
      value: function render() {
        var hijackedProps = _extends({}, this.props, this.state, {
          hidden: this.isHidden(),
          onClick: this.onClick,
          valid: this.isValid()
        });

        return React.createElement(Component, hijackedProps);
      }
    }]);
    return wrapped;
  }(React.Component);

  var mapStateToProps = function mapStateToProps(state) {
    return {
      currency: state.config.viewer.currency
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      onComplexClick: function onComplexClick(productId) {
        return dispatch(showModal$1(PartialModal, {
          name: 'add_extra_complex',
          query: { productId: productId, restrictionAllowed: true }
        }));
      },
      onClick: function onClick(payload) {
        return dispatch(fireMutation(new AlterQuantityInBasketMutation(payload)));
      }
    };
  };

  var queries = {
    purchasables: function purchasables(_ref3) {
      var _ref3$context$child$p = _ref3.context.child.props,
          itemId = _ref3$context$child$p.itemId,
          productId = _ref3$context$child$p.productId;
      return productPurchasablesQuery(productId || itemId);
    },
    quantities: basketPurchasableQuantitiesQuery
  };

  return readyOnGraphData(withQueries$1(reactRedux.connect(mapStateToProps, mapDispatchToProps)(wrapped), queries));
}

var addExtraActions$1 = createHOC('AddExtraProps', addExtraActions);

var validationTimeout = 50;
var ignoreProps = ['formState', 'lastInitialValues', 'onInitialValues', 'onFormSubmit', 'onValidationComplete', 'onValidationRequest', 'validationRequest'];

var getValues = function getValues(form, fields) {
  return fromPairs(fields.map(function (field) {
    return [field, form.fields[field] && form.fields[field].dirty ? form.fields[field].value : null];
  }));
};

function ImplicitForm(Component, options) {
  var Wrapped = function (_React$Component) {
    inherits(Wrapped, _React$Component);

    function Wrapped() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, Wrapped);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Wrapped.__proto__ || Object.getPrototypeOf(Wrapped)).call.apply(_ref, [this].concat(args))), _this), _this.requestValidation = function () {
        clearTimeout(_this.props.validationRequest);

        _this.props.onValidationRequest(_this.form.id, setTimeout(_this.validate, validationTimeout));
      }, _this.validate = function () {
        var validate = options.validate;
        if (!validate) return [];

        var errors = compact(validate(_this.props.formState, _this.props));
        _this.props.onValidationComplete(_this.form.id, errors);
        return errors;
      }, _this.submit = function () {
        var submit$$1 = options.submit;
        if (!submit$$1) return;

        var errors = _this.validate();
        if (errors.length) return;

        var formId = _this.form.id;

        _this.props.onFormSubmit(formId, submit$$1, _this.props).then(function () {
          return _this.requestValidation();
        }).catch(function (error) {
          _this.requestValidation();
          return Promise.reject(error);
        });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(Wrapped, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.updateFormId(this.props);
        this.updateInitialValues(this.props);

        if (options.revalidateProps) {
          this.lastRevalidateProps = pick(this.props, options.revalidateProps);
        }

        if (options.submitOnChange) {
          this.lastSubmitOnChangeValues = getValues(this.props.formState, options.submitOnChange);
        }

        if (!this.props.formState.hasValidated) this.validate();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        this.updateFormId(nextProps);
        this.updateInitialValues(nextProps);

        if (options.revalidateProps) {
          var _revalidateProps = pick(nextProps, options.revalidateProps);
          if (!shallowEqual(_revalidateProps, this.lastRevalidateProps)) this.requestValidation();
          this.lastRevalidateProps = _revalidateProps;
        }

        if (options.submitOnChange) {
          var submitOnChangeValues = getValues(nextProps.formState, options.submitOnChange);
          if (!shallowEqual(submitOnChangeValues, this.lastSubmitOnChangeValues)) {
            setTimeout(function () {
              return _this2.submit();
            });
          }
          this.lastSubmitOnChangeValues = submitOnChangeValues;
        }
      }
    }, {
      key: 'updateFormId',
      value: function updateFormId(props) {
        var id = options.formIdentifier(props);

        if (!this.form || this.form.id !== id) {
          this.form = {
            id: id,
            validate: this.requestValidation,
            submit: this.submit
          };
        }
      }
    }, {
      key: 'updateInitialValues',
      value: function updateInitialValues(props) {
        var initialValues$$1 = options.initialValues ? options.initialValues(props) : null;

        if (!initialValues$$1) return;

        if (!shallowEqual(initialValues$$1, props.lastInitialValues)) {
          this.props.onInitialValues(this.form.id, initialValues$$1);
          this.requestValidation();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var props = omit(this.props, ignoreProps);

        return React.createElement(Component, _extends({}, props, { form: this.form }));
      }
    }]);
    return Wrapped;
  }(React.Component);

  var mapStateToProps = function mapStateToProps(state, props) {
    var formId = options.formIdentifier(props);
    var form = state.form[formId];

    return {
      lastInitialValues: form && form.lastInitialValues || {},
      validationRequest: form && form.validationRequest,
      formState: form || defaultForm(formId)
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      onInitialValues: function onInitialValues(form, values$$1) {
        return dispatch(initialValues$1(form, values$$1));
      },

      onValidationRequest: function onValidationRequest(form, requestId) {
        return dispatch(validationRequest(form, requestId));
      },

      onValidationComplete: function onValidationComplete(form, errors) {
        return dispatch(validationComplete(form, errors));
      },

      onFormSubmit: function onFormSubmit(form, submit$$1, props) {
        return dispatch(submit$1(form, submit$$1, props));
      }
    };
  };

  return reactRedux.connect(mapStateToProps, mapDispatchToProps)(Wrapped);
}

var implicitForm = createHOC('ImplicitForm', ImplicitForm);

var validate$1 = function validate$1(value, form, fieldName, _ref) {
  var _ref2 = toArray(_ref),
      validation = _ref2[0],
      validations = _ref2.slice(1);

  if (!validation) {
    return null;
  }

  return validation(value, form, fieldName) || validate$1(value, form, fieldName, validations);
};


var field = function field(form, fieldName, validations) {
  var formField = form.fields[fieldName];
  var value = formField && formField.value;
  var error = validate$1(value, form, fieldName, validations);

  if (!error) {
    return null;
  }

  return _extends({ field: fieldName }, error);
};

var when = function when(predicate, validations) {
  return predicate ? validations() : [];
};

var required = function required(value) {
  return value == null || typeof value === 'string' && value.trim() === '' ? { type: 'required' } : null;
};

var accepted = function accepted(value) {
  return value !== true ? { type: 'accepted' } : null;
};

var email = function email(value) {
  return typeof value === 'string' && /.+@.+/.test(value) ? null : { type: 'email' };
};

var checkAsNumber = function checkAsNumber(value, check) {
  var n = parseFloat(value);
  if (isNaN(n)) return { type: 'not a number' };
  return check(n);
};

var minimum = function minimum(amount) {
  return function (value) {
    return checkAsNumber(value, function (n) {
      return n < amount ? { type: 'minimum' } : null;
    });
  };
};

var maximum = function maximum(amount) {
  return function (value) {
    return checkAsNumber(value, function (n) {
      return n > amount ? { type: 'maximum' } : null;
    });
  };
};

var INITIAL_VALUE = '_INITIAL VALUE_';

var STOCK_AVAILABLE = 'available';

var stock = 'stock{result{status{result,error},remaining{result,error}},error}';

var purchasable$1 = 'id,name,maxPerTransaction,stock{result{status{result,error},remaining{result,error}},error}';

var event = 'event{error,result{doorsOpen,timezoneOffset,name,performances{name},venue{name,address{city}}}}';

var options$1 = 'options{name,values}';

var variant$1 = 'id,name,maxPerTransaction,stock{result{status{result,error},remaining{result,error}},error},options{name,value}';

var price$1 = 'amount{currency,cents}';

var getVariants = function getVariants(product) {
  // eslint-disable-line
  if (product.variant) return [product.variant];
  if (product.variants) return product.variants;
  return [product];
};

var getOptions = function getOptions(product) {
  // eslint-disable-line
  if (!product.options) return null;
  return fromPairs(product.options.map(function (_ref) {
    var name = _ref.name,
        values$$1 = _ref.values;
    return [name, values$$1];
  }));
};

var BundleGroupQuery = function (_Query) {
  inherits(BundleGroupQuery, _Query);

  function BundleGroupQuery() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, BundleGroupQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = BundleGroupQuery.__proto__ || Object.getPrototypeOf(BundleGroupQuery)).call.apply(_ref2, [this].concat(args))), _this), _this.query = '\n    node (id: $bundleId) {\n      ...on Bundle {\n        productGroups {\n          id\n          name\n          discount\n          products {\n            error\n            result {\n              __typename\n              id\n              name\n              ' + stock + '\n              price (ignoreSubscription: $ignoreSubscription) {\n                __typename\n                ...on FreePrice { ' + price$1 + ' }\n                ...on FixedPrice { ' + price$1 + ' }\n              }\n              ...on Purchasable { ' + purchasable$1 + ' }\n              ...on Varianted {\n                variant { ' + variant$1 + ' }\n                variants { ' + variant$1 + ' }\n              }\n              ...on Experience { ' + options$1 + ' }\n              ...on Merch { ' + options$1 + ' }\n              ...on Pod { ' + options$1 + ' }\n              ...on Ticket {\n                ' + event + '\n                serviceCharge {\n                  cents\n                  currency\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ', _this.resolve = memoize(function (response) {
      return fromPairs(response.productGroups.map(function (group) {
        return [group.id, _extends({}, group, {
          products: group.products.result.map(function (product) {
            return {
              type: product.__typename, // eslint-disable-line
              id: product.id,
              name: product.name,
              price: product.price.amount,
              options: getOptions(product),
              variants: getVariants(product),
              event: product.event,
              stock: product.stock,
              serviceCharge: product.serviceCharge || null
            };
          })
        })];
      }));
    }), _temp), possibleConstructorReturn(_this, _ret);
  }

  return BundleGroupQuery;
}(Query);

var bundleGroupsQuery = memoize(function (bundleId) {
  return new BundleGroupQuery('bundleGroups.' + bundleId, { bundleId: bundleId, ignoreSubscription: true });
});

var getFormState = function getFormState(state, _ref) {
  var form = _ref.form;
  return state.form[typeof form === 'string' ? form : form.id];
};

var makeGetFormField = function makeGetFormField() {
  return reselect.createSelector(getFormState, function (_, _ref2) {
    var name = _ref2.name;
    return name;
  }, function (form, name) {
    return form && form.fields[name];
  });
};

var matchOptions = function matchOptions(selections) {
  return function (purchasable) {
    if (!purchasable.options) return false;
    var options = purchasable.options;


    return options.every(function (_ref) {
      var name = _ref.name,
          value = _ref.value;
      return selections[name] === value;
    });
  };
};

var purchasablesFromProps = function purchasablesFromProps(_, _ref2) {
  var purchasables = _ref2.purchasables;
  return purchasables;
};

var makeGetSelections$1 = function makeGetSelections$1() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'options.';
  return reselect.createSelector(getFormState, function (form) {
    return form && fromPairs(entries(form.fields).filter(function (_ref3) {
      var _ref4 = slicedToArray(_ref3, 2),
          name = _ref4[0],
          value = _ref4[1].value;

      return name.startsWith(prefix) && value && value !== INITIAL_VALUE;
    }).map(function (_ref5) {
      var _ref6 = slicedToArray(_ref5, 2),
          name = _ref6[0],
          value = _ref6[1].value;

      return [name.substr(prefix.length), value];
    }));
  });
};

var makeGetSelectedVariant$1 = function makeGetSelectedVariant$1() {
  return reselect.createSelector(makeGetSelections$1(), purchasablesFromProps, function (selections, purchasables) {
    if (!selections || !purchasables) return null;
    if (purchasables.length === 1) return purchasables[0];
    return purchasables.find(matchOptions(selections));
  });
};

var getGroups = function getGroups(_ref) {
  var groups = _ref.groups;
  return groups;
};
var getProductId = function getProductId(_ref2) {
  var productId = _ref2.productId;
  return productId;
};

var makeGetProduct = function makeGetProduct() {
  return reselect.createSelector(getGroups, getProductId, function (groups, productId) {
    return flatMap(values(groups), function (group) {
      return group.products;
    }).find(function (product) {
      return product.id === productId;
    });
  });
};

var getOptionsKey = function getOptionsKey(_, _ref3) {
  var optionsKey = _ref3.optionsKey;
  return optionsKey;
};

var makeGetSelections$$1 = function makeGetSelections$$1() {
  return reselect.createSelector(getFormState, getOptionsKey, function (form, optionsKey) {
    return form && fromPairs(entries(form.fields).filter(function (_ref4) {
      var _ref5 = slicedToArray(_ref4, 2),
          name = _ref5[0],
          value = _ref5[1].value;

      return name.startsWith(optionsKey) && value && value !== INITIAL_VALUE;
    }).map(function (_ref6) {
      var _ref7 = slicedToArray(_ref6, 2),
          name = _ref7[0],
          value = _ref7[1].value;

      return [name.substr(optionsKey.length), value];
    }));
  });
};

var toLinePurchasable = function toLinePurchasable(currency) {
  return function (_ref) {
    var _ref2 = slicedToArray(_ref, 2),
        bundleGroupId = _ref2[0],
        purchasable = _ref2[1];

    return purchasable && {
      id: purchasable.id,
      bundleGroupId: bundleGroupId,
      currency: currency,
      offeredCents: null
    };
  };
};

var formIdentifier$1 = function formIdentifier$1(_ref3) {
  var _ref3$context = _ref3.context,
      props = _ref3$context.props,
      id = _ref3$context.id;
  return 'bundleBuyActions.' + props.bundleId + '.' + id;
};

var initialValue = function initialValue(group) {
  return group.products.length > 1 ? INITIAL_VALUE : group.products[0].id;
};

var formOptions = {
  formIdentifier: formIdentifier$1,

  initialValues: function initialValues(_ref4) {
    var groups = _ref4.groups;
    return fromPairs([].concat(toConsumableArray(values(groups).filter(function (group) {
      return group.products.length > 0;
    }).map(function (group) {
      return ['group.' + group.id + '.selectedProduct', initialValue(group)];
    }))));
  },

  validate: function validate(form, _ref5) {
    var groups = _ref5.groups,
        groupPurchasables = _ref5.groupPurchasables;
    return [].concat(toConsumableArray(Object.keys(groups).map(function (groupId) {
      return required(groupPurchasables[groupId]) ? { type: 'purchasable required' } : null;
    })));
  },

  submit: function submit(form, props) {
    var onSubmit = props.onSubmit,
        context = props.context,
        currency = props.currency,
        groupPurchasables = props.groupPurchasables;

    if (!currency) return Promise.reject();

    return onSubmit({
      delta: 1,
      productId: context.props.bundleId,
      purchasables: compact(entries(groupPurchasables).map(toLinePurchasable(currency)))
    });
  }
};

var mapStateToProps$1 = function mapStateToProps$1() {
  var getFormField = makeGetFormField();
  var getSelections = makeGetSelections$$1();
  var getProduct = makeGetProduct();

  return function (state, props) {
    var form = formIdentifier$1(props);
    var groups = props.groups;

    var selectedProducts = mapObj(groups, function (group, id) {
      var formField = getFormField(state, { form: form, name: 'group.' + id + '.selectedProduct' });
      return formField && typeof formField.value === 'string' ? formField.value : null;
    });

    var groupPurchasables = mapObj(groups, function (group, id) {
      var productId = selectedProducts[id];
      if (!productId) return null;

      var selectorProps = {
        form: form,
        groups: groups,
        optionsKey: 'productOptions.' + productId + '.',
        productId: productId
      };

      var product = getProduct(selectorProps);
      var selections = getSelections(state, selectorProps);
      var purchasables = product && product.variants;

      if (!purchasables) return null;
      if (purchasables.length === 1) return purchasables[0];

      return selections ? purchasables.find(matchOptions(selections)) : null;
    });

    return {
      currency: state.config.viewer.currency,
      groupPurchasables: groupPurchasables,
      selectedProducts: selectedProducts
    };
  };
};

var mapDispatchToProps$1 = function mapDispatchToProps$1(dispatch) {
  return {
    onSubmit: function onSubmit(input) {
      return dispatch(fireMutation(new AlterQuantityInBasketMutation(input)));
    }
  };
};

var queries = {
  groups: function groups(_ref6) {
    var bundleId = _ref6.context.props.bundleId;
    return bundleGroupsQuery(bundleId);
  }
};

var bundleBuyActions = (function (Component) {
  return readyOnGraphData(withQueries$1(reactRedux.connect(mapStateToProps$1, mapDispatchToProps$1)(implicitForm(Component, formOptions)), queries));
});

var _ref2$1 = jsx('div', {
  className: 'Spinner-rect'
});

var _ref3 = jsx('div', {
  className: 'Spinner-rect'
});

var _ref4 = jsx('div', {
  className: 'Spinner-rect'
});

function Spinner(_ref) {
  var className = _ref.className;

  return jsx('div', {
    className: cx('Spinner', className)
  }, void 0, _ref2$1, _ref3, _ref4);
}

var _ref2 = jsx('div', {
  className: 'LoadingButton-spinner'
}, void 0, jsx(Spinner, {}));

function LoadingButton(_ref) {
  var _ref$loading = _ref.loading,
      loading = _ref$loading === undefined ? false : _ref$loading,
      className = _ref.className,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['loading', 'className', 'children']);

  return React.createElement(
    Button,
    _extends({
      className: cx('LoadingButton', { LoadingButton_loading: loading }, className)
    }, props),
    _ref2,
    jsx('div', {
      className: 'LoadingButton-content'
    }, void 0, children)
  );
}

function MaxInBasket(_ref) {
  var max = _ref.max;

  var maxInBasketMsg = max === 1 ? 'addedToBasket' : 'maxInBasket';
  return jsx('div', {
    className: 'MaxInBasket'
  }, void 0, t('purchasable.' + maxInBasketMsg));
}

var ProductOptionsQuery = function (_Query) {
  inherits(ProductOptionsQuery, _Query);

  function ProductOptionsQuery() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ProductOptionsQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ProductOptionsQuery.__proto__ || Object.getPrototypeOf(ProductOptionsQuery)).call.apply(_ref, [this].concat(args))), _this), _this.query = 'node(id:$productId){...on Experience{options{name,values}},...on Merch{options{name,values}},...on Pod{options{name,values}}}', _this.resolve = memoize(function (response) {
      var options = response && response.options;
      if (!options) return null;
      return fromPairs(options.map(function (_ref2) {
        var name = _ref2.name,
            values$$1 = _ref2.values;
        return [name, values$$1];
      }));
    }), _temp), possibleConstructorReturn(_this, _ret);
  }

  return ProductOptionsQuery;
}(Query);

var productOptionsQuery = memoize(function (productId) {
  return new ProductOptionsQuery('productOptions.' + productId, { productId: productId });
});

var ProductPriceQuery = function (_Query) {
  inherits(ProductPriceQuery, _Query);

  function ProductPriceQuery() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ProductPriceQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ProductPriceQuery.__proto__ || Object.getPrototypeOf(ProductPriceQuery)).call.apply(_ref, [this].concat(args))), _this), _this.query = 'node(id:$productId){...on Product{price{type:__typename,...on BundlePrice{from{currency,cents},fromOriginal{currency,cents}},...on FreePrice{amount{currency,cents}},...on FixedPrice{amount{currency,cents}},...on PayWhatYouWantPrice{minimum{currency,cents},recommended{currency,cents}},...on SubscriptionPrice{amount{currency,cents}}}}}', _this.resolve = function (response) {
      return response.price;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return ProductPriceQuery;
}(Query);

var productPriceQuery = memoize(function (productId) {
  return new ProductPriceQuery('productPrice.' + productId, { productId: productId });
});

var formIdentifier$2 = function formIdentifier$2(_ref) {
  var _ref$context = _ref.context,
      props = _ref$context.props,
      id = _ref$context.id;
  return 'productBuyActions.' + props.productId + '.' + id;
};

var formOptions$1 = {
  formIdentifier: formIdentifier$2,

  initialValues: function initialValues(_ref2) {
    var price = _ref2.price;
    return {
      pwywPrice: price.type === 'PayWhatYouWantPrice' ? price.recommended.cents : null,

      quantity: '1'
    };
  },

  validate: function validate(form, _ref3) {
    var price = _ref3.price,
        purchasable = _ref3.purchasable,
        quantities = _ref3.quantities;
    return [required(purchasable) ? { type: 'purchasable required' } : null, price.type === 'PayWhatYouWantPrice' ? field(form, 'pwywPrice', [required, minimum(price.minimum.cents)]) : null, field(form, 'quantity', [required, minimum(1), maximum(purchasable ? purchasable.maxPerTransaction - (quantities[purchasable.id] || 0) : 0)])];
  },

  submit: function submit(form, props) {
    var onSubmit = props.onSubmit,
        context = props.context,
        currency = props.currency,
        purchasable = props.purchasable,
        price = props.price,
        secret = props.secret;


    if (!purchasable || !currency) return Promise.reject();

    var payload = {
      delta: parseFloat(form.fields.quantity.value),
      productId: context.props.productId,
      purchasables: [{
        currency: currency,
        id: purchasable.id,
        offeredCents: price.type === 'PayWhatYouWantPrice' ? parseFloat(form.fields.pwywPrice.value) : null
      }],
      secret: secret
    };

    return onSubmit(payload);
  },

  revalidateProps: ['quantities']
};

var mapStateToProps$2 = function mapStateToProps$2() {
  var getSelections = makeGetSelections$1();
  var getSelectedVariant = makeGetSelectedVariant$1();

  return function (state, props) {
    var selectProps = { form: formIdentifier$2(props), purchasables: props.purchasables };
    var purchasable = getSelectedVariant(state, selectProps);

    return {
      purchasable: purchasable,
      maxPerTransaction: purchasable && purchasable.maxPerTransaction,
      selections: getSelections(state, selectProps),
      currency: state.config.viewer.currency,
      secret: state.page.secret
    };
  };
};

var mapDispatchToProps$2 = function mapDispatchToProps$2(dispatch) {
  return {
    onSubmit: function onSubmit(input) {
      return dispatch(fireMutation(new AlterQuantityInBasketMutation(input)));
    }
  };
};

var queries$1 = {
  options: function options(_ref4) {
    var productId = _ref4.context.props.productId;
    return productOptionsQuery(productId);
  },
  price: function price(_ref5) {
    var productId = _ref5.context.props.productId;
    return productPriceQuery(productId);
  },
  purchasables: function purchasables(_ref6) {
    var productId = _ref6.context.props.productId;
    return productPurchasablesQuery(productId);
  },
  quantities: basketPurchasableQuantitiesQuery
};

var productBuyActions = (function (Component) {
  return readyOnGraphData(withQueries$1(reactRedux.connect(mapStateToProps$2, mapDispatchToProps$2)(implicitForm(Component, formOptions$1)), queries$1));
});

function SoldOut(_ref) {
  var status = _ref.status;

  return jsx('div', {
    className: 'SoldOut'
  }, void 0, t(status));
}

var withContext = (function (contexts) {
  return function (props) {
    var type = props.context.type;
    var childType = props.context.child ? props.context.type + '.' + props.context.child.type : null;

    var WrappedComponent = contexts[type] || childType && contexts[childType];

    if (!WrappedComponent) {
      window.Bugsnag.notify(('\n      Invalid context type ' + compact([type, childType]).join(' / ') + '.\n      Available context types: ' + Object.keys(contexts).join(', ') + '\n    ').trim());

      return null;
    }

    return React.createElement(WrappedComponent, props);
  };
});

var mapStateToProps$3 = function mapStateToProps$3(state, props) {
  var form = state.form[props.form.id];

  return {
    submitSuccess: !!form && form.submitSuccess,
    submitting: !!form && form.submitting,
    valid: !!form && form.valid === true
  };
};

var withFormMeta = createHOC('withFormMeta', function (Component) {
  return reactRedux.connect(mapStateToProps$3)(Component);
});

var withProps$1 = createHOC('withProps', function (Component, fn) {
  return function withProps(baseProps) {
    var derivedProps = fn(baseProps) || {};
    return React.createElement(Component, _extends({}, baseProps, derivedProps));
  };
});

var requiredProps = function requiredProps(props) {
  var maxPerTransaction = props.maxPerTransaction,
      purchasable = props.purchasable,
      quantities = props.quantities;

  if (!purchasable) return null;

  var _purchasable$stock$re = purchasable.stock.result,
      status = _purchasable$stock$re.status,
      remaining = _purchasable$stock$re.remaining,
      purchasableType = purchasable.type;
  var stockStatusError = status.error,
      _status$result = status.result,
      stockStatus = _status$result === undefined ? '' : _status$result;
  var stockRemainingError = remaining.error,
      stockRemaining = remaining.result;


  if (stockStatusError || stockRemainingError || !maxPerTransaction) return null;

  var amountInBasket = quantities && quantities[purchasable.id];
  var available = Math.min(maxPerTransaction, amountInBasket + (stockRemaining || Infinity));
  var maxInBasket = amountInBasket && amountInBasket >= available;
  var soldOut = stockStatus !== STOCK_AVAILABLE;

  return {
    soldOut: soldOut,
    maxInBasket: maxInBasket || false,
    maxPerTransaction: maxPerTransaction,
    stockStatus: stockStatus,
    purchasableType: purchasableType
  };
};

var ProductAddToBasketProps = createHOC('ProductAddToBasketProps', function (Component) {
  var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
    var price = props.price,
        purchasable = props.purchasable,
        productUuid = props.context.props.productUuid;

    if (!purchasable) return {};

    var isFree = price && price.type === 'FreePrice';
    var isTicket = purchasable.type === 'Ticket';

    if (!isFree || isTicket) return {};

    return {
      onClick: function onClick() {
        return dispatch(showModal$1(PartialModal, {
          name: 'free_download_form',
          query: { productId: productUuid, restrictionAllowed: true }
        }));
      }
    };
  };

  return reactRedux.connect(null, mapDispatchToProps)(withProps$1(Component, requiredProps));
});

// TODO:

function AddToBasket(props) {
  var form = props.form,
      label = props.label,
      maxInBasket = props.maxInBasket,
      maxPerTransaction = props.maxPerTransaction,
      onClick = props.onClick,
      soldOut = props.soldOut,
      stockStatus = props.stockStatus,
      submitting = props.submitting,
      valid = props.valid,
      hidden = props.hidden;


  if (hidden) return null;
  if (maxInBasket && maxPerTransaction) return jsx(MaxInBasket, {
    max: maxPerTransaction
  });
  if (soldOut && stockStatus) return jsx(SoldOut, {
    status: stockStatus
  });

  return jsx(LoadingButton, {
    disabled: !valid,
    onClick: onClick || form.submit,
    loading: submitting,
    className: 'AddToBasket'
  }, void 0, label != null ? label : t('purchasable.add'));
}

var AddToBasket$1 = withContext({
  product: productBuyActions(withFormMeta(ProductAddToBasketProps(AddToBasket))),
  bundle: bundleBuyActions(withFormMeta(AddToBasket)),
  'basketLine.product': addExtraActions$1(AddToBasket)
});

var BasketOverviewQuery = function (_Query) {
  inherits(BasketOverviewQuery, _Query);

  function BasketOverviewQuery() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, BasketOverviewQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = BasketOverviewQuery.__proto__ || Object.getPrototypeOf(BasketOverviewQuery)).call.apply(_ref, [this].concat(args))), _this), _this.query = 'viewer{basket{error,result{id,complete,overview{cardHandlingFee{type:__typename,amount{currency,cents}},hasDeliverables,hasPhysical,lineCount,postageTotal{type:__typename,amount{currency,cents}},reservationExpiresAt,subTotal{type:__typename,amount{currency,cents}},totalDiscount{type:__typename,amount{currency,cents}},totalPrice{type:__typename,amount{currency,cents}},unitCount}}}}', _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(BasketOverviewQuery, [{
    key: 'resolve',
    value: function resolve(response) {
      return _extends({}, response.basket.result.overview, {
        complete: response.basket.result.complete
      });
    }
  }]);
  return BasketOverviewQuery;
}(Query);

var basketOverviewQuery = new BasketOverviewQuery('basket.overview');

var BasketCount = function (_React$PureComponent) {
  inherits(BasketCount, _React$PureComponent);

  function BasketCount() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, BasketCount);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = BasketCount.__proto__ || Object.getPrototypeOf(BasketCount)).call.apply(_ref, [this].concat(args))), _this), _this.state = { animating: true }, _this.startAnimating = function () {
      _this.setState({ animating: true });
      _this.timeout = setTimeout(function () {
        return _this.setState({ animating: false });
      }, 5000);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(BasketCount, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var _this2 = this;

      var unitCount = _ref2.overview.unitCount;

      if (unitCount !== this.props.overview.unitCount) {
        if (!this.state.animating) {
          this.startAnimating();
        } else {
          clearTimeout(this.timeout);
          this.setState({ animating: false }, function () {
            setTimeout(_this2.startAnimating, 0);
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var unitCount = this.props.overview.unitCount;

      var className = cx('BasketCount', {
        BasketCount_empty: unitCount < 1,
        BasketCount_changed: this.state.animating
      });

      return jsx('span', {
        className: className
      }, void 0, unitCount);
    }
  }]);
  return BasketCount;
}(React.PureComponent);

var BasketCount$1 = readyOnGraphData(withQueries$1(BasketCount, {
  overview: basketOverviewQuery
}));

var nonFractionalCurrencies = new Set(['huf', 'jpy']);

var gatewayRoundedCurrencies = new Set(['huf', 'jpy', 'twd']);

var normaliseFractional = function normaliseFractional(cents, currency) {
  return nonFractionalCurrencies.has(currency) ? cents : cents / 100;
};

function formatMoney(cents, currency) {
  var forceLatin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var normalCurrency = currency.toLowerCase();
  var amount = normaliseFractional(cents, normalCurrency);

  // The -u-nu-latn suffix forces Intl to use the latin numbering system regardless of the user's
  // locale. This is because we offer translations like arabic that use different numbering systems
  // whilst not really supporting anything other than latin in other code like numeric inputs
  var locale = forceLatin ? window.LOCALE.code + '-u-nu-latn' : window.LOCALE.code;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: normalCurrency
  }).format(amount);
}

var formatMoneyObj = function formatMoneyObj(_ref, forceLatin) {
  var cents = _ref.cents,
      currency = _ref.currency;
  return formatMoney(cents, currency, forceLatin);
};

function BasketPrice(_ref) {
  var overview = _ref.overview;

  var amount = overview.totalPrice.amount;
  return jsx('span', {}, void 0, formatMoney(amount.cents, amount.currency));
}

var BasketPrice$1 = readyOnGraphData(withQueries$1(BasketPrice, {
  overview: basketOverviewQuery
}));

// eslint-disable-next-line import/prefer-default-export
var paymentProviders = {
  CARD: 'card',
  FREE: 'free',
  PAYPAL: 'paypal'
};

var COUNTRIES_WITHOUT_POSTCODES = new Set(['AO', 'AG', 'AW', 'BS', 'BZ', 'BJ', 'BW', 'BF', 'BI', 'CM', 'CF', 'KM', 'CG', 'CD', 'CK', 'CI', 'DJ', 'DM', 'GQ', 'ER', 'FJ', 'TF', 'GM', 'GH', 'GD', 'GN', 'GY', 'HK', 'IE', 'JM', 'KE', 'KI', 'MO', 'MW', 'ML', 'MR', 'MU', 'MS', 'NR', 'AN', 'NU', 'KP', 'PA', 'QA', 'RW', 'KN', 'LC', 'ST', 'SA', 'SC', 'SL', 'SB', 'SO', 'ZA', 'SR', 'SY', 'TZ', 'TL', 'TK', 'TO', 'TT', 'TV', 'UG', 'AE', 'VU', 'YE', 'ZW']);

var COUNTRIES_WITH_STATES = new Set(['CN', 'US']);

var CHECKOUT_OUTCOMES = {
  BASKET_COULD_NOT_BE_PREPARED_FOR_ORDER_PROCESSING: 'BASKET_COULD_NOT_BE_PREPARED_FOR_ORDER_PROCESSING',
  BASKET_NOT_FOUND: 'BASKET_NOT_FOUND',
  CARD_DECLINED: 'CARD_DECLINED',
  EXPIRED_CARD: 'EXPIRED_CARD',
  EMPTY_BASKET: 'EMPTY_BASKET',
  INCORRECT_CARD_NUMBER: 'INCORRECT_CARD_NUMBER',
  INCORRECT_CVC: 'INCORRECT_CVC',
  INCORRECT_POST_CODE: 'INCORRECT_POST_CODE',
  INVALID_BASKET: 'INVALID_BASKET',
  INVALID_CARD_NUMBER: 'INVALID_CARD_NUMBER',
  INVALID_CVC: 'INVALID_CVC',
  INVALID_EXPIRY_MONTH: 'INVALID_EXPIRY_MONTH',
  INVALID_EXPIRY_YEAR: 'INVALID_EXPIRY_YEAR',
  ORDER_COULD_NOT_BE_REPORTED: 'ORDER_COULD_NOT_BE_REPORTED',
  ORDER_COULD_NOT_BE_SUBMITTED: 'ORDER_COULD_NOT_BE_SUBMITTED',
  PAYMENT_GATEWAY_FAILED: 'PAYMENT_GATEWAY_FAILED',
  RESERVATION_COULD_NOT_BE_SECURED: 'RESERVATION_COULD_NOT_BE_SECURED',
  RESERVATION_COULD_NOT_BE_HELD: 'RESERVATION_COULD_NOT_BE_HELD'
};

var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

var getValue = (function (event) {
  if (isEvent(event)) {
    if (event.nativeEvent && event.nativeEvent.text !== undefined) return event.nativeEvent.text;

    var _event$target = event.target,
        type = _event$target.type,
        value = _event$target.value,
        checked = _event$target.checked,
        files = _event$target.files,
        dataTransfer = event.dataTransfer;

    if (type === 'checkbox') return checked;
    if (type === 'file') return files || dataTransfer && dataTransfer.files;
    if (type === 'number' || type === 'range') return parseFloat(value);
    return value;
  }

  return event && (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object' && typeof event.value !== 'undefined' ? event.value : event;
});

var defaultProps = {
  dirty: false,
  active: false,
  validationsPending: false,
  errors: [],
  touched: false,
  validateOn: 'blur'
};

var hasValidationEvent = function hasValidationEvent(event, _ref) {
  var validateOn = _ref.validateOn;
  return typeof validateOn === 'string' ? validateOn === event : validateOn.includes(event);
};

var Field = function (_React$PureComponent) {
  inherits(Field, _React$PureComponent);

  function Field() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, Field);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Field.__proto__ || Object.getPrototypeOf(Field)).call.apply(_ref2, [this].concat(args))), _this), _this.handleBlur = function (e) {
      _this.props.onBlur(e);
      if (hasValidationEvent('blur', _this.props)) _this.props.form.validate();
    }, _this.handleChange = function (e) {
      _this.props.onChange(e);
      if (hasValidationEvent('change', _this.props)) _this.props.form.validate();
    }, _this.handleFocus = function (e) {
      _this.props.onFocus(e);
      if (hasValidationEvent('focus', _this.props)) _this.props.form.validate();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Field, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          component = _props.component,
          children = _props.children,
          props = objectWithoutProperties(_props, ['component', 'children']);

      return React.createElement(component, _extends({}, omit(props, ['form', 'name', 'validateOn']), {
        valid: props.errors.length === 0,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus
      }), children);
    }
  }]);
  return Field;
}(React.PureComponent);

Field.defaultProps = defaultProps;


var mapStateToProps$5 = function mapStateToProps$5() {
  var getFormField = makeGetFormField();
  return function (state, props) {
    return getFormField(state, props) || {};
  };
};

var mapDispatchToProps$4 = function mapDispatchToProps$4(dispatch, _ref3) {
  var form = _ref3.form,
      name = _ref3.name;
  return {
    onChange: function onChange(event) {
      return dispatch(fieldChange(form.id, name, getValue(event)));
    },
    onBlur: function onBlur(event) {
      return dispatch(fieldBlur(form.id, name, getValue(event)));
    },
    onFocus: function onFocus() {
      return dispatch(fieldFocus(form.id, name));
    }
  };
};

var Field$1 = reactRedux.connect(mapStateToProps$5, mapDispatchToProps$4)(Field);

var idCounter$1 = 0;

var Input = function (_React$PureComponent) {
  inherits(Input, _React$PureComponent);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.inputId = 'Input_' + (idCounter$1 += 1), _this.handleBlur = function (e) {
      _this.setState({ focus: false });
      var value = getValue(e);
      if (_this.props.onBlur) _this.props.onBlur(value);
    }, _this.handleChange = function (e) {
      if (_this.props.disabled) return;
      var value = getValue(e);
      if (_this.props.onChange) _this.props.onChange(value);
    }, _this.handleFocus = function (e) {
      if (_this.props.disabled) return;
      _this.setState({ focus: true });
      var value = getValue(e);
      if (_this.props.onFocus) _this.props.onFocus(value);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          label = _props.label,
          type = _props.type,
          value = _props.value,
          children = _props.children,
          props = objectWithoutProperties(_props, ['className', 'label', 'type', 'value', 'children']);

      var valid = typeof this.props.valid === 'boolean' ? this.props.valid : true;
      var dirty = typeof this.props.dirty === 'boolean' ? this.props.dirty : !!value;
      var touched = typeof props.touched === 'boolean' ? this.props.touched : !!value;

      var fullClassName = cx('Input', className, {
        Input_dirty: dirty,
        Input_disabled: this.props.disabled,
        Input_error: !valid,
        Input_focus: this.state.focus,
        Input_populated: !!value,
        Input_success: valid,
        Input_touched: touched
      });

      var filteredProps = typeof type === 'string' ? props : omit(props, ['dirty', 'active', 'validationsPending', 'errors', 'touched', 'valid']);

      var input = React.createElement(typeof type === 'string' ? 'input' : type, _extends({}, filteredProps, {
        type: typeof type === 'string' ? type : undefined,
        id: this.inputId,
        defaultValue: undefined,
        className: 'Input-input',
        value: value || (typeof type === 'string' ? '' : value),
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus
      }));

      return jsx('label', {
        htmlFor: this.inputId,
        className: fullClassName
      }, void 0, jsx('span', {
        className: 'Input-label',
        style: { pointerEvents: 'none' }
      }, void 0, label), input, children);
    }
  }]);
  return Input;
}(React.PureComponent);

var serialiseCustomField = function serialiseCustomField(field) {
  var productId = field.productId,
      lineId = field.lineId,
      name = field.name,
      index = field.index;


  if (!productId || !lineId || !name || !index) throw new Error('malformed custom field input');

  if (name.includes('.')) throw new Error('field name cannot contain dots');

  return 'custom-' + lineId + '|' + productId + '|' + name + '.' + index;
};

function CheckoutCustomField(props) {
  var form = props.form,
      field = props.field,
      _props$field = props.field,
      name = _props$field.name,
      label = _props$field.label;


  return jsx('div', {
    className: 'CheckoutFormCustomField'
  }, void 0, jsx('span', {
    className: 'CheckoutFormCustomField-label'
  }, void 0, label), jsx(Field$1, {
    component: Input,
    form: form,
    label: name,
    name: serialiseCustomField(field),
    required: true,
    type: 'text'
  }));
}

var lineCustomFields = function lineCustomFields(quantity, lineId, fields) {
  return flatMap(fields, function (field) {
    return times(quantity, function (i) {
      return _extends({}, field, {
        lineId: lineId,
        index: i + 1
      });
    });
  });
};

function CheckoutCustomFieldsLine(props) {
  var form = props.form,
      fields = props.fields,
      lineId = props.lineId,
      quantity = props.quantity;

  var lineFields = lineCustomFields(quantity, lineId, fields);

  return jsx('div', {
    className: 'CheckoutCustomFieldsLine'
  }, void 0, lineFields.map(function (field) {
    return jsx(CheckoutCustomField, {
      form: form,
      field: field
    }, field.id + '-' + field.index);
  }));
}

var hasExtraFields = function hasExtraFields(_ref) {
  var fields = _ref.fields;
  return fields.length > 0;
};

function CheckoutCustomFields(props) {
  var form = props.form,
      basketCustomFields = props.basketCustomFields;

  var lines = values(basketCustomFields).filter(hasExtraFields);

  if (lines.length < 1) return null;

  return jsx('fieldset', {
    className: 'CheckoutFormCustomFields'
  }, void 0, jsx('legend', {
    className: 'CheckoutFormCustomFields-legend'
  }, void 0, t('checkout.extraFields.legend')), lines.map(function (_ref2, i) {
    var lineId = _ref2.lineId,
        fields = _ref2.fields,
        quantity = _ref2.quantity;
    return jsx(CheckoutCustomFieldsLine, {
      form: form,
      fields: fields,
      lineId: lineId,
      quantity: quantity
    }, i);
  }));
}

var extractCustomFieldProp = function extractCustomFieldProp(serialized) {
  var _serialized$split = serialized.split('custom-'),
      _serialized$split2 = slicedToArray(_serialized$split, 2),
      data = _serialized$split2[1];

  var _data$split = data.split('|'),
      _data$split2 = slicedToArray(_data$split, 3),
      lineId = _data$split2[0],
      productId = _data$split2[1],
      fieldName = _data$split2[2];

  var _fieldName$split = fieldName.split('.'),
      _fieldName$split2 = slicedToArray(_fieldName$split, 1),
      name = _fieldName$split2[0];

  return { lineId: lineId, productId: productId, name: name };
};

var deserialize = function deserialize(fields) {
  return fields.map(function (_ref) {
    var _ref2 = slicedToArray(_ref, 2),
        key = _ref2[0],
        field = _ref2[1];

    var _extractCustomFieldPr = extractCustomFieldProp(key),
        productId = _extractCustomFieldPr.productId,
        lineId = _extractCustomFieldPr.lineId,
        name = _extractCustomFieldPr.name;

    return {
      productId: productId,
      lineId: lineId,
      name: name,
      // $FlowFixMe - flow sees this value as mixed and regardless of all my checks it wont stop :(
      values: [field.value]
    };
  });
};

var formatCustomFields = function formatCustomFields(form) {
  var fields = entries(form.fields).filter(function (_ref3) {
    var _ref4 = slicedToArray(_ref3, 1),
        key = _ref4[0];

    return key.startsWith('custom-');
  });

  return { customFields: deserialize(fields) };
};

var getCustomFields = function getCustomFields(basketCustomFields) {
  return flatMap(values(basketCustomFields).filter(hasExtraFields), function (_ref5) {
    var quantity = _ref5.quantity,
        lineId = _ref5.lineId,
        fields = _ref5.fields;
    return lineCustomFields(quantity, lineId, fields);
  });
};

var parseCustomFields = function parseCustomFields(obj) {
  return obj && obj.customCheckoutFields && typeof obj.customCheckoutFields === 'string' ? JSON.parse(obj.customCheckoutFields) : [];
};

var getCustomFieldsForItem = function getCustomFieldsForItem(_ref6) {
  var purchasable = _ref6.purchasable;
  return [].concat(toConsumableArray(parseCustomFields(purchasable)), toConsumableArray(purchasable.product ? parseCustomFields(purchasable.product) : []));
};

var getCustomFieldsForLine = function getCustomFieldsForLine(memo, line) {
  var lineId = line.lineId,
      product = line.product,
      items = line.items,
      quantity = line.quantity;

  if (product.error || !product.result.customCheckoutFields) return memo;

  var fields = uniqueBy('id', [].concat(toConsumableArray(parseCustomFields(product.result)), toConsumableArray(flatMap(items.result || [], getCustomFieldsForItem))));

  return Object.assign(memo, defineProperty({}, product.result.id, { lineId: lineId, quantity: quantity, fields: fields }));
};

var OFF$1 = 'off';


var REQUIRED$1 = 'required';


var OPTIONAL$1 = 'optional';


var propertyStatusEnum = { OFF: OFF$1, REQUIRED: REQUIRED$1, OPTIONAL: OPTIONAL$1 };

var PrepareCheckoutMutation = function (_Mutation) {
  inherits(PrepareCheckoutMutation, _Mutation);

  function PrepareCheckoutMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, PrepareCheckoutMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = PrepareCheckoutMutation.__proto__ || Object.getPrototypeOf(PrepareCheckoutMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'PrepareCheckout', _this.mutation = 'prepareCheckout', _this.query = 'outcome,successful,response', _this.invalidateQueries = function () {
      return [];
    }, _this.invalidatePartials = function () {
      return [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return PrepareCheckoutMutation;
}(Mutation);

var getPaypalPayload = function getPaypalPayload(payload) {
  // do we have a name? then we have a shipping address
  var customer = payload.customer.deliveryAddress.name ? payload.customer : _extends({}, payload.customer, { deliveryAddress: null });

  return _extends({}, payload, {
    customer: customer,
    card: null
  });
};

var beginPayPalFlow = (function (payload) {
  return dispatch(fireMutation(new PrepareCheckoutMutation(_extends({
    paymentMethod: paymentProviders.PAYPAL
  }, getPaypalPayload(payload))))).then(function (resp) {
    var successful = resp.successful,
        outcome = resp.outcome,
        response = resp.response;

    if (!successful) throw new Error(outcome);
    window.location.href = response;
    return resp;
  });
});

var FinaliseCheckoutMutation = function (_Mutation) {
  inherits(FinaliseCheckoutMutation, _Mutation);

  function FinaliseCheckoutMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, FinaliseCheckoutMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = FinaliseCheckoutMutation.__proto__ || Object.getPrototypeOf(FinaliseCheckoutMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'FinalizeCheckout', _this.mutation = 'finalizeCheckout', _this.query = 'outcome,successful,completedBasket{friendlyOrderId,id,lines{product{error,result{id,name}},quantity},overview{totalPrice{amount{cents,currency}}},uuid}', _this.invalidateQueries = function (_, queryIds) {
      return [].concat(toConsumableArray(queryIds.filter(match(/^basket\./))));
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return FinaliseCheckoutMutation;
}(Mutation);

var getPayload = function getPayload(payload) {
  return _extends({}, payload, {
    paymentMethod: paymentProviders.CARD
  });
};

function beginCardFlow(payload, _ref) {
  var profileName = _ref.profileName;

  return dispatch(fireMutation(new PrepareCheckoutMutation(getPayload(payload)))).then(function (prepareCheckout) {
    var outcome = prepareCheckout.outcome,
        successful = prepareCheckout.successful;


    if (!successful) throw new Error(outcome);
    return dispatch(fireMutation(new FinaliseCheckoutMutation(payload)));
  }).then(function (finalizeCheckout) {
    var outcome = finalizeCheckout.outcome,
        successful = finalizeCheckout.successful,
        completedBasket = finalizeCheckout.completedBasket;


    if (!successful) throw new Error(outcome);

    track$1({
      name: trackingEvents.CHECKOUT,
      event: {
        basket: completedBasket,
        profile: profileName
      }
    });

    var pathname = window.PROFILE_PATH + '/receipt/' + completedBasket.uuid;
    breakwater.navigation.navigate(pathname);

    return finalizeCheckout;
  });
}

var FreeCheckoutMutation = function (_Mutation) {
  inherits(FreeCheckoutMutation, _Mutation);

  function FreeCheckoutMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, FreeCheckoutMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = FreeCheckoutMutation.__proto__ || Object.getPrototypeOf(FreeCheckoutMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'FreeCheckout', _this.mutation = 'freeCheckout', _this.query = 'outcome,successful,completedBasket{friendlyOrderId,id,lines{product{error,result{id,name}},quantity},overview{totalPrice{amount{cents,currency}}},uuid}', _this.invalidateQueries = function (_, queryIds) {
      return [].concat(toConsumableArray(queryIds.filter(match(/^basket\./))));
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return FreeCheckoutMutation;
}(Mutation);

var getFreeCheckoutPayload = function getFreeCheckoutPayload(_ref) {
  var customer = _ref.customer,
      consent = _ref.consent;
  return {
    customer: customer,
    consent: consent
  };
};

function beginFreeFlow(payload, _ref2) {
  var profileName = _ref2.profileName;

  return dispatch(fireMutation(new FreeCheckoutMutation(getFreeCheckoutPayload(payload)))).then(function (freeCheckout) {
    var outcome = freeCheckout.outcome,
        successful = freeCheckout.successful,
        completedBasket = freeCheckout.completedBasket;


    if (!successful) {
      throw new Error(outcome);
    }

    track$1({
      name: trackingEvents.CHECKOUT,
      event: {
        basket: completedBasket,
        profile: profileName
      }
    });

    var pathname = window.PROFILE_PATH + '/receipt/' + completedBasket.uuid;

    breakwater.navigation.navigate(pathname);

    return freeCheckout;
  });
}

var _providerProps;

var CARD = paymentProviders.CARD;
var FREE = paymentProviders.FREE;
var PAYPAL = paymentProviders.PAYPAL;
var REQUIRED$$1 = propertyStatusEnum.REQUIRED;
var OFF$$1 = propertyStatusEnum.OFF;
var OPTIONAL$$1 = propertyStatusEnum.OPTIONAL;


var isFree = function isFree(_ref) {
  var cents = _ref.totalPrice.amount.cents;
  return cents === 0;
};

var nonFree = compose$1(not, isFree);

var providerProps = (_providerProps = {}, defineProperty(_providerProps, CARD, {
  translationKey: 'cardpayment',
  billingInfo: REQUIRED$$1,
  shippingInfo: OPTIONAL$$1,
  locationInfo: OFF$$1,
  checkoutFlow: beginCardFlow,
  isApplicable: nonFree
}), defineProperty(_providerProps, PAYPAL, {
  translationKey: 'paypal',
  billingInfo: OFF$$1,
  shippingInfo: REQUIRED$$1,
  locationInfo: OFF$$1,
  checkoutFlow: beginPayPalFlow,
  isApplicable: nonFree
}), defineProperty(_providerProps, FREE, {
  translationKey: 'free',
  billingInfo: OFF$$1,
  shippingInfo: OFF$$1,
  locationInfo: REQUIRED$$1,
  checkoutFlow: beginFreeFlow,
  isApplicable: isFree
}), _providerProps);

var _Object$keys = Object.keys(providerProps);
var _Object$keys2 = slicedToArray(_Object$keys, 1);
var defaultProviderId = _Object$keys2[0];

var getProviders = function getProviders(enabled, basketOverview) {
  return Object.keys(providerProps).filter(function (provider) {
    return (provider === FREE || enabled.includes(provider)) && providerProps[provider].isApplicable(basketOverview);
  });
};

function getPaymentProviderProps(provider) {
  var prop = provider || defaultProviderId;

  return _extends({ id: prop }, providerProps[prop]);
}

var getFieldVisibility = function getFieldVisibility(fieldStatus) {
  var shouldRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return shouldRender && fieldStatus !== OFF$$1;
};

var ChangeCardTypeMutation = function (_Mutation) {
  inherits(ChangeCardTypeMutation, _Mutation);

  function ChangeCardTypeMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ChangeCardTypeMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ChangeCardTypeMutation.__proto__ || Object.getPrototypeOf(ChangeCardTypeMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'ChangeCardType', _this.mutation = 'changeCardType', _this.invalidateQueries = function () {
      return ['basketOverview'];
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return ChangeCardTypeMutation;
}(Mutation);

var AuthorizeBasketMutation = function (_Mutation) {
  inherits(AuthorizeBasketMutation, _Mutation);

  function AuthorizeBasketMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AuthorizeBasketMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AuthorizeBasketMutation.__proto__ || Object.getPrototypeOf(AuthorizeBasketMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'AuthorizeBasket', _this.mutation = 'authorizeBasket', _this.query = 'basketItemsRemoved', _this.invalidateQueries = function (_, queryIds) {
      return queryIds.filter(match(/^(basket|productPurchasables)\./));
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return AuthorizeBasketMutation;
}(Mutation);

var ValidateBasketPricesMutation = function (_Mutation) {
  inherits(ValidateBasketPricesMutation, _Mutation);

  function ValidateBasketPricesMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ValidateBasketPricesMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ValidateBasketPricesMutation.__proto__ || Object.getPrototypeOf(ValidateBasketPricesMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'ValidateBasketPrices', _this.mutation = 'validateBasketPrices', _this.query = 'somethingChanged', _this.invalidateQueries = function (_, queryIds) {
      return queryIds.filter(match(/^(basket|productPurchasables)\./));
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return ValidateBasketPricesMutation;
}(Mutation);

var ExtendReservationMutation = function (_Mutation) {
  inherits(ExtendReservationMutation, _Mutation);

  function ExtendReservationMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ExtendReservationMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ExtendReservationMutation.__proto__ || Object.getPrototypeOf(ExtendReservationMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'ExtendReservation', _this.mutation = 'extendReservation', _this.query = 'reservationErrors{id,type,name}', _this.invalidateQueries = function (_, queryIds) {
      return queryIds.filter(match(/^(productPurchasables|basket)\./));
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return ExtendReservationMutation;
}(Mutation);

var UpdateCustomFieldsMutation = function (_Mutation) {
  inherits(UpdateCustomFieldsMutation, _Mutation);

  function UpdateCustomFieldsMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, UpdateCustomFieldsMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = UpdateCustomFieldsMutation.__proto__ || Object.getPrototypeOf(UpdateCustomFieldsMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'UpdateCustomFields', _this.mutation = 'updateCustomFields', _this.invalidateQueries = function () {
      return ['basket.overview'];
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return UpdateCustomFieldsMutation;
}(Mutation);

var BasketLineQuantitiesQuery = function (_Query) {
  inherits(BasketLineQuantitiesQuery, _Query);

  function BasketLineQuantitiesQuery() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, BasketLineQuantitiesQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = BasketLineQuantitiesQuery.__proto__ || Object.getPrototypeOf(BasketLineQuantitiesQuery)).call.apply(_ref, [this].concat(args))), _this), _this.query = 'viewer{basket{result{lines{id,quantity}}}}', _this.resolve = memoize(function (response) {
      return fromPairs(response.basket.result.lines.map(function (_ref2) {
        var id = _ref2.id,
            quantity = _ref2.quantity;
        return [id, quantity];
      }));
    }), _temp), possibleConstructorReturn(_this, _ret);
  }

  return BasketLineQuantitiesQuery;
}(Query);

var basketLineQuantitiesQuery = new BasketLineQuantitiesQuery('basket.lineQuantities');

var BasketCustomFieldsQuery = function (_Query) {
  inherits(BasketCustomFieldsQuery, _Query);

  function BasketCustomFieldsQuery() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, BasketCustomFieldsQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = BasketCustomFieldsQuery.__proto__ || Object.getPrototypeOf(BasketCustomFieldsQuery)).call.apply(_ref, [this].concat(args))), _this), _this.query = 'viewer{basket{error,result{lines{lineId:id,quantity,product{error,result{id,customCheckoutFields}},items{error,result{purchasable{...on Ticket{customCheckoutFields},...on Digital{customCheckoutFields},...on Variant{product{customCheckoutFields}}}}}}}}}', _this.resolve = memoize(function (response) {
      return response.basket.error ? {} : response.basket.result.lines.reduce(getCustomFieldsForLine, {});
    }), _temp), possibleConstructorReturn(_this, _ret);
  }

  return BasketCustomFieldsQuery;
}(Query);

var basketCustomFieldsQuery = new BasketCustomFieldsQuery('basket.customFields');

var billing = function billing(_ref) {
  var totalPrice = _ref.totalPrice;
  return totalPrice.amount.cents > 0;
};


var delivery = function delivery(_ref2) {
  var hasDeliverables = _ref2.hasDeliverables;
  return hasDeliverables;
};

var confirmLocation = function confirmLocation(_ref3) {
  var totalPrice = _ref3.totalPrice;
  return totalPrice.amount.cents === 0;
};

var defaultFormat = /(\d{1,4})/g;

var defaultMask = '1111 1111 1111 1111';
var defaultProgressiveFormat = /(?:^|\s)(\d{4})$/;

var cards = [{
  type: 'amex',
  pattern: /^3[47]/,
  format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  mask: '1111 111111 11111',
  progressiveFormat: /^(\d{4}|\d{4}\s\d{6})$/,
  length: [15],
  cvcLength: [4],
  luhn: true
}, {
  type: 'maestro',
  pattern: /^(5018|5020|5038|6304|6703|6759|676[1-3])/,
  format: defaultFormat,
  mask: defaultMask,
  progressiveFormat: defaultProgressiveFormat,
  length: [12, 13, 14, 15, 16, 17, 18, 19],
  cvcLength: [3],
  luhn: true
}, {
  type: 'mastercard',
  pattern: /^5[1-5]/,
  format: defaultFormat,
  mask: defaultMask,
  progressiveFormat: defaultProgressiveFormat,
  length: [16],
  cvcLength: [3],
  luhn: true
}, {
  type: 'visaelectron',
  pattern: /^4(026|17500|405|508|844|91[37])/,
  format: defaultFormat,
  mask: defaultMask,
  progressiveFormat: defaultProgressiveFormat,
  length: [16],
  cvcLength: [3],
  luhn: true
}, {
  type: 'visa',
  pattern: /^4/,
  format: defaultFormat,
  mask: defaultMask,
  progressiveFormat: defaultProgressiveFormat,
  length: [13, 16],
  cvcLength: [3],
  luhn: true
}];

var formatPlain = function formatPlain(number) {
  return ('' + (number || '')).replace(/\D/g, '');
};

var cardFromNumber = function cardFromNumber(number) {
  var formatted = formatPlain(number);
  return cards.find(function (card) {
    return card.pattern.test(formatted);
  });
};





var luhnCheck = function luhnCheck(number) {
  var sum = formatPlain(number).split('').reverse().map(function (digit) {
    return parseInt(digit, 10);
  }).map(function (digit, i) {
    return (i + 1) % 2 === 0 ? digit * 2 : digit;
  }).map(function (digit) {
    return digit > 9 ? digit - 9 : digit;
  }).reduce(function (a, b) {
    return a + b;
  }, 0);

  return sum % 10 === 0;
};

var validateCardNumber = function validateCardNumber() {
  var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var number = raw.replace(/\s+|-/g, '');

  if (!/^\d+$/.test(number)) return false;

  var card = cardFromNumber(number);

  if (!card) return false;

  if (!card.length.includes(number.length)) return false;
  if (card.luhn) return luhnCheck(number);

  return true;
};

var pad = function pad(number, length) {
  return ('000000' + number).slice(-1 * length);
};

var parseExpiry = function parseExpiry(raw) {
  if (typeof raw !== 'string') throw new TypeError('parseExpiry must be passed a string');

  var plain = formatPlain(raw);

  if (plain.length !== 4 && plain.length !== 6) return { error: true, raw: raw };

  var month = parseInt(plain.slice(0, 2), 10);
  var year = parseInt(plain.length === 4 ? '20' + plain.slice(2) : plain.slice(2), 10);

  return { month: month, year: year, error: false };
};

var formatExpiry = function formatExpiry(expiry) {
  if (expiry.error) return expiry.raw;
  return pad(expiry.month, 2) + '/' + pad(expiry.year, 4);
};

var validateExpiry = function validateExpiry(expiry) {
  if (expiry.error) return false;

  var month = expiry.month,
      year = expiry.year;

  if (month < 1 || month > 12) return false;
  return Date.now() < Date.UTC(year, month);
};

var ensureCardExpiry = function ensureCardExpiry(raw) {
  if (raw && (typeof raw === 'undefined' ? 'undefined' : _typeof(raw)) === 'object') {
    var _month = raw.month,
        _year = raw.year,
        _error = raw.error,
        rawVal = raw.raw;

    if (_error === true && typeof rawVal === 'string') return { error: true, raw: rawVal };
    if (typeof _month === 'number' && typeof _year === 'number') return { month: _month, year: _year, error: false };
  }

  throw new TypeError('Expected a CardExpiry');
};

var getCardExpiry = function getCardExpiry(raw) {
  if (typeof raw === 'string') {
    return parseExpiry(raw);
  } else if ((typeof raw === 'undefined' ? 'undefined' : _typeof(raw)) === 'object' && raw != null) {
    return ensureCardExpiry(raw);
  }

  throw TypeError('Expected a string or a CardExpiry');
};

var isSecurityError = function isSecurityError(e) {
  return hasOwnProperty(e, 'name') && e.name === 'SecurityError' || hasOwnProperty(e, 'code') && e.code === e.SECURITY_ERR;
};

var ignoreSecurityError = function ignoreSecurityError(f) {
  return function () {
    try {
      return f.apply(undefined, arguments);
    } catch (e) {
      if (!isSecurityError(e)) {
        throw e;
      }
    }
    return null;
  };
};

var STORAGE_KEY = 'nextTime';

var read = ignoreSecurityError(function () {
  localStorage.getItem(STORAGE_KEY);
});

var save$1 = ignoreSecurityError(function (items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
});

var clear$1 = ignoreSecurityError(function () {
  localStorage.removeItem(STORAGE_KEY);
});

var actions = {
  ItemsRemovedFromBasketAlert: function ItemsRemovedFromBasketAlert() {
    return showModal$1(SimpleModal, { content: t('alerts.content.georestrictedItemsRemoved') });
  }
};

var load = function load() {
  var nextTimeData = read();
  if (!nextTimeData) return [];

  try {
    return JSON.parse(nextTimeData);
  } catch (e) {
    Bugsnag.notifyException(e);

    return [];
  }
};

var exec = function exec() {
  var items = load();
  clear$1();

  items.forEach(function (item) {
    return dispatch(actions[item.type](item));
  });
};

var nextTime = (function (item) {
  var items = load();
  items.push(item);
  save$1(items);
});

var ChangeViewerCountryMutation = function (_Mutation) {
  inherits(ChangeViewerCountryMutation, _Mutation);

  function ChangeViewerCountryMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ChangeViewerCountryMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ChangeViewerCountryMutation.__proto__ || Object.getPrototypeOf(ChangeViewerCountryMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'ChangeViewerCountry', _this.mutation = 'changeViewerCountry', _this.query = 'basketItemsRemoved', _this.invalidateQueries = function () {
      return [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ChangeViewerCountryMutation, [{
    key: 'after',
    value: function after(_ref2) {
      var basketItemsRemoved = _ref2.basketItemsRemoved;

      if (basketItemsRemoved) {
        nextTime({
          type: 'ItemsRemovedFromBasketAlert'
        });
      }

      window.location.reload();
    }
  }]);
  return ChangeViewerCountryMutation;
}(Mutation);

function setStateAsync(component, state) {
  return new Promise(function (resolve) {
    return component.setState(state, resolve);
  });
}

var ignoreProps$1 = ['dirty', 'active', 'validationsPending', 'errors', 'touched', 'valid'];

var Select = function (_React$PureComponent) {
  inherits(Select, _React$PureComponent);

  function Select() {
    classCallCheck(this, Select);
    return possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
  }

  createClass(Select, [{
    key: 'componentWillMount',
    // eslint-disable-line react/sort-comp

    value: function componentWillMount() {
      this.checkValue(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.checkValue(props);
    }
  }, {
    key: 'checkValue',
    value: function checkValue(props) {
      var value = props.value,
          options = props.options;

      if (value == null) return;

      var valueOption = options.find(function (option) {
        return (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' ? '' + option.value === '' + value : '' + option === '' + value;
      });

      if (valueOption == null && this.props.onChange) {
        this.props.onChange((typeof valueOption === 'undefined' ? 'undefined' : _typeof(valueOption)) === 'object' ? valueOption.value : valueOption);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          options = _props.options,
          props = objectWithoutProperties(_props, ['value', 'options']);

      return React.createElement(
        'select',
        _extends({ value: value || '' }, omit(props, ignoreProps$1)),
        options.map(function (opt) {
          return (typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) === 'object' ? jsx('option', {
            value: opt.value,
            disabled: opt.disabled
          }, opt.value, opt.label) : jsx('option', {
            value: opt
          }, opt, opt);
        })
      );
    }
  }]);
  return Select;
}(React.PureComponent);

function SelectInput(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      props = objectWithoutProperties(_ref, ['className']);

  return React.createElement(Input, _extends({ type: Select, className: 'SelectInput ' + className }, props));
}

var _ref2$2 = jsx(Spinner, {
  className: 'AsyncSelectInput-spinner'
});

var AsyncSelectInput = function (_React$PureComponent) {
  inherits(AsyncSelectInput, _React$PureComponent);

  function AsyncSelectInput() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AsyncSelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AsyncSelectInput.__proto__ || Object.getPrototypeOf(AsyncSelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = { loading: false }, _this.handleChange = function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          _this$props$options = slicedToArray(_this$props.options, 1),
          firstOption = _this$props$options[0],
          onChange = _this$props.onChange;

      if (disabled || _this.state.loading) return;
      var safeValue = value || String(firstOption);

      setStateAsync(_this, { loading: true }).then(function () {
        return onChange(safeValue);
      }).then(function () {
        return _this.mounted && setStateAsync(_this, { loading: false });
      }).catch(function (error) {
        if (_this.mounted) _this.setState({ loading: false });
        return Promise.reject(error);
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(AsyncSelectInput, [{
    key: 'componentDidMount',
    // eslint-disable-line react/sort-comp
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          options = _props.options,
          loadingProp = _props.loading,
          props = objectWithoutProperties(_props, ['className', 'options', 'loading']);

      var loading = this.state.loading || loadingProp;

      return React.createElement(
        SelectInput,
        _extends({}, props, {
          options: options,
          className: cx('AsyncSelectInput', className, { AsyncSelectInput_loading: loading }),
          onChange: this.handleChange
        }),
        _ref2$2
      );
    }
  }]);
  return AsyncSelectInput;
}(React.PureComponent);

var options$2 = sortBy(window.LOCALE.countries, function (country) {
  return country.name;
}).map(function (_ref) {
  var code = _ref.code,
      name = _ref.name;
  return { value: code.toUpperCase(), label: name };
});

function ViewerCountrySelect(props) {
  var className = props.className,
      country = props.country,
      label = props.label,
      onChange = props.onChange;


  return jsx(AsyncSelectInput, {
    label: label != null ? label : '',
    className: cx('ViewerCountrySelect', className),
    value: country.toUpperCase(),
    options: options$2,
    onChange: onChange
  });
}

var mapStateToProps$7 = function mapStateToProps$7(_ref2) {
  var code = _ref2.config.viewer.country.code;
  return {
    country: code
  };
};

var mapDispatchToProps$5 = function mapDispatchToProps$5(dispatch) {
  return {
    onChange: function onChange(country) {
      return dispatch(fireMutation(new ChangeViewerCountryMutation({ country: country })));
    }
  };
};

var ViewerCountrySelect$1 = reactRedux.connect(mapStateToProps$7, mapDispatchToProps$5)(ViewerCountrySelect);

// @form
function ConfirmLocation(props) {
  var form = props.form,
      _props$className = props.className,
      className = _props$className === undefined ? '' : _props$className;


  return jsx('fieldset', {
    className: 'CheckoutForm-location ' + className
  }, void 0, jsx('div', {
    className: 'CheckoutForm-location-city'
  }, void 0, jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: 'confirmLocation.city',
    label: t('confirmLocation.city'),
    validateOn: ['change', 'blur'],
    required: true
  })), jsx('div', {
    className: 'CheckoutForm-location-country'
  }, void 0, jsx(ViewerCountrySelect$1, {
    label: t('confirmLocation.country')
  })));
}

var idCounter$2 = 0;

var Checkbox = function (_React$Component) {
  inherits(Checkbox, _React$Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.checkboxId = 'Checkbox_' + (idCounter$2 += 1), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Checkbox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          label = _props.label,
          value = _props.value,
          props = objectWithoutProperties(_props, ['className', 'label', 'value']);

      return jsx('label', {
        className: 'Checkbox ' + className,
        htmlFor: this.checkboxId
      }, void 0, React.createElement('input', _extends({
        id: this.checkboxId,
        className: 'Checkbox-input',
        type: 'checkbox'
      }, props, {
        checked: value || false
      })), jsx('span', {
        className: 'Checkbox-label'
      }, void 0, label));
    }
  }]);
  return Checkbox;
}(React.Component);

function HTMLString(props) {
  var __html = props.html,
      _props$Component = props.Component,
      Component = _props$Component === undefined ? 'span' : _props$Component,
      childProps = objectWithoutProperties(props, ['html', 'Component']);


  return React.createElement(Component, _extends({}, childProps, {
    dangerouslySetInnerHTML: { __html: __html }
  }));
}

function Consent(props) {
  var form = props.form,
      vendors = props.vendors;


  return jsx('section', {
    className: 'CheckoutFormConsent'
  }, void 0, jsx('fieldset', {}, void 0, jsx(Field$1, {
    form: form,
    name: 'consents.mgMailingList',
    component: Checkbox,
    label: t('checkout.consent.mgMailingList')
  }), entries(vendors).map(function (_ref) {
    var _ref2 = slicedToArray(_ref, 2),
        id = _ref2[0],
        name = _ref2[1];

    return jsx(Field$1, {
      form: form,
      name: 'consents.vendorMailingLists.' + id,
      component: Checkbox,
      label: t('checkout.consent.vendorMailingLists', { name: name })
    }, id);
  }), jsx(Field$1, {
    form: form,
    name: 'consents.mgTermsAndConditions',
    component: Checkbox,
    label: jsx(HTMLString, {
      html: t('checkout.consent.mgTermsAndConditions')
    }),
    validateOn: 'change'
  })));
}

function SelectableButton(props) {
  var onChange = props.onChange,
      _props$type = props.type,
      type = _props$type === undefined ? 'button' : _props$type,
      selectableValue = props.selectableValue,
      _props$className = props.className,
      className = _props$className === undefined ? '' : _props$className,
      value = props.value,
      _props$selectedClass = props.selectedClass,
      selectedClass = _props$selectedClass === undefined ? '' : _props$selectedClass,
      children = props.children,
      childProps = objectWithoutProperties(props, ['onChange', 'type', 'selectableValue', 'className', 'value', 'selectedClass', 'children']);


  return React.createElement(
    'button',
    _extends({}, childProps, {
      type: type,
      onClick: function onClick() {
        return onChange({ value: selectableValue });
      },
      className: cx(className, defineProperty({}, selectedClass, value === selectableValue))
    }),
    children
  );
}

var BillingProviders = function BillingProviders(_ref) {
  var form = _ref.form,
      name = _ref.name,
      providers = _ref.providers;
  return jsx('div', {
    className: 'BillingMethodButtons'
  }, void 0, providers.map(function (provider) {
    return jsx(Field$1, {
      className: cx('BillingMethodButton', 'BillingMethodButton-' + provider),
      component: SelectableButton,
      form: form,
      name: name,
      selectableValue: provider,
      selectedClass: 'BillingMethodButton_active',
      type: 'button',
      validateOn: ['change', 'blur']
    }, provider, t('checkout.paymentService.' + getPaymentProviderProps(provider).translationKey));
  }));
};

var FilteredChildren = function FilteredChildren(props) {
  var providerProps = props.providerProps,
      children = props.children;


  var isRequired = function isRequired(child) {
    return providerProps[child.props.propName] === propertyStatusEnum.REQUIRED;
  };
  var filteredProps = function filteredProps(child) {
    return omit(child.props, ['propName', 'shouldRender']);
  };

  var arrayChildren = React.Children.toArray(children);
  var visibleChildren = arrayChildren.filter(function (_ref2) {
    var _ref2$props = _ref2.props,
        propName = _ref2$props.propName,
        shouldRender = _ref2$props.shouldRender;
    return getFieldVisibility(providerProps[propName], shouldRender);
  });

  return jsx('div', {}, void 0, visibleChildren.map(function (child) {
    return React.cloneElement(child, _extends({}, filteredProps(child), { isRequired: isRequired(child) }));
  }));
};

function BillingMethodChooser(props) {
  var children = props.children,
      form = props.form,
      name = props.name,
      providers = props.providers,
      selected = props.selected;


  return jsx('div', {
    className: 'BillingMethodWrapper'
  }, void 0, providers.length > 1 && jsx('fieldset', {
    className: 'BillingMethodChooser'
  }, void 0, jsx('legend', {}, void 0, t('checkout.paymentService.legend')), jsx(BillingProviders, {
    form: form,
    name: name,
    providers: providers
  })), jsx(FilteredChildren, {
    providerProps: getPaymentProviderProps(selected)
  }, void 0, children));
}

function Address(props) {
  var form = props.form,
      type = props.type,
      _props$className = props.className,
      className = _props$className === undefined ? '' : _props$className,
      _props$withName = props.withName,
      withName = _props$withName === undefined ? false : _props$withName;


  return jsx('fieldset', {
    className: 'CheckoutFormAddress CheckoutFormAddress_' + type + ' ' + className
  }, void 0, withName && jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: type + '.name',
    label: t('checkout.' + type + '.name')
  }), jsx('div', {
    className: 'CheckoutFormAddress-fieldPair'
  }, void 0, jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: type + '.address1',
    label: t('checkout.' + type + '.address1')
  }), jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: type + '.address2',
    label: t('checkout.address.address2') + ' (' + t('checkout.address.optional') + ')'
  })), jsx('div', {
    className: 'CheckoutFormAddress-fieldPair'
  }, void 0, jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: type + '.city',
    label: t('checkout.address.city')
  }), jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: type + '.state',
    label: t('checkout.address.state')
  })), jsx('div', {
    className: 'CheckoutFormAddress-fieldPair'
  }, void 0, jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: type + '.postcode',
    label: t('checkout.address.postcode')
  }), jsx(ViewerCountrySelect$1, {
    label: t('checkout.address.country'),
    disabled: type === 'delivery',
    onChange: form.validate
  })));
}

/* eslint-disable react/sort-comp */
var SHOULD_PREPEND_ZERO = /^([2-9]|1[3-9])$/;

var CardExpiry = function (_React$Component) {
  inherits(CardExpiry, _React$Component);

  function CardExpiry() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, CardExpiry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = CardExpiry.__proto__ || Object.getPrototypeOf(CardExpiry)).call.apply(_ref, [this].concat(args))), _this), _this.state = { value: '' }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(CardExpiry, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.maybeUpdateValueFromProps(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.maybeUpdateValueFromProps(nextProps);
    }
  }, {
    key: 'maybeUpdateValueFromProps',
    value: function maybeUpdateValueFromProps(props) {
      if (props.value && !props.value.error && (this.state.value === '' || formatExpiry(getCardExpiry(props.value)) !== formatExpiry(parseExpiry(this.state.value)))) {
        this.updateValue(props.value);
      }
    }
  }, {
    key: 'updateValue',
    value: function updateValue(value) {
      this.setState({ value: formatExpiry(getCardExpiry(value)) });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      var _props$onChange = this.props.onChange,
          onChange = _props$onChange === undefined ? noop : _props$onChange;


      var rawValue = formatPlain(getValue(event));
      var adjustedValue = rawValue;

      if (rawValue.match(SHOULD_PREPEND_ZERO)) {
        adjustedValue = '0' + rawValue;
      }

      this.setState({ value: adjustedValue }, function () {
        onChange({ value: parseExpiry(adjustedValue) });
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var _props$onBlur = this.props.onBlur,
          onBlur = _props$onBlur === undefined ? noop : _props$onBlur;


      var parsedValue = parseExpiry(getValue(event));

      if (!parsedValue.error) {
        this.updateValue(parsedValue);
      }

      onBlur({ value: parsedValue });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$className = this.props.className,
          className = _props$className === undefined ? '' : _props$className;
      var value = this.state.value;


      return jsx(MaskedInput, {
        type: 'tel',
        mask: '11/1111',
        className: 'CCExpiryInput ' + className,
        onChange: function onChange(e) {
          return _this2.handleChange(e);
        },
        onBlur: function onBlur(e) {
          return _this2.handleBlur(e);
        },
        placeholder: '',
        value: value
      });
    }
  }]);
  return CardExpiry;
}(React.Component);

/* eslint-disable react/sort-comp */
var wrapEvent = function wrapEvent(eventHandler) {
  return function (event) {
    return eventHandler({ value: formatPlain(event.target.value) });
  };
};

var _ref2$3 = jsx('span', {
  className: 'CCNumberInput-icon'
});

var CardNumber = function (_React$Component) {
  inherits(CardNumber, _React$Component);

  function CardNumber() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, CardNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = CardNumber.__proto__ || Object.getPrototypeOf(CardNumber)).call.apply(_ref, [this].concat(args))), _this), _this.state = { type: 'unknown', mask: defaultMask }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(CardNumber, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.maybeUpdateCardType(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.maybeUpdateCardType(nextProps);
    }
  }, {
    key: 'maybeUpdateCardType',
    value: function maybeUpdateCardType(nextProps) {
      var _nextProps$onCardType = nextProps.onCardTypeChange,
          onCardTypeChange = _nextProps$onCardType === undefined ? noop : _nextProps$onCardType;


      var nextCard = cardFromNumber(nextProps.value || '');
      var nextType = nextCard ? nextCard.type : 'unknown';
      var nextMask = nextCard ? nextCard.mask : defaultMask;

      if (nextType !== this.state.type) {
        this.setState({
          type: nextType,
          mask: nextMask
        });

        onCardTypeChange(nextType);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$value = _props.value,
          value = _props$value === undefined ? '' : _props$value,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          _props$onChange = _props.onChange,
          onChange = _props$onChange === undefined ? noop : _props$onChange,
          _props$onBlur = _props.onBlur,
          onBlur = _props$onBlur === undefined ? noop : _props$onBlur;
      var _state = this.state,
          type = _state.type,
          mask = _state.mask;


      return jsx('span', {
        className: 'CCNumberInput CCNumberInput_' + type
      }, void 0, jsx(MaskedInput, {
        type: 'tel',
        className: className,
        mask: mask,
        onChange: wrapEvent(onChange),
        onBlur: wrapEvent(onBlur),
        placeholder: '',
        value: value
      }), _ref2$3);
    }
  }]);
  return CardNumber;
}(React.Component);

var wrapEventHandler = memoize(function (f) {
  return function (e) {
    return f({ value: formatPlain(getValue(e)) });
  };
});

function CVC(props) {
  var _props$value = props.value,
      value = _props$value === undefined ? '' : _props$value,
      onChange = props.onChange,
      onBlur = props.onBlur,
      _props$className = props.className,
      className = _props$className === undefined ? '' : _props$className;


  return jsx(MaskedInput, {
    type: 'tel',
    mask: '111',
    className: 'CVCInput ' + className,
    onChange: wrapEventHandler(onChange),
    onBlur: wrapEventHandler(onBlur),
    value: value,
    placeholderChar: ' '
  });
}

function Card(props) {
  var form = props.form,
      onCardTypeChange = props.onCardTypeChange,
      hasCardHandlingFee = props.hasCardHandlingFee,
      cardNameDefaultValue = props.cardNameDefaultValue;


  return jsx('fieldset', {}, void 0, jsx('legend', {}, void 0, t('checkout.card.legend')), jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: 'card.name',
    label: t('checkout.card.name'),
    defaultValue: cardNameDefaultValue,
    required: true
  }), jsx('div', {
    className: 'CheckoutFormCard-numbers'
  }, void 0, jsx('div', {
    className: 'CheckoutFormCard-number'
  }, void 0, jsx(Field$1, {
    form: form,
    component: Input,
    type: CardNumber,
    name: 'card.cardNumber',
    label: t('checkout.card.number'),
    onCardTypeChange: onCardTypeChange
  })), jsx('div', {
    className: 'CheckoutFormCard-expires'
  }, void 0, jsx(Field$1, {
    form: form,
    component: Input,
    type: CardExpiry,
    name: 'card.expiry',
    label: t('checkout.card.expiry')
  })), jsx('div', {
    className: 'CheckoutFormCard-cvc'
  }, void 0, jsx(Field$1, {
    form: form,
    component: Input,
    type: CVC,
    name: 'card.cvc',
    label: t('checkout.card.cvc')
  }))), hasCardHandlingFee && jsx('span', {
    className: 'CheckoutFormCard-fee'
  }, void 0, t('checkout.card.fee')));
}

var cardNameDefaultValue = function cardNameDefaultValue(getFormField, form) {
  return function () {
    var firstName = ifNotNull(getProp('value'), getFormField(form, 'customer.firstName'));
    var lastName = ifNotNull(getProp('value'), getFormField(form, 'customer.lastName'));
    return (String(firstName || '') + ' ' + String(lastName || '')).trim();
  };
};

var mapStateToProps$8 = function mapStateToProps$8() {
  var getFormField = makeGetFormField();

  return function (state, _ref) {
    var form = _ref.form;
    return {
      cardNameDefaultValue: cardNameDefaultValue(getFormField, form)
    };
  };
};

var Card$1 = reactRedux.connect(mapStateToProps$8)(Card);

function Billing(props) {
  var form = props.form,
      onCardTypeChange = props.onCardTypeChange,
      hasCardHandlingFee = props.hasCardHandlingFee;


  return jsx('fieldset', {
    className: 'CheckoutFormBilling'
  }, void 0, jsx(Card$1, {
    form: form,
    hasCardHandlingFee: hasCardHandlingFee,
    className: 'CheckoutFormBilling-card',
    onCardTypeChange: onCardTypeChange
  }), jsx(Address, {
    form: form,
    className: 'CheckoutFormBilling-address',
    type: 'billing'
  }));
}

function Customer(props) {
  var form = props.form;


  return jsx('fieldset', {
    className: 'CheckoutFormCustomer'
  }, void 0, jsx('legend', {}, void 0, t('checkout.customer.legend')), jsx('div', {
    className: 'row'
  }, void 0, jsx('div', {
    className: 'col-md-6'
  }, void 0, jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: 'customer.firstName',
    label: t('checkout.customer.firstName'),
    autoComplete: 'given-name',
    required: true
  })), jsx('div', {
    className: 'col-md-6'
  }, void 0, jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: 'customer.lastName',
    label: t('checkout.customer.lastName'),
    autoComplete: 'family-name',
    required: true
  }))), jsx(Field$1, {
    form: form,
    component: Input,
    type: 'text',
    name: 'customer.email',
    label: t('checkout.customer.email'),
    autoComplete: 'email',
    required: true
  }));
}

var _ref = jsx('legend', {}, void 0, 'Delivery address');

function Delivery(props) {
  var active = props.active,
      _props$isRequired = props.isRequired,
      isRequired = _props$isRequired === undefined ? false : _props$isRequired,
      form = props.form;


  return jsx('section', {
    className: 'CheckoutFormDelivery'
  }, void 0, jsx('div', {
    className: 'CheckoutFormDelivery-toggle'
  }, void 0, !isRequired && jsx(Field$1, {
    component: Checkbox,
    form: form,
    name: 'delivery.differentToBilling',
    validateOn: ['change', 'blur'],
    label: t('checkout.deliveryToggle'),
    className: 'CheckoutFormDelivery-toggle-checkbox'
  })), (isRequired || active) && jsx('fieldset', {}, void 0, _ref, jsx(Address, {
    form: form,
    withName: true,
    type: 'delivery'
  })));
}

var mapStateToProps$9 = function mapStateToProps$9() {
  var getFormField = makeGetFormField();

  return function (state, _ref2) {
    var form = _ref2.form;

    var differentToBilling = ifNotNull(getProp('value'), getFormField(state, { form: form, name: 'delivery.differentToBilling' }));

    return {
      active: toBool(differentToBilling)
    };
  };
};

var Delivery$1 = reactRedux.connect(mapStateToProps$9)(Delivery);

var preventDefault = function preventDefault(e) {
  e.preventDefault();
  return e;
};

function CheckoutFormPay(props) {
  var submitting = props.submitting,
      valid = props.valid,
      form = props.form,
      onSubmit = props.onSubmit;


  return jsx(LoadingButton, {
    className: 'CheckoutPayButton',
    onClick: onSubmit || compose$1(form.submit, preventDefault),
    disabled: !valid,
    loading: submitting,
    id: 'CheckoutPayButton'
  }, void 0, t('checkout.purchase'));
}

var Pay = withFormMeta(CheckoutFormPay);

var _ref$1 = jsx('div', {
  className: 'SpinnerCircular-circle'
});

function SpinnerCircular(props) {
  var _props$className = props.className,
      className = _props$className === undefined ? '' : _props$className;


  return jsx('div', {
    className: 'SpinnerCircular ' + className
  }, void 0, _ref$1);
}

function transformVendorMailingList(vendors) {
  return Object.keys(vendors).reduce(function (memo, id) {
    return _extends({}, memo, defineProperty({}, 'consents.vendorMailingLists.' + id, true));
  }, {});
}

var prefill = ['profiles.musicglue.dev', 'www-staging.musicglue.com', 'www-demo.musicglue.com', 'www.musicglue.dev'].includes(window.location.hostname);

var prefillBilling = {
  'billing.address1': 'House',
  'billing.address2': 'Road',
  'billing.city': 'London',
  'billing.state': 'London',
  'billing.postcode': 'SW1A 1AA',
  'card.cardNumber': '4242424242424242',
  'card.expiry': { month: 12, year: 2020 },
  'card.cvc': '123'
};

var prefillLocation = {
  'confirmLocation.city': 'London'
};

var getPrefills = function getPrefills(basket) {
  if (!prefill) return null;
  return _extends({
    'customer.firstName': 'Joe',
    'customer.lastName': 'Bloggs',
    'customer.email': 'joe-bloggs@comedyglue.com'
  }, billing(basket) ? prefillBilling : null, confirmLocation(basket) ? prefillLocation : null);
};

var _initialValues = (function (basket, vendors, paymentProviders) {
  var prefills = getPrefills(basket);

  if (!prefills) {
    return {
      paymentProvider: paymentProviders[0]
    };
  }

  return _extends({}, prefills, transformVendorMailingList(vendors), {
    'card.name': billing(basket) ? prefills['customer.firstName'] + ' ' + prefills['customer.lastName'] : undefined,
    'consents.mgMailingList': true,
    'delivery.name': delivery(basket) ? prefills['customer.firstName'] + ' ' + prefills['customer.lastName'] : undefined,
    paymentProvider: paymentProviders[0]
  });
});

var PAYPAL$1 = paymentProviders.PAYPAL;
var FREE$1 = paymentProviders.FREE;


var formatExpiry$1 = function formatExpiry$1(card) {
  if (!card || typeof card.year !== 'number' || typeof card.month !== 'number') {
    return '';
  }

  return card.year + '-' + card.month;
};

var makeFieldValueGetter = function makeFieldValueGetter(form) {
  return function (field) {
    return form.fields[field] ? form.fields[field].value : null;
  };
};

var trimString = compose$1(trim, String);

var address = function address(viewer, fieldValue, role) {
  var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : fieldValue(role + '.name');
  return {
    name: ifNotNull(trimString, name),
    line1: trimString(fieldValue(role + '.address1')),
    line2: ifNotNull(trimString, fieldValue(role + '.address2')),
    city: trimString(fieldValue(role + '.city')),
    state: ifNotNull(trimString, fieldValue(role + '.state')),
    postcode: ifNotNull(trimString, fieldValue(role + '.postcode')),
    country: viewer.country.code
  };
};

var card = function card(viewer, fieldValue) {
  return {
    name: trimString(fieldValue('card.name')),
    cardNumber: trimString(fieldValue('card.cardNumber')),
    expiryDate: formatExpiry$1(fieldValue('card.expiry')),
    cvc: trimString(fieldValue('card.cvc')),
    billingAddress: address(viewer, fieldValue, 'billing', fieldValue('card.name'))
  };
};

var customerDetails = function customerDetails(fieldValue) {
  return {
    firstName: trimString(fieldValue('customer.firstName')),
    lastName: trimString(fieldValue('customer.lastName')),
    email: trimString(fieldValue('customer.email'))
  };
};

var deliveryAddress = function deliveryAddress(viewer, fieldValue, paymentMethod) {
  if (paymentMethod === FREE$1) {
    var _customerDetails = customerDetails(fieldValue),
        firstName = _customerDetails.firstName,
        lastName = _customerDetails.lastName;

    var _name = firstName + ' ' + lastName;
    return address(viewer, fieldValue, 'confirmLocation', _name);
  }

  return paymentMethod === PAYPAL$1 || fieldValue('delivery.differentToBilling') ? address(viewer, fieldValue, 'delivery') : address(viewer, fieldValue, 'billing', fieldValue('card.name'));
};

var customer = function customer(viewer, fieldValue, paymentMethod) {
  return _extends({}, customerDetails(fieldValue), {
    deliveryAddress: deliveryAddress(viewer, fieldValue, paymentMethod)
  });
};

var vendorConsent = function vendorConsent(fieldValue, key, vendors) {
  return compact(Object.keys(vendors).map(function (id) {
    return fieldValue('consents.' + key + '.' + id) === true ? id : null;
  }));
};

var consent = function consent(fieldValue, vendors) {
  return {
    mgTermsAndConditions: toBool(fieldValue('consents.mgTermsAndConditions')),
    mgMailingList: toBool(fieldValue('consents.mgMailingList')),
    vendorTermsAndConditions: [], // TODO: something, probably? what is supposed to go here??
    vendorMailingLists: vendorConsent(fieldValue, 'vendorMailingLists', vendors)
  };
};

var getPayload$1 = (function (form, paymentMethod, viewer, vendors) {
  var getFieldValue = makeFieldValueGetter(form);

  return {
    card: card(viewer, getFieldValue),
    customer: customer(viewer, getFieldValue, paymentMethod),
    consent: consent(getFieldValue, vendors)
  };
});

var postCodeValidations = function postCodeValidations(form, type, viewer) {
  return COUNTRIES_WITHOUT_POSTCODES.has(viewer.country.code.toUpperCase()) ? null : field(form, type + '.postcode', [required]);
};

var stateValidations = function stateValidations(form, type, viewer) {
  return COUNTRIES_WITH_STATES.has(viewer.country.code.toUpperCase()) ? field(form, type + '.state', [required]) : null;
};

var cardNumber = function cardNumber(value) {
  return typeof value === 'string' && validateCardNumber(value) ? null : { type: 'cardNumber' };
};

var cardExpiry = function cardExpiry(value) {
  if (validateExpiry(getCardExpiry(value))) {
    return null;
  }
  return { type: 'cardExpiry' };
};

var isDeliveryRequired = function isDeliveryRequired(provider) {
  return getPaymentProviderProps(provider).shippingInfo === propertyStatusEnum.REQUIRED;
};

var isBillingRequired = function isBillingRequired(provider) {
  return getPaymentProviderProps(provider).billingInfo === propertyStatusEnum.REQUIRED;
};

var fieldValue = function fieldValue(form, field$$1) {
  return form.fields[field$$1] && form.fields[field$$1].value;
};

var formOptions$2 = {
  formIdentifier: function formIdentifier(_ref) {
    var id = _ref.context.id;
    return 'checkout.' + id;
  },
  initialValues: function initialValues(_ref2) {
    var basketOverview = _ref2.basketOverview,
        vendors = _ref2.vendors,
        enabledGateways = _ref2.enabledGateways;
    return _initialValues(basketOverview, vendors, getProviders(enabledGateways, basketOverview));
  },
  validate: function validate(form, _ref3) {
    var basketOverview = _ref3.basketOverview,
        basketCustomFields = _ref3.basketCustomFields,
        viewer = _ref3.viewer;
    return compact([field(form, 'customer.firstName', [required]), field(form, 'customer.lastName', [required]), field(form, 'customer.email', [required, email]), field(form, 'consents.mgTermsAndConditions', [required, accepted])].concat(toConsumableArray(when(billing(basketOverview) && isBillingRequired(String(fieldValue(form, 'paymentProvider'))), function () {
      return [field(form, 'billing.address1', [required]), field(form, 'billing.city', [required]), postCodeValidations(form, 'billing', viewer), stateValidations(form, 'billing', viewer), field(form, 'card.cardNumber', [required, cardNumber]), field(form, 'card.cvc', [required]), field(form, 'card.name', [required]), field(form, 'card.expiry', [required, cardExpiry])];
    })), toConsumableArray(when(delivery(basketOverview) && (isDeliveryRequired(String(fieldValue(form, 'paymentProvider'))) || fieldValue(form, 'delivery.differentToBilling') === true), function () {
      return [field(form, 'delivery.name', [required]), field(form, 'delivery.address1', [required]), field(form, 'delivery.city', [required]), postCodeValidations(form, 'delivery', viewer), stateValidations(form, 'delivery', viewer)];
    })), toConsumableArray(when(confirmLocation(basketOverview), function () {
      return [field(form, 'confirmLocation.city', [required])];
    })), toConsumableArray(getCustomFields(basketCustomFields).map(serialiseCustomField).map(function (fieldName) {
      return field(form, fieldName, [required]);
    }))));
  },
  submit: function submit(form, _ref4) {
    var onSubmit = _ref4.onSubmit,
        viewer = _ref4.viewer,
        vendors = _ref4.vendors;
    return onSubmit(form, getPayload$1(form, String(form.fields.paymentProvider.value), viewer, vendors));
  }
};

var _ref5 = jsx(SpinnerCircular, {
  className: 'CheckoutSpinner'
});

function CheckoutForm(props) {
  var basketCustomFields = props.basketCustomFields,
      basketOverview = props.basketOverview,
      cardHandlingFee = props.basketOverview.cardHandlingFee,
      basketQuantities = props.basketQuantities,
      enabledGateways = props.enabledGateways,
      form = props.form,
      onCardTypeChange = props.onCardTypeChange,
      paymentProvider = props.paymentProvider,
      submitSuccess = props.submitSuccess,
      submitting = props.submitting,
      vendors = props.vendors;


  var showSpinner = submitting || !!submitSuccess;

  if (Object.keys(basketQuantities).length === 0 && !showSpinner) {
    return jsx('div', {
      className: 'EmptySection EmptyCheckout'
    }, void 0, t('checkout.nothingInBasket'));
  }

  return jsx('div', {
    className: cx('Checkout', { Checkout_loading: showSpinner })
  }, void 0, _ref5, jsx('div', {
    className: 'CheckoutForm'
  }, void 0, jsx('form', {
    className: 'CheckoutForm-form'
  }, void 0, jsx(Customer, {
    form: form
  }), jsx(CheckoutCustomFields, {
    form: form,
    basketCustomFields: basketCustomFields
  }), jsx(BillingMethodChooser, {
    form: form,
    name: 'paymentProvider',
    providers: getProviders(enabledGateways, basketOverview),
    selected: paymentProvider
  }, void 0, jsx(Billing, {
    propName: 'billingInfo',
    shouldRender: billing(basketOverview),
    onCardTypeChange: onCardTypeChange,
    form: form,
    hasCardHandlingFee: cardHandlingFee.amount.cents > 0
  }), jsx(Delivery$1, {
    propName: 'shippingInfo',
    shouldRender: delivery(basketOverview),
    form: form
  }), jsx(ConfirmLocation, {
    propName: 'locationInfo',
    shouldRender: confirmLocation(basketOverview),
    form: form
  })), jsx(Consent, {
    form: form,
    vendors: vendors
  }), jsx(Pay, {
    form: form
  }))));
}

var mapStateToProps$6 = function mapStateToProps$6() {
  var getFormField = makeGetFormField();

  return function (state, _ref6) {
    var form = _ref6.form;

    var paymentProvider = getFormField(state, { form: form, name: 'paymentProvider' });

    return { paymentProvider: paymentProvider ? String(paymentProvider.value) : null };
  };
};

var CheckoutForm$1 = implicitForm(withFormMeta(reactRedux.connect(mapStateToProps$6)(CheckoutForm)), formOptions$2);

var TouchBasket = function (_Mutation) {
  inherits(TouchBasket, _Mutation);

  function TouchBasket() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, TouchBasket);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = TouchBasket.__proto__ || Object.getPrototypeOf(TouchBasket)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'TouchBasket', _this.mutation = 'touchBasket', _this.query = '__typename', _this.invalidateQueries = function () {
      return [];
    }, _this.invalidatePartials = function () {
      return [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return TouchBasket;
}(Mutation);

var onDismiss$1 = function onDismiss$1() {
  return dispatch(fireMutation(new TouchBasket({}))).then(function () {
    return dispatch(dismissModal$1());
  });
};

function PricesChangedModal(_ref) {
  var title = _ref.title,
      content = _ref.content;

  return jsx(SimpleModal, {
    title: title,
    content: content,
    onDismiss: onDismiss$1
  });
}

var INITIATE_CHECKOUT = trackingEvents.INITIATE_CHECKOUT;
var CHECKOUT$1 = trackingEvents.CHECKOUT;


var authorizeAndValidateBasket = function authorizeAndValidateBasket(dispatch$$1) {
  return dispatch$$1(fireMutation(new AuthorizeBasketMutation({}))).then(function (_ref) {
    var basketItemsRemoved = _ref.basketItemsRemoved;

    if (!basketItemsRemoved) return;

    dispatch$$1(showModal$1(SimpleModal, { content: t('basket.itemsRemoved') }));
  }).then(function () {
    return dispatch$$1(fireMutation(new ValidateBasketPricesMutation({})));
  }).then(function (_ref2) {
    var somethingChanged = _ref2.somethingChanged;

    if (!somethingChanged) return;

    dispatch$$1(showModal$1(PricesChangedModal, { content: t('basket.priceChanged') }));
  });
};

var Checkout = function Checkout(_ref3) {
  var context = _ref3.context,
      props = objectWithoutProperties(_ref3, ['context']);
  return React.createElement(CheckoutForm$1, _extends({}, context.props, props, { context: context }));
};

var mapStateToProps$4 = function mapStateToProps$4(state) {
  return {
    viewer: state.config.viewer,
    websiteMode: state.config.profile.websiteMode,
    profileName: state.config.profile.slug
  };
};

var mapDispatchToProps$3 = function mapDispatchToProps$3(dispatch$$1) {
  return {
    onCardTypeChange: function onCardTypeChange(cardType) {
      return dispatch$$1(fireMutation(new ChangeCardTypeMutation({ cardType: cardType })));
    },
    onSubmit: function onSubmit(form, payload) {
      return authorizeAndValidateBasket(dispatch$$1).then(function () {
        return dispatch$$1(fireMutation(new ExtendReservationMutation({})));
      }).then(function () {
        return dispatch$$1(fireMutation(new UpdateCustomFieldsMutation(formatCustomFields(form))));
      }).then(function () {
        var _getState = getState(),
            _getState$config$prof = _getState.config.profile,
            websiteMode = _getState$config$prof.websiteMode,
            profileName = _getState$config$prof.slug;

        var _getPaymentProviderPr = getPaymentProviderProps(String(form.fields.paymentProvider.value)),
            checkoutFlow = _getPaymentProviderPr.checkoutFlow;

        return checkoutFlow(payload, { websiteMode: websiteMode, profileName: profileName }).then(tap$1(function (_ref4) {
          var completedBasket = _ref4.completedBasket;

          // When checking out using Paypal Express, we won't receive the basket yet
          if (completedBasket) {
            track$1({
              name: CHECKOUT$1,
              event: {
                basket: completedBasket,
                profile: profileName
              }
            });
          }
        })).catch(function (error) {
          var checkoutError = hasOwnProperty(CHECKOUT_OUTCOMES, error.message) ? error.message : CHECKOUT_OUTCOMES.ORDER_COULD_NOT_BE_SUBMITTED;

          dispatch$$1(showModal$1(SimpleModal, {
            title: t('alerts.titles.error'),
            content: t('checkout.errors.' + checkoutError)
          }));

          throw error;
        });
      });
    }
  };
};

var queries$2 = {
  basketOverview: basketOverviewQuery,
  basketQuantities: basketLineQuantitiesQuery,
  basketCustomFields: basketCustomFieldsQuery
};

var Checkout$1 = withContext({
  checkout: readyOnGraphData(withTracking(withQueries$1(reactRedux.connect(mapStateToProps$4, mapDispatchToProps$3)(Checkout), queries$2), tracker({ name: INITIATE_CHECKOUT })))
});

var ConfirmLocationMutation = function (_Mutation) {
  inherits(ConfirmLocationMutation, _Mutation);

  function ConfirmLocationMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ConfirmLocationMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ConfirmLocationMutation.__proto__ || Object.getPrototypeOf(ConfirmLocationMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'ConfirmLocation', _this.mutation = 'confirmLocation', _this.query = 'nextStep,urls{files{author,fileName,fileSize,formats{id,mimeType,url},id,title},product{error,result{description,id,name}}}', _this.invalidateQueries = function () {
      return [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return ConfirmLocationMutation;
}(Mutation);

var readyImmediate = createHOC('readyImmediate', function (Component) {
  return function (_React$Component) {
    inherits(_class, _React$Component);

    function _class() {
      classCallCheck(this, _class);
      return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.onReady();
      }
    }, {
      key: 'render',
      value: function render() {
        return React.createElement(Component, omit(this.props, ['onReady']));
      }
    }]);
    return _class;
  }(React.Component);
});

var formIdentifier$3 = function formIdentifier$3(_ref) {
  var context = _ref.context;
  return 'confirmLocationForm.' + context.id;
};

var formOptions$3 = {
  formIdentifier: formIdentifier$3,

  initialValues: function initialValues(_ref2) {
    var city = _ref2.context.props.city;
    return {
      city: city
    };
  },

  validate: function validate(form) {
    return [field(form, 'city', [required])];
  },

  submit: function submit(_ref3, props) {
    var city = _ref3.fields.city;
    var country = props.country,
        profileId = props.profileId,
        onSubmit = props.onSubmit,
        onConfirmedDownload = props.onConfirmedDownload,
        onConfirmedMailing = props.onConfirmedMailing,
        onMissingToken = props.onMissingToken,
        onSubmitError = props.onSubmitError,
        _props$context$props = props.context.props,
        token = _props$context$props.token,
        redirectPath = _props$context$props.redirectPath;


    if (!profileId || !city || typeof city.value !== 'string' || !country) return Promise.reject();

    return onSubmit({ city: city.value, country: country, profileId: profileId, token: token }).then(function (response) {
      var nextStep = response.nextStep,
          urls = response.urls;


      track$2({ name: trackingEvents.CONFIRM_LOCATION });

      if (nextStep === 'download') onConfirmedDownload(urls.files, redirectPath);else if (nextStep === 'mailing') onConfirmedMailing(redirectPath);else if (nextStep === 'missing') onMissingToken();else throw new Error('Unhandled confirm location code: \'' + nextStep + '\'');
    }).catch(function () {
      return onSubmitError();
    });
  }
};

var mapStateToProps$10 = function mapStateToProps$10(state) {
  return {
    profileId: state.config.profile.uuid,
    country: state.config.viewer.country.code
  };
};

var mapDispatchToProps$6 = function mapDispatchToProps$6(dispatch) {
  return {
    onSubmit: function onSubmit(input) {
      return dispatch(fireMutation(new ConfirmLocationMutation(input)));
    },
    // FIXME: handle mailing/download in error as well
    onSubmitError: function onSubmitError() {
      return dispatch(showModal$1(SimpleModal, { content: t('freeDownload.failure') }));
    },
    onConfirmedDownload: function onConfirmedDownload(files, redirectPath) {
      breakwater.navigation.navigate(redirectPath);

      dispatch(showModal$1(PartialModal, { name: 'free_download_success', query: { files: files } }));
    },
    onConfirmedMailing: function onConfirmedMailing(redirectPath) {
      breakwater.navigation.navigate(redirectPath);
      dispatch(showModal$1(SimpleModal, { content: t('mailingList.success') }));
    },
    onMissingToken: function onMissingToken() {
      return dispatch(showModal$1(SimpleModal, {
        content: t('confirmLocation.missingToken.message'),
        title: t('confirmLocation.missingToken.title')
      }));
    }
  };
};

var confirmLocation$1 = (function (Component) {
  return readyImmediate(reactRedux.connect(mapStateToProps$10, mapDispatchToProps$6)(implicitForm(Component, formOptions$3)));
});

function CityInput(props) {
  var form = props.form,
      _props$label = props.label,
      label = _props$label === undefined ? t('confirmLocation.city') : _props$label;


  return jsx(Field$1, {
    form: form,
    name: 'city',
    component: Input,
    type: 'text',
    label: label,
    validateOn: 'change'
  });
}

var CityInput$1 = withContext({
  confirmLocation: confirmLocation$1(CityInput)
});

var ApplyToPlaySignupMutation = function (_Mutation) {
  inherits(ApplyToPlaySignupMutation, _Mutation);

  function ApplyToPlaySignupMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ApplyToPlaySignupMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ApplyToPlaySignupMutation.__proto__ || Object.getPrototypeOf(ApplyToPlaySignupMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'RequestToPerform', _this.mutation = 'requestToPerform', _this.query = 'result', _this.invalidateQueries = function () {
      return [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return ApplyToPlaySignupMutation;
}(Mutation);

var formIdentifier$4 = function formIdentifier$4(_ref) {
  var context = _ref.context;
  return 'applyToPlaySignup.' + context.id;
};

var formOptions$4 = {
  formIdentifier: formIdentifier$4,

  validate: function validate(form) {
    return [field(form, 'email', [required, email])];
  },

  submit: function submit(form, props) {
    var profileId = props.profileId,
        onSubmit = props.onSubmit,
        modalClass = props.modal_class,
        onSubmitSuccess = props.onSubmitSuccess,
        onSubmitError = props.onSubmitError;

    var emailField = form.fields.email;

    if (!profileId || !emailField || typeof emailField.value !== 'string') return Promise.reject();

    return onSubmit({ emailAddress: emailField.value, entityId: profileId }).then(function (_ref2) {
      var result = _ref2.result;

      if (result) {
        onSubmitSuccess(modalClass);
        track$2({ name: trackingEvents.APPLY_TO_PLAY_SIGNUP });
      } else {
        onSubmitError(modalClass);
      }
    }).catch(function () {
      onSubmitError(modalClass);
    });
  }
};

var mapStateToProps$11 = function mapStateToProps$11(state) {
  return {
    profileId: state.config.profile.uuid
  };
};

var mapDispatchToProps$7 = function mapDispatchToProps$7(dispatch) {
  return {
    onSubmit: function onSubmit(input) {
      return dispatch(fireMutation(new ApplyToPlaySignupMutation(input)));
    },

    onSubmitSuccess: function onSubmitSuccess(className) {
      return dispatch(showModal$1(SimpleModal, { content: t('applyToPlay.success'), className: className }));
    },

    onSubmitError: function onSubmitError(className) {
      return dispatch(showModal$1(SimpleModal, { content: t('applyToPlay.failure'), className: className }));
    }
  };
};

var applyToPlaySignup = (function (Component) {
  return readyImmediate(reactRedux.connect(mapStateToProps$11, mapDispatchToProps$7)(implicitForm(Component, formOptions$4)));
});

var FreeDownloadRequestMutation = function (_Mutation) {
  inherits(FreeDownloadRequestMutation, _Mutation);

  function FreeDownloadRequestMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, FreeDownloadRequestMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = FreeDownloadRequestMutation.__proto__ || Object.getPrototypeOf(FreeDownloadRequestMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'FreeDownloadRequest', _this.mutation = 'freeDownloadRequest', _this.query = 'status,urls{product{error,result{id}},files{id,fileName,title,author,fileSize,formats{id,mimeType,url}}}', _this.invalidateQueries = function () {
      return [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return FreeDownloadRequestMutation;
}(Mutation);

var formIdentifier$5 = function formIdentifier$5(_ref) {
  var context = _ref.context;
  return 'freeDownloadRequest.' + context.id;
};

var formOptions$5 = {
  formIdentifier: formIdentifier$5,

  validate: function validate(form) {
    return [field(form, 'email', [required, email])];
  },

  submit: function submit(form, props) {
    var onSubmit = props.onSubmit,
        onSubmitError = props.onSubmitError,
        onConfirmed = props.onConfirmed,
        onUnconfirmed = props.onUnconfirmed,
        callbackUrl = props.callbackUrl;
    var productId = props.context.props.productId;

    var emailField = form.fields.email;

    if (!productId || !emailField || typeof emailField.value !== 'string') return Promise.reject();

    return onSubmit({ callbackUrl: callbackUrl, email: emailField.value, productId: productId }).then(function (_ref2) {
      var status = _ref2.status,
          urls = _ref2.urls;

      if (status === 'proceed') {
        onConfirmed(urls.files);
      } else {
        onUnconfirmed();
        track$2({ name: trackingEvents.MAILING_LIST_SUBSCRIBE });
      }
    }).catch(function () {
      return onSubmitError();
    });
  }
};

var mapDispatchToProps$8 = function mapDispatchToProps$8(dispatch) {
  return {
    onSubmit: function onSubmit(input) {
      return dispatch(fireMutation(new FreeDownloadRequestMutation(input)));
    },
    onSubmitError: function onSubmitError() {
      return dispatch(replaceModal(SimpleModal, { content: t('mailingList.failure') }));
    },
    onUnconfirmed: function onUnconfirmed() {
      return dispatch(replaceModal(SimpleModal, { content: t('freeDownload.confirm') }));
    },
    onConfirmed: function onConfirmed(files) {
      return dispatch(replaceModal(PartialModal, {
        name: 'free_download_success',
        query: { files: files }
      }));
    }
  };
};

var freeDownloadRequest = (function (Component) {
  return readyImmediate(reactRedux.connect(null, mapDispatchToProps$8)(implicitForm(Component, formOptions$5)));
});

var LoginMutation = function (_Mutation) {
  inherits(LoginMutation, _Mutation);

  function LoginMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, LoginMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = LoginMutation.__proto__ || Object.getPrototypeOf(LoginMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'UserLogin', _this.mutation = 'login', _this.query = 'result', _this.invalidateQueries = function () {
      return [];
    }, _this.after = function (_ref2, dispatch) {
      var result = _ref2.result;

      if (result) {
        window.redirectPending = true;
        var currentLocation = window.location.pathname;
        window.location = currentLocation.replace(/\/login$/, '');
      } else {
        dispatch(showModal$1(SimpleModal, { content: t('login.invalid') }));
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return LoginMutation;
}(Mutation);

var getPayload$2 = function getPayload$2(form) {
  var getFieldValue = function getFieldValue(key) {
    return form.fields[key] ? form.fields[key].value : null;
  };

  return {
    emailAddress: getFieldValue('email'),
    password: getFieldValue('password')
  };
};

var formIdentifier$6 = function formIdentifier$6(_ref) {
  var id = _ref.context.id;
  return 'login.' + id;
};

var formOptions$6 = {
  formIdentifier: formIdentifier$6,

  validate: function validate(form) {
    return [field(form, 'email', [required, email]), field(form, 'password', [required])];
  },

  submit: function submit(form, _ref2) {
    var onSubmit = _ref2.onSubmit;
    return onSubmit(getPayload$2(form));
  }
};

var mapStateToProps$12 = function mapStateToProps$12() {
  return function (state) {
    return { viewer: state.config.viewer };
  };
};

var mapDispatchToProps$9 = function mapDispatchToProps$9(dispatch) {
  return {
    onSubmit: function onSubmit(payload) {
      return dispatch(fireMutation(new LoginMutation(payload)));
    }
  };
};

var login = (function (Component) {
  return readyImmediate(reactRedux.connect(mapStateToProps$12, mapDispatchToProps$9)(implicitForm(Component, formOptions$6)));
});

var MailingListSignupMutation = function (_Mutation) {
  inherits(MailingListSignupMutation, _Mutation);

  function MailingListSignupMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, MailingListSignupMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = MailingListSignupMutation.__proto__ || Object.getPrototypeOf(MailingListSignupMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'MailingListSignup', _this.mutation = 'mailingListSignup', _this.query = 'status', _this.invalidateQueries = function () {
      return [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return MailingListSignupMutation;
}(Mutation);

var formIdentifier$7 = function formIdentifier$7(_ref) {
  var context = _ref.context;
  return 'mailingListSignup.' + context.id;
};

var formOptions$7 = {
  formIdentifier: formIdentifier$7,

  validate: function validate(form) {
    return [field(form, 'email', [required, email])];
  },

  submit: function submit(form, props) {
    var profileId = props.profileId,
        onSubmit = props.onSubmit,
        onSubmitSuccess = props.onSubmitSuccess,
        onSubmitError = props.onSubmitError,
        callbackUrl = props.callbackUrl;

    var emailField = form.fields.email;

    if (!profileId || !emailField || typeof emailField.value !== 'string') return Promise.reject();

    return onSubmit({ signup: { callbackUrl: callbackUrl, email: emailField.value, profileId: profileId } }).then(function (_ref2) {
      var status = _ref2.status;

      onSubmitSuccess(status === 'subscribed' ? 'success' : 'emailSent');
      track$2({ name: trackingEvents.MAILING_LIST_SUBSCRIBE });
    }).catch(function () {
      onSubmitError();
    });
  }
};

var mapStateToProps$13 = function mapStateToProps$13(state) {
  return {
    profileId: state.config.profile.uuid
  };
};

var mapDispatchToProps$10 = function mapDispatchToProps$10(dispatch) {
  return {
    onSubmit: function onSubmit(input) {
      return dispatch(fireMutation(new MailingListSignupMutation(input)));
    },

    onSubmitSuccess: function onSubmitSuccess(type) {
      return dispatch(showModal$1(SimpleModal, { content: t('mailingList.' + type) }));
    },

    onSubmitError: function onSubmitError() {
      return dispatch(showModal$1(SimpleModal, { content: t('mailingList.failure') }));
    }
  };
};

var mailingListSignup = (function (Component) {
  return readyImmediate(reactRedux.connect(mapStateToProps$13, mapDispatchToProps$10)(implicitForm(Component, formOptions$7)));
});

function EmailInput(props) {
  var form = props.form,
      label = props.label;


  return jsx(Field$1, {
    form: form,
    name: 'email',
    component: Input,
    type: 'email',
    label: label != null ? label : t('email.label'),
    validateOn: 'change'
  });
}

var EmailInput$1 = withContext({
  applyToPlay: applyToPlaySignup(EmailInput),
  mailingList: mailingListSignup(EmailInput),
  product: freeDownloadRequest(EmailInput),
  login: login(EmailInput)
});

var scriptCache = {};

var doLoad = function doLoad(scriptUrl) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;

    script.onload = function () {
      return resolve();
    };
    script.onerror = function () {
      reject();
      scriptCache[scriptUrl] = null;
    };

    document.body.appendChild(script);
  });
};

var loadScript = function loadScript(scriptUrl) {
  if (!scriptCache[scriptUrl]) {
    scriptCache[scriptUrl] = doLoad(scriptUrl);
  }

  return scriptCache[scriptUrl];
};

var asyncScriptLoader = createHOC('AsyncScriptLoader', function (Component, _ref) {
  var scriptUrl = _ref.scriptUrl,
      globalName = _ref.globalName;
  return function (_React$Component) {
    inherits(AsyncScriptLoader, _React$Component);

    function AsyncScriptLoader() {
      var _ref2;

      var _temp, _this, _ret;

      classCallCheck(this, AsyncScriptLoader);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = AsyncScriptLoader.__proto__ || Object.getPrototypeOf(AsyncScriptLoader)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { loaded: false }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(AsyncScriptLoader, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        loadScript(scriptUrl).then(function () {
          return _this2.setState({ loaded: true });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        if (!this.state.loaded) return null;

        var childProps = _extends({}, this.props, defineProperty({}, globalName, window[globalName]));

        return React.createElement(Component, childProps);
      }
    }]);
    return AsyncScriptLoader;
  }(React.Component);
});

// Stub raf:

if (!window.requestAnimationFrame) window.requestAnimationFrame = function (fn) {
  return setTimeout(fn, 16);
};

var callbacks = {};
var waiting = false;

var tick = function tick() {
  if (waiting) {
    values(callbacks).forEach(function (_ref) {
      var fn = _ref.fn,
          args = _ref.args;
      return typeof fn === 'function' && fn.apply(undefined, toConsumableArray(args));
    });
    callbacks = {};
    waiting = false;
  }
  window.requestAnimationFrame(tick);
};

tick();

var idCounter$3 = 0;
var rafDebounce = (function (fn) {
  var id = idCounter$3 += 1;
  var debounced = function debounced() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    callbacks['' + id] = { fn: fn, args: args };
    waiting = true;
  };

  return debounced;
});

var teleportTarget = document.createElement('div');
document.body.appendChild(teleportTarget);

var getSize = function getSize(element) {
  var top = element.offsetTop;
  var left = element.offsetLeft;
  var width = element.offsetWidth;
  var height = element.offsetHeight;

  var offsetParent = element.offsetParent;
  while (offsetParent && offsetParent instanceof HTMLElement) {
    top += offsetParent.offsetTop;
    left += offsetParent.offsetLeft;
    offsetParent = offsetParent.offsetParent || null;
  }

  return { top: top, left: left, width: width, height: height };
};

var Teleport = function (_React$Component) {
  inherits(Teleport, _React$Component);

  function Teleport() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Teleport);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Teleport.__proto__ || Object.getPrototypeOf(Teleport)).call.apply(_ref, [this].concat(args))), _this), _this.sync = rafDebounce(function () {
      var teleported = _this.teleported;
      var target = _this.target;
      if (!teleported || !target) return;

      var size = getSize(target);

      teleported.style.width = size.width + 'px';
      teleported.style.position = 'absolute';
      teleported.style.overflow = 'hidden';
      teleported.style.top = size.top + 'px';
      teleported.style.left = size.left + 'px';

      target.style.height = teleported.offsetHeight + 'px';

      if (_this.props.onSync) _this.props.onSync(size.width);
    }), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Teleport, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var children = this.props.children;
      if (!children) return;

      var teleported = document.createElement('div');
      ReactDOM.render(children, teleported);
      teleportTarget.appendChild(teleported);

      this.teleported = teleported;

      this.sync();
      this.syncTimer = setInterval(this.sync, 300);
      window.addEventListener('resize', this.sync);
    } // eslint-disable-line react/sort-comp

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.children && this.teleported) {
        ReactDOM.render(this.props.children, this.teleported);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var teleported = this.teleported;

      clearInterval(this.syncTimer);
      window.removeEventListener('resize', this.sync);

      if (teleported) {
        ReactDOM.unmountComponentAtNode(teleported);
        if (teleported.parentNode) teleported.parentNode.removeChild(teleported);
        this.teleported = this.target = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { ref: function ref(c) {
            _this2.target = c;
          } },
        ' '
      );
    }
  }]);
  return Teleport;
}(React.Component);

var fbKey = process.env.NODE_ENV === 'production' ? '477662122297015' : '300042960097930';
var scriptUrl = 'https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v2.8&appId=' + fbKey;

var Facebook = function (_React$Component) {
  inherits(Facebook, _React$Component);

  function Facebook() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Facebook.__proto__ || Object.getPrototypeOf(Facebook)).call.apply(_ref, [this].concat(args))), _this), _this.state = { width: 200 }, _this.updateFb = debounce(500, function () {
      if (_this.props.FB) _this.props.FB.XFBML.parse();
    }), _this.handleSync = function (width) {
      if (width !== _this.state.width) {
        _this.setState({ width: width });
        _this.updateFb();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  } // eslint-disable-line react/sort-comp


  createClass(Facebook, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.FB) {
        setTimeout(this.updateFb);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.FB !== nextProps.FB) {
        setTimeout(this.updateFb);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          username = _props.username,
          height = _props.height;


      return jsx(Teleport, {
        onSync: this.handleSync
      }, void 0, jsx('div', {
        className: 'fb-page',
        'data-href': 'https://facebook.com/' + username,
        'data-adapt-container-width': 'true',
        'data-tabs': 'timeline,events,messages',
        'data-height': height || 260,
        'data-width': this.state.width,
        style: { display: 'block' }
      }));
    }
  }]);
  return Facebook;
}(React.Component);

var Facebook$1 = readyImmediate(asyncScriptLoader(Facebook, {
  scriptUrl: scriptUrl,
  globalName: 'FB'
}));

var GatewayReceptionMutation = function (_Mutation) {
  inherits(GatewayReceptionMutation, _Mutation);

  function GatewayReceptionMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, GatewayReceptionMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = GatewayReceptionMutation.__proto__ || Object.getPrototypeOf(GatewayReceptionMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'GatewayReceptionCheckout', _this.mutation = 'gatewayReceptionCheckout', _this.query = 'outcome,successful,completedBasket{friendlyOrderId,id,lines{product{error,result{id,name}},quantity},overview{totalPrice{amount{cents,currency}}},uuid}', _this.invalidateQueries = function (_, queryIds) {
      return [].concat(toConsumableArray(queryIds.filter(match(/^basket\./))));
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return GatewayReceptionMutation;
}(Mutation);

var EMPTY_QUERY = new Map();

var KEY_VALUE = /^([^=]+)=(.*)$/;
var KEY_ONLY = /^([^=]+)$/;
var ALL_PLUSES = /\+/g;
var SPLIT_CHARS = /\?|&/;

var takeUntil = function takeUntil(_ref, v) {
  var _ref2 = toArray(_ref),
      f = _ref2[0],
      fs = _ref2.slice(1);

  return f ? f(v) || takeUntil(fs, v) : null;
};

var matchers = [function (v) {
  var matches = v.match(KEY_VALUE);
  if (!matches) return null;
  return [matches[1], matches[2]];
}, function (v) {
  var matches = v.match(KEY_ONLY);
  if (!matches) return null;
  return [matches[1], true];
}];

var urlDecode = function urlDecode(v) {
  return typeof v !== 'string' ? v : decodeURIComponent(v).replace(ALL_PLUSES, ' ');
};

var parseQuery = memoize(function (queryString) {
  return queryString.length === 0 ? EMPTY_QUERY : queryString.split(SPLIT_CHARS).filter(identity).reduce(function (args, arg) {
    var match$$1 = takeUntil(matchers, arg);
    if (match$$1) {
      var _match = slicedToArray(match$$1, 2),
          name = _match[0],
          value = _match[1];

      if (args.has(name)) {
        args.set(name, [].concat(args.get(name)).concat([urlDecode(value)]));
      } else {
        args.set(name, value);
      }
    }
    return args;
  }, new Map());
});

var getParameterByName = function getParameterByName(name) {
  var queryString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;
  return parseQuery(queryString).get(name);
};

var getParametersByName = function getParametersByName(names) {
  return names.map(function (name) {
    return getParameterByName(name);
  });
};

/* eslint-disable react/sort-comp */
var _ref$2 = jsx('div', {
  className: 'GatewayReception'
}, void 0, jsx(SpinnerCircular, {
  className: 'GatewayReceptionSpinner'
}));

var GatewayReception = function (_React$Component) {
  inherits(GatewayReception, _React$Component);

  function GatewayReception() {
    classCallCheck(this, GatewayReception);
    return possibleConstructorReturn(this, (GatewayReception.__proto__ || Object.getPrototypeOf(GatewayReception)).apply(this, arguments));
  }

  createClass(GatewayReception, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var complete = this.props.context.props.basket.complete;


      if (!complete) {
        this.finaliseCheckout.apply(this, toConsumableArray(getParametersByName(['PayerID', 'paymentId', 'token'])));
      }
    }
  }, {
    key: 'finaliseCheckout',
    value: function finaliseCheckout(PayerID, paymentId, token) {
      if (!PayerID || !paymentId || !token) {
        throw new Error('Expected to receive PayerId, paymentId and token');
      }

      var _props = this.props,
          onReceivedResponse = _props.onReceivedResponse,
          profileName = _props.profileName;


      return onReceivedResponse(PayerID, paymentId, token).then(function (response) {
        var outcome = response.outcome,
            successful = response.successful,
            completedBasket = response.completedBasket;


        if (!successful) throw new Error(outcome);

        track$1({
          name: trackingEvents.CHECKOUT,
          event: {
            basket: completedBasket,
            profile: profileName
          }
        });

        window.location.href = window.PROFILE_URL + '/receipt/' + completedBasket.uuid;

        return response;
      }).catch(function (err) {
        window.Bugsnag.notify(err, err.name + ':' + err.message);
        window.location.href = window.PROFILE_URL + '/checkout/?error=' + err.message;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var complete = this.props.context.props.basket.complete;


      if (complete) {
        return jsx('div', {}, void 0, t('checkout.alreadyCheckedOut'));
      }

      return _ref$2;
    }
  }]);
  return GatewayReception;
}(React.Component);

var queries$3 = {
  basketOverview: basketOverviewQuery
};

var mapStateToProps$14 = function mapStateToProps$14(state) {
  return {
    profileName: state.config.profile.slug,
    websiteMode: state.config.profile.websiteMode
  };
};

var mapDispatchToProps$11 = function mapDispatchToProps$11(dispatch, props) {
  return {
    onReceivedResponse: function onReceivedResponse(PayerID, paymentId, token) {
      return dispatch(fireMutation(new GatewayReceptionMutation({
        basketId: props.context.props.basket.id,
        PayerID: String(PayerID),
        paymentId: String(paymentId),
        token: String(token)
      })));
    }
  };
};

var GatewayReception$1 = withContext({
  checkout: readyOnGraphData(withQueries$1(reactRedux.connect(mapStateToProps$14, mapDispatchToProps$11)(GatewayReception), queries$3))
});

function EmbedIFrame(_ref) {
  var src = _ref.src,
      height = _ref.height;

  return jsx(Teleport, {}, void 0, jsx('iframe', {
    src: src,
    width: '100%',
    height: height,
    scrolling: 'no',
    frameBorder: 'no',
    allowTransparency: 'true'
  }));
}

var GoogleMap = readyImmediate(withProps$1(EmbedIFrame, function (_ref) {
  var q = _ref.q,
      apiKey = _ref.apiKey,
      height = _ref.height;
  return {
    src: 'https://www.google.com/maps/embed/v1/place?key=' + apiKey + '&q=' + encodeURIComponent(q),
    height: height || 300
  };
}));

function formatDateTz(date, tzOffsetMinutes, options) {
  var currentOffsetMinutes = date.getTimezoneOffset();
  var t = date.getTime();
  var offset = (tzOffsetMinutes + currentOffsetMinutes) * 60 * 1000;
  var tzDate = new Date(t + offset);

  return new Intl.DateTimeFormat(window.LOCALE.code, options).format(tzDate);
}

var withCurrentGroup = (function (Component) {
  return withProps$1(Component, function (_ref) {
    var context = _ref.context,
        groups = _ref.groups;

    if (context.child && context.child.type === 'group') {
      return { group: groups[context.child.props.groupId] };
    }

    return null;
  });
});

var isInStock = function isInStock(stockable) {
  return !!stockable.stock.result && stockable.stock.result.status.result === STOCK_AVAILABLE;
};

var stockRemaining = function stockRemaining(stockable) {
  if (!isInStock(stockable)) return 0;

  var remaining = stockable.stock.result && stockable.stock.result.remaining.result;

  return typeof remaining === 'number' ? remaining : Infinity;
};

var stockResponse = function stockResponse(product) {
  return isInStock(product) ? '' : t('soldOut');
};

var ticketDetails = function ticketDetails(product) {
  if (product.type !== 'Ticket' || !product.event) return '';

  var _product$event = product.event,
      eventError = _product$event.error,
      event = _product$event.result;


  if (eventError) return '';

  var eventName = event.name,
      doorsOpen = event.doorsOpen,
      performances = event.performances,
      venue = event.venue,
      timezoneOffset = event.timezoneOffset;
  var city = venue.address.city,
      venueName = venue.name;

  var options = { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
  var date = formatDateTz(new Date(doorsOpen), timezoneOffset, options);
  var eventTitle = eventName || performances[0].name;
  var title = compact([date, eventTitle]).join(' ');
  var location = compact([venueName, city]).join(', ');

  return t('events.tickets.description', { title: title, location: location });
};

var defaultOption = { label: t('bundle.complex'), value: INITIAL_VALUE };

var formatProductLabel = function formatProductLabel(product) {
  var elements = [ticketDetails(product), product.name, stockResponse(product)];

  return compact(elements).join(' - ');
};

var assembleOptions = function assembleOptions(products) {
  return [defaultOption].concat(toConsumableArray(products.map(function (product) {
    return {
      label: formatProductLabel(product),
      value: product.id,
      disabled: !isInStock(product)
    };
  })));
};

function GroupSelect(props) {
  var form = props.form,
      group = props.group,
      label = props.label;


  return jsx(Field$1, {
    form: form,
    name: 'group.' + group.id + '.selectedProduct',
    component: SelectInput,
    label: label != null ? label : group.name,
    options: assembleOptions(group.products),
    validateOn: 'change'
  });
}

var GroupSelect$1 = withContext({
  'bundle.group': bundleBuyActions(withCurrentGroup(GroupSelect))
});

var IFrame = readyImmediate(EmbedIFrame);

var queryfyObject = function queryfyObject(object) {
  return Object.keys(object).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(object[k]);
  }).join('&');
};

var generateShrinkrayURL = (function (params) {
  return window.SHRINKRAY_URL + '?' + queryfyObject(params);
});

function Thumbnail(props) {
  var width = props.width,
      height = props.height,
      onClick = props.onClick,
      active = props.active;

  var thumbSrc = generateShrinkrayURL(_extends({}, props, { mode: 'thumb' }));

  return jsx('img', {
    className: cx('Lightbox-thumbnail', { 'Lightbox-thumbnail_active': active }),
    onClick: onClick,
    alt: '',
    src: thumbSrc,
    width: width,
    height: height
  });
}

var btnClass = function btnClass(condition, type) {
  return cx('Lightbox-btn Lightbox-' + type, { 'Lightbox-btn_disabled': condition });
};

var Lightbox = function (_React$PureComponent) {
  inherits(Lightbox, _React$PureComponent);

  function Lightbox() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Lightbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      active: _this.props.images.indexOf(_this.props.invoker),
      windowWidth: window.innerWidth
    }, _this.componentDidMount = function () {
      return window.addEventListener('resize', _this.updateDimensions);
    }, _this.componentWillUnmount = function () {
      return window.removeEventListener('resize', _this.updateDimensions);
    }, _this.updateDimensions = function () {
      return _this.setState({ windowWidth: window.innerWidth });
    }, _this.changeActive = function (active) {
      return _this.setState({ active: active });
    }, _this.prevImage = function () {
      return _this.changeActive(Math.max(_this.state.active - 1, 0));
    }, _this.nextImage = function () {
      return _this.changeActive(Math.min(_this.state.active + 1, _this.props.images.length - 1));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Lightbox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          images = _props.images,
          onDismiss = _props.onDismiss;
      var _state = this.state,
          active = _state.active,
          windowWidth = _state.windowWidth;

      var style = {
        width: windowWidth * images.length,
        transform: 'translateX(-' + active * windowWidth + 'px)'
      };

      var atStart = active === 0;
      var atEnd = active === images.length - 1;

      return jsx('div', {
        className: 'Lightbox-wrapper'
      }, void 0, jsx('button', {
        className: 'Lightbox-close',
        onClick: onDismiss
      }), jsx('button', {
        className: btnClass(atStart, 'prev'),
        onClick: this.prevImage
      }), jsx('button', {
        className: btnClass(atEnd, 'next'),
        onClick: this.nextImage
      }), jsx('div', {
        className: 'Lightbox-roll',
        style: style
      }, void 0, images.map(function (url) {
        return jsx('div', {
          className: 'Lightbox-image',
          style: { width: windowWidth }
        }, url, jsx('img', {
          alt: '',
          src: generateShrinkrayURL({ url: url })
        }));
      })), jsx('div', {
        className: 'Lightbox-thumbnails-wrapper'
      }, void 0, jsx('div', {
        className: 'Lightbox-thumbnails'
      }, void 0, images.map(function (url, i) {
        return jsx(Thumbnail, {
          active: active === i,
          onClick: function onClick() {
            return _this2.changeActive(i);
          },
          url: url,
          width: 80,
          height: 80
        }, url);
      }))));
    }
  }]);
  return Lightbox;
}(React.PureComponent);

function Image(props) {
  var className = props.className,
      src = props.src,
      alt = props.alt,
      width = props.width,
      height = props.height,
      title = props.title,
      images = props.images,
      onClick = props.onClick,
      url = props.url;


  return jsx('img', {
    alt: alt,
    src: src,
    width: width,
    height: height,
    title: title,
    className: className,
    onClick: function (_onClick) {
      function onClick() {
        return _onClick.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick.toString();
      };

      return onClick;
    }(function () {
      return images ? onClick(images, url) : null;
    })
  });
}

var mapStateToProps$15 = function mapStateToProps$15() {
  return {};
};

var mapDispatchToProps$12 = function mapDispatchToProps$12(dispatch) {
  return {
    onClick: function onClick(images, invoker) {
      return dispatch(showModal$1(Lightbox, { className: 'Lightbox', maxWidth: '100%', images: images, invoker: invoker }));
    }
  };
};

var Image$1 = readyImmediate(reactRedux.connect(mapStateToProps$15, mapDispatchToProps$12)(Image));

var _ref2$5 = jsx('div', {
  className: 'SpinnerLines-rect'
});

var _ref3$2 = jsx('div', {
  className: 'SpinnerLines-rect'
});

var _ref4$1 = jsx('div', {
  className: 'SpinnerLines-rect'
});

var _ref5$1 = jsx('div', {
  className: 'SpinnerLines-rect'
});

var _ref6 = jsx('div', {
  className: 'SpinnerLines-rect'
});

function IndividualTrackPlayingIndicator(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  return jsx('div', {
    className: 'SpinnerLines ' + className
  }, void 0, _ref2$5, _ref3$2, _ref4$1, _ref5$1, _ref6);
}

var ProductPlaylistQuery = function (_Query) {
  inherits(ProductPlaylistQuery, _Query);

  function ProductPlaylistQuery() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ProductPlaylistQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ProductPlaylistQuery.__proto__ || Object.getPrototypeOf(ProductPlaylistQuery)).call.apply(_ref, [this].concat(args))), _this), _this.query = 'node(id:$productId){...on Digital{id,name,files{result{stream{type:__typename,id,track{error,result{type:__typename,title,author}}}}}}}', _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ProductPlaylistQuery, [{
    key: 'resolve',
    value: function resolve(_ref2) {
      var playlistId = _ref2.id,
          displayName = _ref2.name,
          files = _ref2.files;

      if (files.error != null || files.result == null) {
        return {
          displayName: displayName,
          playlistId: playlistId,
          error: files.error,
          tracks: []
        };
      }

      return {
        displayName: displayName,
        playlistId: playlistId,
        error: null,
        tracks: assignNextProps(files.result.filter(function (f) {
          return f.stream;
        }).map(function (f) {
          return f.stream;
        }).map(streamToTrack).filter(function (t) {
          return t != null;
        }))
      };
    }
  }]);
  return ProductPlaylistQuery;
}(Query);

var productPlaylistQuery = memoize(function (productId) {
  return new ProductPlaylistQuery('productPlaylist.' + productId, { productId: productId });
});

var _ref2$4 = jsx(IndividualTrackPlayingIndicator, {
  className: 'IndividualTrackPlayButton-spinner'
});

var _ref3$1 = jsx('span', {
  className: 'IndividualTrackPlayButton-icon ProductFile-play'
});

function IndividualTrackPlayButton(_ref) {
  var isPlaying = _ref.isPlaying,
      onClick = _ref.onClick;

  return isPlaying ? _ref2$4 :
  // $FlowFixMe - Flow, go home, you're drunk
  jsx('button', {
    className: 'IndividualTrackPlayButton',
    onClick: onClick
  }, void 0, _ref3$1);
}

var mapStateToProps$16 = function mapStateToProps$16(_ref4, _ref5) {
  var playback = _ref4.streamPlayer.playback;
  var streamId = _ref5.streamId;
  return {
    isPlaying: playback.active && playback.streamId === streamId
  };
};

var mapDispatchToProps$13 = function mapDispatchToProps$13(dispatch, _ref6) {
  var streamId = _ref6.streamId,
      productPlaylist = _ref6.productPlaylist;
  return {
    onClick: function onClick() {
      return dispatch(playTrack(productPlaylist, streamId));
    }
  };
};

var queries$4 = {
  productPlaylist: function productPlaylist(_ref7) {
    var productId = _ref7.productId;
    return productPlaylistQuery(productId);
  }
};

var IndividualTrackPlayButton$1 = readyOnGraphData(withQueries$1(reactRedux.connect(mapStateToProps$16, mapDispatchToProps$13)(IndividualTrackPlayButton), queries$4));

function fetchJSONP(url) {
  return new Promise(function (resolve, reject) {
    var embedCb = 'jsonp_callback_' + Math.random().toString(36).replace('.', '');
    var script = document.createElement('script');
    var removeEmbedCb = function removeEmbedCb() {
      document.head.removeChild(script);
      window[embedCb] = undefined;
    };

    // $FlowFixMe - no `error` type in flows defs
    script.addEventListener('error', function (err) {
      removeEmbedCb();
      return reject(err);
    });

    window[embedCb] = function embedCallback(response) {
      removeEmbedCb();
      return resolve(response);
    };

    script.src = url + '&callback=' + embedCb;
    document.head.appendChild(script);
  });
}

var scriptUrl$1 = '//platform.instagram.com/en_US/embeds.js';

var Instagram = function (_React$Component) {
  inherits(Instagram, _React$Component);

  function Instagram() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Instagram);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Instagram.__proto__ || Object.getPrototypeOf(Instagram)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      html: ''
    }, _temp), possibleConstructorReturn(_this, _ret);
  } // eslint-disable-line react/sort-comp

  createClass(Instagram, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var url = this.props.url;

      var embedInfo = 'https://api.instagram.com/oembed?url=' + url + '&omitscript=true';

      fetchJSONP(embedInfo).then(function (_ref2) {
        var html = _ref2.html;

        _this2.setState({ html: html }, function () {
          window.instgrm.Embeds.process();
        });
      });
    }
  }, {
    key: 'instagramEmbedMarkup',
    value: function instagramEmbedMarkup() {
      return {
        __html: this.state.html
      };
    }

    /* eslint-disable react/no-danger */

  }, {
    key: 'render',
    value: function render() {
      return jsx(Teleport, {}, void 0, jsx('div', {
        className: 'Instagram-embed',
        dangerouslySetInnerHTML: this.instagramEmbedMarkup()
      }));
    }
  }]);
  return Instagram;
}(React.Component);

var Instagram$1 = readyImmediate(asyncScriptLoader(Instagram, {
  scriptUrl: scriptUrl$1,
  globalName: 'instgrm'
}));

var delay = (function (ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
});

var speed = 0.2;

// Turns out, coordinating animations involving several different event loops is kinda tricky!
//
// There's a couple things going on here:
//   - startAnimation and stopAnimation are both async actions. We don't want to start an animation
//     part way through stopping on and vice-versa. To prevent this, we keep track of
//     `currentAction`, a promise representing a start- or stop- animation process.
//   - The animation itself uses a slow set-timeout loop rather than a single event loop. That means
//     we can potentially have one animation start in the delay period of another anination, and the
//     two loops will compete. To prevent this, we use an animationId which gets incremented every
//     time the animtion starts or stops. When the animation callback is called, it checks if
//     this value has changed since it started so it knows to stop the loop.

var LoadingBar = function (_React$Component) {
  inherits(LoadingBar, _React$Component);

  function LoadingBar() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, LoadingBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = LoadingBar.__proto__ || Object.getPrototypeOf(LoadingBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { progress: 0, loading: false }, _this.unmounted = false, _this.delayTimeout = 0, _this.currentAnimation = 0, _this.step = rafDebounce(function (animationId) {
      if (!_this.state.loading || _this.unmounted || animationId !== _this.currentAnimation) return;

      var progress = _this.state.progress + (97 - _this.state.progress) * speed;
      _this.setState({ progress: progress });

      delay(Math.random() * 350 + 150).then(function () {
        return _this.step(animationId);
      });
    }), _temp), possibleConstructorReturn(_this, _ret);
  } // eslint-disable-line react/sort-comp


  createClass(LoadingBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.loading !== this.props.loading) {
        clearTimeout(this.delayTimeout);

        if (newProps.loading) {
          this.startLoader();
        } else {
          this.stopLoader();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: 'completeCurrent',
    value: function completeCurrent() {
      return this.currentAction || Promise.resolve();
    }
  }, {
    key: 'startLoader',
    value: function startLoader() {
      var _this2 = this;

      this.delayTimeout = setTimeout(function () {
        _this2.currentAction = _this2.completeCurrent().then(function () {
          return setStateAsync(_this2, { progress: 0, loading: true });
        }).then(function () {
          return _this2.startAnimation();
        });
      }, 100);
    }
  }, {
    key: 'stopLoader',
    value: function stopLoader() {
      var _this3 = this;

      this.currentAction = this.completeCurrent().then(function () {
        return _this3.stopAnimation();
      }).then(function () {
        return setStateAsync(_this3, { progress: 100 });
      }).then(function () {
        return delay(50);
      }).then(function () {
        return setStateAsync(_this3, { loading: false });
      }).then(function () {
        return setStateAsync(_this3, { progress: 0 });
      });
    }
  }, {
    key: 'startAnimation',
    value: function startAnimation() {
      this.currentAnimation += 1;
      this.step(this.currentAnimation);
    }
  }, {
    key: 'stopAnimation',
    value: function stopAnimation() {
      this.currentAnimation += 1;
    }
  }, {
    key: 'currentState',
    value: function currentState() {
      if (this.state.loading) return 'loading';
      return 'stopped';
    }
  }, {
    key: 'render',
    value: function render() {
      return jsx('div', {
        className: 'LoadingBar LoadingBar_' + this.currentState(),
        style: { transform: 'scaleX(' + this.state.progress / 100 + ')' }
      });
    }
  }]);
  return LoadingBar;
}(React.Component);

var mapStateToProps$17 = function mapStateToProps$17(_ref2) {
  var loading = _ref2.page.loading;
  return { loading: loading };
};

var LoadingBar$1 = readyImmediate(reactRedux.connect(mapStateToProps$17, null)(LoadingBar));

function NextTrack(_ref) {
  var shouldRender = _ref.shouldRender,
      onClick = _ref.onClick,
      hasNext = _ref.hasNext,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  if (!shouldRender) return null;

  return jsx('button', {
    className: 'StreamPlayer-next ' + className,
    disabled: !hasNext,
    onClick: onClick
  });
}

var mapStateToProps$18 = function mapStateToProps$18(state) {
  return {
    shouldRender: state.streamPlayer.playback.streamId != null,
    hasNext: state.streamPlayer.playback.hasNext
  };
};

var mapDispatchToProps$14 = function mapDispatchToProps$14(dispatch) {
  return {
    onClick: function onClick() {
      return dispatch(nextTrack$1());
    }
  };
};

var NextTrack$1 = readyImmediate(reactRedux.connect(mapStateToProps$18, mapDispatchToProps$14)(NextTrack));

function NowPlayingAuthor(_ref) {
  var isPlaying = _ref.isPlaying,
      author = _ref.author;

  return isPlaying ? jsx('span', {}, void 0, author) : null;
}

var emptyState = {
  isPlaying: false,
  author: ''
};

var mapStateToProps$19 = function mapStateToProps$19(state) {
  var _state$streamPlayer = state.streamPlayer,
      playlists = _state$streamPlayer.playlists,
      playback = _state$streamPlayer.playback;


  if (playback.playlistId == null) {
    return emptyState;
  }

  var playlist = playlists[playback.playlistId];

  if (!playlist) {
    return emptyState;
  }

  var currentTrack = playlist.tracks.find(function (_ref2) {
    var streamId = _ref2.streamId;
    return streamId === playback.streamId;
  });

  if (!currentTrack) {
    return emptyState;
  }

  return {
    isPlaying: true,
    author: currentTrack.author
  };
};

var NowPlayingAuthor$1 = readyImmediate(reactRedux.connect(mapStateToProps$19)(NowPlayingAuthor));

function NowPlayingPlaylist(_ref) {
  var isPlaying = _ref.isPlaying,
      playlist = _ref.playlist;

  return isPlaying ? jsx('span', {}, void 0, playlist) : null;
}

var emptyState$1 = {
  isPlaying: false,
  playlist: ''
};

var mapStateToProps$20 = function mapStateToProps$20(state) {
  var _state$streamPlayer = state.streamPlayer,
      playlists = _state$streamPlayer.playlists,
      playback = _state$streamPlayer.playback;


  if (playback.playlistId == null) {
    return emptyState$1;
  }

  var playlist = playlists[playback.playlistId];

  if (!playlist) {
    return emptyState$1;
  }

  var currentTrack = playlist.tracks.find(function (_ref2) {
    var streamId = _ref2.streamId;
    return streamId === playback.streamId;
  });

  if (!currentTrack) {
    return emptyState$1;
  }

  return {
    isPlaying: true,
    playlist: playlist.displayName
  };
};

var NowPlayingPlaylist$1 = readyImmediate(reactRedux.connect(mapStateToProps$20)(NowPlayingPlaylist));

function NowPlayingTitle(_ref) {
  var isPlaying = _ref.isPlaying,
      title = _ref.title;

  return isPlaying ? jsx('span', {}, void 0, title) : null;
}

var emptyState$2 = {
  isPlaying: false,
  title: ''
};

var mapStateToProps$21 = function mapStateToProps$21(state) {
  var _state$streamPlayer = state.streamPlayer,
      playlists = _state$streamPlayer.playlists,
      playback = _state$streamPlayer.playback;


  if (playback.playlistId == null) {
    return emptyState$2;
  }

  var playlist = playlists[playback.playlistId];

  if (!playlist) {
    return emptyState$2;
  }

  var currentTrack = playlist.tracks.find(function (_ref2) {
    var streamId = _ref2.streamId;
    return streamId === playback.streamId;
  });

  if (!currentTrack) {
    return emptyState$2;
  }

  return {
    isPlaying: true,
    title: currentTrack.title
  };
};

var NowPlayingTitle$1 = readyImmediate(reactRedux.connect(mapStateToProps$21)(NowPlayingTitle));

var bundleProductProps = createHOC('BundleProductProps', function (Component) {
  var mapStateToProps = function mapStateToProps() {
    var getSelections = makeGetSelections$$1();
    var getProduct = makeGetProduct();

    return function (state, props) {
      var productId = props.context.child && props.context.child.props.productId;
      if (!productId) return null;

      var optionsKey = 'productOptions.' + productId + '.';
      var selectorProps = {
        form: props.form,
        groups: props.groups,
        optionsKey: optionsKey,
        productId: productId
      };

      var product = getProduct(selectorProps);

      return {
        options: product && product.options,
        optionsKey: optionsKey,
        purchasables: product && product.variants,
        selections: getSelections(state, selectorProps)
      };
    };
  };

  return reactRedux.connect(mapStateToProps)(Component);
});

var initialOption = function initialOption(name) {
  return {
    label: name,
    value: INITIAL_VALUE
  };
};

var isOptionEnabled = function isOptionEnabled(optionName, optionValue, selections, purchasables) {
  var nextSelections = entries(_extends({}, selections, defineProperty({}, optionName, optionValue)));

  var purchasable = purchasables.find(function (_ref) {
    var options = _ref.options;

    if (!options) return false;

    return nextSelections.every(function (_ref2) {
      var _ref3 = slicedToArray(_ref2, 2),
          name = _ref3[0],
          value = _ref3[1];

      return options && options.find(function (o) {
        return o.name === name && o.value === value;
      });
    });
  });

  return !!purchasable && isInStock(purchasable);
};

var assembleOptions$1 = function assembleOptions$1(name, optionValues, selections, purchasables) {
  return [initialOption(name)].concat(toConsumableArray(optionValues.map(function (value) {
    var enabled = isOptionEnabled(name, value, selections, purchasables);

    return {
      label: enabled ? value : value + ' - ' + t('buyLink.notOnSale'),
      value: value,
      disabled: !enabled
    };
  })));
};

function OptionSelect(props) {
  var form = props.form,
      label = props.label,
      option = props.option,
      options = props.options,
      _props$optionsKey = props.optionsKey,
      optionsKey = _props$optionsKey === undefined ? 'options.' : _props$optionsKey,
      purchasables = props.purchasables,
      selections = props.selections;


  var optionValues = options && options[option];
  if (!optionValues || !purchasables) return null;

  return jsx(Field$1, {
    form: form,
    name: '' + optionsKey + option,
    component: SelectInput,
    label: label != null ? label : option,
    options: assembleOptions$1(option, optionValues, selections, purchasables),
    validateOn: 'change'
  });
}

var OptionSelect$1 = withContext({
  product: productBuyActions(OptionSelect),
  'bundle.product': bundleBuyActions(bundleProductProps(OptionSelect))
});

function PasswordInput(props) {
  var form = props.form,
      label = props.label;


  return jsx(Field$1, {
    form: form,
    name: 'password',
    component: Input,
    type: 'password',
    label: label != null ? label : t('password.label'),
    validateOn: 'change'
  });
}

var PasswordInput$1 = withContext({
  login: login(PasswordInput)
});

function NextTrack$2(_ref) {
  var shouldRender = _ref.shouldRender,
      onClick = _ref.onClick,
      hasPrev = _ref.hasPrev,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  if (!shouldRender) return null;

  return jsx('button', {
    disabled: !hasPrev,
    onClick: onClick,
    className: 'StreamPlayer-previous ' + className
  });
}

var mapStateToProps$22 = function mapStateToProps$22(state) {
  return {
    shouldRender: state.streamPlayer.playback.streamId != null,
    hasPrev: state.streamPlayer.playback.hasPrev
  };
};

var mapDispatchToProps$15 = function mapDispatchToProps$15(dispatch) {
  return {
    onClick: function onClick() {
      return dispatch(previousTrack$1());
    }
  };
};

var PrevTrack = readyImmediate(reactRedux.connect(mapStateToProps$22, mapDispatchToProps$15)(NextTrack$2));

// parses a positive number using the correct decimal place for the locale
function parseNumber(str) {
  var decimal = window.LOCALE.numbers.decimal;

  var normalised = str.replace(new RegExp('[^0-9\\' + decimal + ']', 'g'), '').replace(new RegExp('\\' + decimal, 'g'), '.');

  var number = parseFloat(normalised);

  if (isNaN(number)) return null;
  return number;
}

// Parses a string representing a positive amount of money in a specific currency and returns the
// number of cents it represents
function parseMoney(str, currency) {
  var amount = parseNumber(str);
  if (amount == null) return null;

  return nonFractionalCurrencies.has(currency.toLowerCase()) ? amount : amount * 100;
}

var MoneyField = function (_React$Component) {
  inherits(MoneyField, _React$Component);

  function MoneyField() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, MoneyField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = MoneyField.__proto__ || Object.getPrototypeOf(MoneyField)).call.apply(_ref, [this].concat(args))), _this), _this.state = { value: '' }, _this.handleChange = function (e) {
      if (!(e.target instanceof HTMLInputElement)) return;

      var value = e.target.value.trim();
      var amount = _this.parse(value);

      _this.setState({ value: value }, function () {
        if (value != null) {
          _this.props.onChange(amount);
        }
      });
    }, _this.handleBlur = function (e) {
      if (!(e.target instanceof HTMLInputElement)) return;

      var value = _this.parse(e.target.value.trim());

      _this.setState({ value: value == null ? '' : _this.format(value) });
      _this.props.onChange(value);
      if (_this.props.onBlur) _this.props.onBlur(value);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(MoneyField, [{
    key: 'componentWillMount',
    // eslint-disable-line react/sort-comp

    value: function componentWillMount() {
      this.setValue(this.props.value || this.props.defaultValue || 0);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setValue(nextProps.value);
    }
  }, {
    key: 'format',
    value: function format(amount) {
      return formatMoney(amount, this.props.currency, true);
    }
  }, {
    key: 'parse',
    value: function parse(amount) {
      if (typeof amount === 'number') return amount;
      return parseMoney(amount, this.props.currency);
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      if (value == null || value === '' || isNaN(value)) {
        this.setState({ value: '' });
        return;
      }

      var newValue = this.parse(value);
      var currentValue = this.parse(this.state.value);

      if (currentValue !== newValue) {
        this.setState({
          value: newValue == null ? '' : this.format(newValue)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          id = _props.id,
          onFocus = _props.onFocus;
      var value = this.state.value;


      return jsx('input', {
        type: 'tel',
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: onFocus,
        value: value,
        className: cx('MoneyField', className),
        id: id
      });
    }
  }]);
  return MoneyField;
}(React.Component);

function PriceInput(props) {
  var form = props.form,
      label = props.label,
      currency = props.currency;


  return jsx(Field$1, {
    form: form,
    name: 'pwywPrice',
    component: Input,
    type: MoneyField,
    label: label != null ? label : '',
    currency: currency,
    validateOn: 'change'
  });
}

var PriceInput$1 = withContext({
  product: productBuyActions(PriceInput)
});

var availableCount = function availableCount(maxPerTransaction) {
  var quantityInBasket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var remaining = arguments[2];

  var max = Math.max(0, maxPerTransaction - quantityInBasket);

  return remaining ? Math.min(remaining, max) : max;
};

function productQuantityProps(props) {
  var maxPerTransaction = props.maxPerTransaction,
      purchasable = props.purchasable,
      quantities = props.quantities;

  var hidden = true;

  if (!maxPerTransaction || maxPerTransaction <= 1) return null;

  var quantity = quantities && purchasable ? quantities[purchasable.id] || 0 : 0;

  var count = purchasable && maxPerTransaction && stockRemaining(purchasable) > 0 ? availableCount(maxPerTransaction, quantity, stockRemaining(purchasable)) : 0;

  if (purchasable) {
    var status = purchasable.stock.result.status;
    var stockStatusError = status.error,
        _status$result = status.result,
        stockStatus = _status$result === undefined ? '' : _status$result;

    hidden = stockStatusError || stockStatus !== STOCK_AVAILABLE || count === 0;
  } else {
    hidden = true;
  }

  return {
    min: 1,
    max: count,
    disabled: count < 1,
    loading: false,
    hidden: hidden
  };
}

function basketQuantityProps(props) {
  var maxPerTransaction = props.maxPerTransaction,
      purchasables = props.purchasables,
      quantityInBasket = props.quantityInBasket,
      submitting = props.submitting;

  var remaining = Math.min.apply(Math, toConsumableArray(purchasables.map(function (p) {
    return stockRemaining(p);
  })));
  var available = quantityInBasket + remaining;
  var count = Math.max(1, Math.min(maxPerTransaction, available));

  return {
    min: 0,
    max: count || 1,
    loading: submitting
  };
}

var BasketLinePurchasablesQuery = function (_Query) {
  inherits(BasketLinePurchasablesQuery, _Query);

  function BasketLinePurchasablesQuery() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, BasketLinePurchasablesQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = BasketLinePurchasablesQuery.__proto__ || Object.getPrototypeOf(BasketLinePurchasablesQuery)).call.apply(_ref, [this].concat(args))), _this), _this.query = 'viewer{basket{result{lines{id,items{result{purchasable{type:__typename,id,name,maxPerTransaction,stock{result{status{result,error},remaining{result,error}},error}}}}}}}}', _this.resolve = memoize(function (response) {
      return fromPairs(response.basket.result.lines.map(function (_ref2) {
        var id = _ref2.id,
            items = _ref2.items;
        return [id, items.result.map(function (i) {
          return i.purchasable;
        })];
      }));
    }), _temp), possibleConstructorReturn(_this, _ret);
  }

  return BasketLinePurchasablesQuery;
}(Query);

var basketLinePurchasablesQuery = new BasketLinePurchasablesQuery('basket.linePurchasables');

var formOptions$8 = {
  formIdentifier: function formIdentifier(_ref) {
    var id = _ref.context.id;
    return 'basketLineActions.' + id;
  },

  initialValues: function initialValues(_ref2) {
    var quantityInBasket = _ref2.quantityInBasket;
    return {
      quantity: '' + quantityInBasket
    };
  },

  validate: function validate(form) {
    return [field(form, 'quantity', [required])];
  },

  submit: function submit(form, props) {
    var onSubmit = props.onSubmit,
        quantityInBasket = props.quantityInBasket,
        currency = props.currency,
        context = props.context;


    var requestedQuantity = parseFloat(form.fields.quantity.value);
    if (isNaN(requestedQuantity) || requestedQuantity === quantityInBasket) return Promise.reject();

    return onSubmit({
      delta: requestedQuantity - quantityInBasket,
      productId: context.props.productId,
      purchasables: context.props.purchasables.map(function (_ref3) {
        var purchasableId = _ref3.purchasableId,
            offeredCents = _ref3.offeredCents;
        return {
          currency: currency,
          id: purchasableId,
          offeredCents: offeredCents
        };
      })
    });
  },

  submitOnChange: ['quantity']
};

var EMPTY_LIST = [];

var computeExtraProps = function computeExtraProps(props) {
  var context = props.context,
      linePurchasables = props.linePurchasables,
      quantities = props.quantities;
  var lineId = context.props.lineId;


  var purchasables = linePurchasables[lineId] || EMPTY_LIST;
  var purchaseLimits = purchasables.filter(function (_ref4) {
    var type = _ref4.type;
    return type !== 'Digital';
  }).map(function (p) {
    return p.maxPerTransaction;
  });

  return {
    purchasables: purchasables,
    quantityInBasket: quantities[lineId],
    maxPerTransaction: Math.min.apply(Math, toConsumableArray(purchaseLimits)) || 1
  };
};

var mapStateToProps$23 = function mapStateToProps$23(state) {
  return {
    currency: state.config.viewer.currency
  };
};

var mapDispatchToProps$16 = function mapDispatchToProps$16(dispatch) {
  return {
    onSubmit: function onSubmit(input) {
      return dispatch(fireMutation(new AlterQuantityInBasketMutation(input)));
    }
  };
};

var queries$5 = {
  linePurchasables: basketLinePurchasablesQuery,
  quantities: basketLineQuantitiesQuery
};

var basketLineActions = (function (Component) {
  return readyOnGraphData(withQueries$1(reactRedux.connect(mapStateToProps$23, mapDispatchToProps$16)(withProps$1(implicitForm(Component, formOptions$8), computeExtraProps)), queries$5));
});

function QuantitySelect(props) {
  var form = props.form,
      label = props.label,
      _props$max = props.max,
      max = _props$max === undefined ? 1 : _props$max,
      hidden = props.hidden,
      disabled = props.disabled,
      loading = props.loading;

  var count = max;
  var options = times(count, function (i) {
    return '' + (i + 1);
  });

  if (hidden) return null;

  return jsx(Field$1, {
    form: form,
    name: 'quantity',
    component: AsyncSelectInput,
    label: label != null ? label : t('quantity'),
    options: options,
    disabled: disabled || count === 0,
    loading: loading,
    validateOn: 'change'
  });
}

var QuantitySelect$1 = withContext({
  basketLine: basketLineActions(withFormMeta(withProps$1(QuantitySelect, basketQuantityProps))),
  product: productBuyActions(withProps$1(QuantitySelect, productQuantityProps))
});

function formatNumber(value, options) {
  return new Intl.NumberFormat(window.LOCALE.code, options).format(value);
}

var constrain = function constrain(n, min, max) {
  return Math.min(Math.max(n, min), max);
};

var _ref2$6 = jsx('div', {
  className: 'NumberStepper-spinner'
}, void 0, jsx(Spinner, {}));

var NumberStepper = function (_React$Component) {
  inherits(NumberStepper, _React$Component);

  function NumberStepper() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, NumberStepper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = NumberStepper.__proto__ || Object.getPrototypeOf(NumberStepper)).call.apply(_ref, [this].concat(args))), _this), _this.handleIncrement = function (e) {
      e.preventDefault();
      _this.changeBy(1);
    }, _this.handleDecrement = function (e) {
      e.preventDefault();
      _this.changeBy(-1);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(NumberStepper, [{
    key: 'value',
    // eslint-disable-line react/sort-comp

    value: function value() {
      return parseInt(this.props.value, 10);
    }
  }, {
    key: 'changeBy',
    value: function changeBy(delta) {
      var value = this.value();
      var newValue = constrain(value + delta, this.props.min, this.props.max);
      if (value !== newValue) this.props.onChange('' + newValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          min = _props.min,
          max = _props.max,
          incrementLabel = _props.incrementLabel,
          decrementLabel = _props.decrementLabel;

      var value = this.value();

      var decrementDisabled = value <= min;
      var incrementDisabled = value >= max;

      return jsx('div', {
        className: cx('NumberStepper', { NumberStepper_loading: loading })
      }, void 0, jsx('div', {
        className: 'NumberStepper-content'
      }, void 0, jsx('button', {
        onClick: this.handleDecrement,
        disabled: decrementDisabled,
        className: 'NumberStepper-decrement'
      }, void 0, decrementLabel), jsx('span', {
        className: 'NumberStepper-value'
      }, void 0, formatNumber(value)), jsx('button', {
        onClick: this.handleIncrement,
        disabled: incrementDisabled,
        className: 'NumberStepper-increment'
      }, void 0, incrementLabel)), _ref2$6);
    }
  }]);
  return NumberStepper;
}(React.Component);

function QuantityStepper(props) {
  var form = props.form,
      _props$min = props.min,
      min = _props$min === undefined ? 1 : _props$min,
      _props$max = props.max,
      max = _props$max === undefined ? 1 : _props$max,
      loading = props.loading,
      incrementLabel = props.incrementLabel,
      decrementLabel = props.decrementLabel;


  return jsx(Field$1, {
    component: NumberStepper,
    decrementLabel: decrementLabel,
    form: form,
    incrementLabel: incrementLabel,
    loading: loading,
    max: max,
    min: min,
    name: 'quantity',
    validateOn: 'change'
  });
}

var QuantityStepper$1 = withContext({
  basketLine: basketLineActions(withFormMeta(withProps$1(QuantityStepper, basketQuantityProps))),
  product: productBuyActions(withProps$1(QuantityStepper, productQuantityProps))
});

function RawRemoveButton(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      loading = _ref.loading;

  return jsx(LoadingButton, {
    loading: loading,
    onClick: function onClick() {
      return onChange('0');
    }
  }, void 0, label);
}

function RemoveButton(_ref2) {
  var label = _ref2.label,
      form = _ref2.form,
      submitting = _ref2.submitting;

  return jsx(Field$1, {
    form: form,
    name: 'quantity',
    component: RawRemoveButton,
    label: label != null ? label : 'Remove',
    loading: submitting
  });
}

var RemoveButton$1 = withContext({
  basketLine: basketLineActions(withFormMeta(RemoveButton))
});

var EXPIRING_SLEEP_MILLISECONDS = 500;
var IDLING_SLEEP_MILLISECONDS = 10000;
var EXPIRY_MODE_THRESHOLD = 60000;

var ReservationExpiry = function (_React$Component) {
  inherits(ReservationExpiry, _React$Component);

  function ReservationExpiry() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ReservationExpiry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ReservationExpiry.__proto__ || Object.getPrototypeOf(ReservationExpiry)).call.apply(_ref, [this].concat(args))), _this), _this.state = { remaining: 0, expiresAt: 0 }, _this.setRemainingTime = function (_ref2) {
      var reservationExpiresAt = _ref2.overview.reservationExpiresAt;

      // Allow for mount time etc. Turns out to be roughly 2 seconds
      if (reservationExpiresAt) {
        _this.setState({
          remaining: new Date(reservationExpiresAt) - Date.now() + 1000,
          expiresAt: new Date(reservationExpiresAt)
        });
      }
    }, _this.tuneSleep = function (remainingTime) {
      _this.sleep = remainingTime < EXPIRY_MODE_THRESHOLD ? EXPIRING_SLEEP_MILLISECONDS : IDLING_SLEEP_MILLISECONDS;
    }, _this.sleep = IDLING_SLEEP_MILLISECONDS, _this.tick = function () {
      _this.setState({ remaining: _this.state.expiresAt - Date.now() });
    }, _this.translationId = function (seconds, lessThanAMinute) {
      return seconds <= 0 ? 'basket.reservation.expired' : 'basket.reservation.expires_in_' + (lessThanAMinute ? 'seconds' : 'minutes');
    }, _this.translationProp = function (seconds, lessThanAMinute) {
      return { expire_time: lessThanAMinute ? seconds : Math.min(Math.ceil(seconds / 60), 10) };
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ReservationExpiry, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setRemainingTime(this.props);
      this.timer = setInterval(this.tick, EXPIRING_SLEEP_MILLISECONDS);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setRemainingTime(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$overview = this.props.overview,
          lineCount = _props$overview.lineCount,
          hasPhysical = _props$overview.hasPhysical;
      var remaining = this.state.remaining;

      if (!hasPhysical || !remaining || lineCount === 0) return null;

      var seconds = Math.max(0, Math.floor(remaining / 1000));
      var lessThanAMinute = seconds < 60;
      var id = this.translationId(seconds, lessThanAMinute);
      var prop = this.translationProp(seconds, lessThanAMinute);

      return jsx('span', {
        className: 'ReservationExpiresAtTime'
      }, void 0, t(id, prop));
    }
  }]);
  return ReservationExpiry;
}(React.Component);

var ReservationExpiry$1 = readyOnGraphData(withQueries$1(ReservationExpiry, { overview: basketOverviewQuery }));

var Soundcloud = readyImmediate(withProps$1(EmbedIFrame, function (_ref) {
  var url = _ref.url,
      height = _ref.height,
      color = _ref.color;
  return {
    src: 'https://w.soundcloud.com/player/?' + assembleQueryString({ url: url, color: color }),
    height: height || 166
  };
}));

var Spotify = readyImmediate(withProps$1(EmbedIFrame, function (_ref) {
  var uri = _ref.uri,
      height = _ref.height,
      view = _ref.view,
      theme = _ref.theme;
  return {
    src: 'https://embed.spotify.com/?' + assembleQueryString({
      uri: uri,
      theme: theme || 'black',
      view: view || 'list'
    }),
    height: height || 390
  };
}));

var ApplyVoucherMutation = function (_Mutation) {
  inherits(ApplyVoucherMutation, _Mutation);

  function ApplyVoucherMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ApplyVoucherMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ApplyVoucherMutation.__proto__ || Object.getPrototypeOf(ApplyVoucherMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'ApplyVoucher', _this.mutation = 'applyVoucher', _this.invalidateQueries = function () {
      return ['basket.overview'];
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return ApplyVoucherMutation;
}(Mutation);

var formIdentifier$8 = function formIdentifier$8(_ref) {
  var context = _ref.context;
  return 'voucher.' + context.id;
};

var formOptions$9 = {
  formIdentifier: formIdentifier$8,

  validate: function validate(form) {
    return [field(form, 'voucher', [required])];
  },

  submit: function submit(form, _ref2) {
    var onSubmit = _ref2.onSubmit;

    var voucherField = form.fields.voucher;

    if (!voucherField || typeof voucherField.value !== 'string') return Promise.reject();

    return onSubmit({ voucherCode: voucherField.value });
  }
};

var mapDispatchToProps$17 = function mapDispatchToProps$17(dispatch) {
  return {
    onSubmit: function onSubmit(input) {
      return dispatch(fireMutation(new ApplyVoucherMutation(input)));
    }
  };
};

var voucherForm = (function (Component) {
  return readyImmediate(reactRedux.connect(null, mapDispatchToProps$17)(implicitForm(Component, formOptions$9)));
});

function SubmitButton(_ref) {
  var label = _ref.label,
      form = _ref.form,
      valid = _ref.valid,
      submitting = _ref.submitting;

  return jsx(LoadingButton, {
    disabled: !valid,
    onClick: form.submit,
    loading: submitting
  }, void 0, label != null ? label : t('form.submit'));
}

var SubmitButton$1 = withContext({
  applyToPlay: applyToPlaySignup(withFormMeta(SubmitButton)),
  confirmLocation: confirmLocation$1(withFormMeta(SubmitButton)),
  mailingList: mailingListSignup(withFormMeta(SubmitButton)),
  voucher: voucherForm(withFormMeta(SubmitButton)),
  product: freeDownloadRequest(withFormMeta(SubmitButton)),
  login: login(withFormMeta(SubmitButton))
});

var getState$1 = function getState$1(paused, loading) {
  if (paused) return 'paused';
  if (loading) return 'loading';
  return 'playing';
};

function TogglePlayback(props) {
  var shouldRender = props.shouldRender,
      onClick = props.onClick,
      disabled = props.disabled,
      paused = props.paused,
      loading = props.loading,
      _props$className = props.className,
      className = _props$className === undefined ? '' : _props$className;


  if (!shouldRender) return null;

  var state = getState$1(paused, loading);

  return jsx('button', {
    className: 'StreamPlayer-play StreamPlayer-play_' + state + ' ' + className,
    disabled: disabled,
    onClick: onClick
  });
}

var mapStateToProps$24 = function mapStateToProps$24(_ref) {
  var playback = _ref.streamPlayer.playback;
  return {
    shouldRender: playback.streamId != null,
    disabled: playback.playlistId == null,
    paused: !playback.active,
    loading: playback.active && playback.pending
  };
};

var mapDispatchToProps$18 = function mapDispatchToProps$18(dispatch) {
  return {
    onClick: function onClick() {
      return dispatch(togglePlayback());
    }
  };
};

var TogglePlayback$1 = readyImmediate(reactRedux.connect(mapStateToProps$24, mapDispatchToProps$18)(TogglePlayback));

// Some payment gateways require some currencies to be non-fractional. For example:
//
//   https://developer.paypal.com/docs/classic/api/currency_codes/
//
// Here HUF, JPY, and TWD say "decimal amounts not supported for this currency". In order to avoid
// errors at the gateway or in subsequent order processing, we should remove the fractional content
// of pricing at the basket stage. This function should be called anywhere that obtains a money
// amount, e.g. loading prices from the products service or applying a percentage discount.

var roundGatewayRoundedCurrencies = function roundGatewayRoundedCurrencies(money) {
  return gatewayRoundedCurrencies.has(money.currency.toLowerCase()) ? { cents: Math.round(money.cents * 0.01) * 100, currency: money.currency } : money;
};

var findSelectedProduct = function findSelectedProduct(selected, group) {
  return group.products.find(function (product) {
    return product.id === selected[group.id];
  });
};

var applyDiscount = function applyDiscount(_ref, discount) {
  var cents = _ref.cents,
      currency = _ref.currency;
  return {
    cents: cents * ((100 - discount) / 100),
    currency: currency
  };
};

var addMoney = function addMoney(a, b) {
  if (a.currency.toLowerCase() !== b.currency.toLowerCase()) {
    throw new Error('Cannot add Money of different currencies');
  }

  return {
    cents: a.cents + b.cents,
    currency: a.currency
  };
};

var getProductTotalPrice = function getProductTotalPrice(product) {
  return product.serviceCharge ? addMoney(product.price, product.serviceCharge) : product.price;
};

var getSelectedProductPrice = function getSelectedProductPrice(selected, discounted) {
  return function (group) {
    var product = findSelectedProduct(selected, group);
    if (!product) return null;

    var price = getProductTotalPrice(product);
    var afterDiscounts = discounted ? applyDiscount(price, group.discount) : price;

    return roundGatewayRoundedCurrencies(afterDiscounts);
  };
};

var bundlePrice = function bundlePrice(groups, selectedProducts, discounted, currency) {
  return compact(values(groups).map(getSelectedProductPrice(selectedProducts, discounted))).reduce(addMoney, { cents: 0, currency: currency });
};

function Total(props) {
  var groups = props.groups,
      selectedProducts = props.selectedProducts,
      original = props.original,
      hideIdentical = props.hideIdentical,
      currency = props.currency;

  var undiscounted = formatMoneyObj(bundlePrice(groups, selectedProducts, true, currency));
  var discounted = formatMoneyObj(bundlePrice(groups, selectedProducts, false, currency));

  if (hideIdentical && undiscounted === discounted) return null;
  return jsx('span', {}, void 0, formatMoneyObj(bundlePrice(groups, selectedProducts, !original, currency)));
}

var Total$1 = withContext({
  bundle: bundleBuyActions(Total)
});

var scriptUrl$2 = 'https://platform.twitter.com/widgets.js';

var Twitter = function (_React$Component) {
  inherits(Twitter, _React$Component);

  function Twitter() {
    classCallCheck(this, Twitter);
    return possibleConstructorReturn(this, (Twitter.__proto__ || Object.getPrototypeOf(Twitter)).apply(this, arguments));
  }

  createClass(Twitter, [{
    key: 'componentDidMount',
    // eslint-disable-line react/sort-comp

    value: function componentDidMount() {
      if (this.props.twttr) this.props.twttr.widgets.load();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.twttr !== nextProps.twttr && nextProps.twttr) nextProps.twttr.widgets.load();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          username = _props.username,
          height = _props.height;


      return jsx(Teleport, {}, void 0, jsx('a', {
        className: 'twitter-timeline',
        'data-height': height || 260,
        href: 'https://twitter.com/' + username
      }, void 0, t('twitter.footer', { handle: username })));
    }
  }]);
  return Twitter;
}(React.Component);

var Twitter$1 = readyImmediate(asyncScriptLoader(Twitter, {
  scriptUrl: scriptUrl$2,
  globalName: 'twttr'
}));

function Upsells(_ref) {
  var context = _ref.context;
  var _context$props = context.props,
      productSlug = _context$props.productSlug,
      catalogueId = _context$props.catalogueId;


  var query = { productSlug: productSlug, catalogueId: catalogueId };
  var upsellsType = productSlug ? 'bundle' : 'basket';

  return jsx(Partial$1, {
    name: upsellsType + '_upsells',
    query: query
  });
}

var Upsells$1 = readyImmediate(Upsells);

var ViewerCountrySelect$2 = readyImmediate(ViewerCountrySelect$1);

var ChangeViewerCurrencyMutation = function (_Mutation) {
  inherits(ChangeViewerCurrencyMutation, _Mutation);

  function ChangeViewerCurrencyMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ChangeViewerCurrencyMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ChangeViewerCurrencyMutation.__proto__ || Object.getPrototypeOf(ChangeViewerCurrencyMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'ChangeViewerCurrency', _this.mutation = 'changeViewerCurrency', _this.invalidateQueries = function () {
      return [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ChangeViewerCurrencyMutation, [{
    key: 'after',
    value: function after() {
      window.location.reload();
    }
  }]);
  return ChangeViewerCurrencyMutation;
}(Mutation);

var getOptions$1 = function getOptions$1(currency) {
  return compact([].concat(toConsumableArray(window.LOCALE.currencies.filter(function (c) {
    return c.global;
  })), [window.LOCALE.currencies.find(function (c) {
    return !c.global && c.code === currency;
  })])).map(function (_ref) {
    var code = _ref.code,
        name = _ref.name;
    return {
      value: code,
      label: name
    };
  });
};

function ViewerCurrencySelect(props) {
  var className = props.className,
      label = props.label,
      onChange = props.onChange;

  var currency = props.currency.toUpperCase();

  return jsx(AsyncSelectInput, {
    label: label != null ? label : '',
    className: cx('ViewerCurrencySelect', className),
    value: currency,
    options: getOptions$1(currency),
    onChange: onChange
  });
}

var mapStateToProps$25 = function mapStateToProps$25(_ref2) {
  var currency = _ref2.config.viewer.currency;
  return {
    currency: currency
  };
};

var mapDispatchToProps$19 = function mapDispatchToProps$19(dispatch) {
  return {
    onChange: function onChange(currency) {
      return dispatch(fireMutation(new ChangeViewerCurrencyMutation({ currency: currency })));
    }
  };
};

var ViewerCurrencySelect$1 = readyImmediate(reactRedux.connect(mapStateToProps$25, mapDispatchToProps$19)(ViewerCurrencySelect));

var ChangeViewerLanguageMutation = function (_Mutation) {
  inherits(ChangeViewerLanguageMutation, _Mutation);

  function ChangeViewerLanguageMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ChangeViewerLanguageMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ChangeViewerLanguageMutation.__proto__ || Object.getPrototypeOf(ChangeViewerLanguageMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'ChangeViewerLanguage', _this.mutation = 'changeViewerLanguage', _this.invalidateQueries = function () {
      return [];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ChangeViewerLanguageMutation, [{
    key: 'after',
    value: function after() {
      window.location.reload();
    }
  }]);
  return ChangeViewerLanguageMutation;
}(Mutation);

var languages = [{
  "code": "EN",
  "featured": true,
  "nativeName": "English"
}, {
  "code": "ES",
  "featured": true,
  "nativeName": "Español"
}, {
  "code": "ZH",
  "featured": true,
  "nativeName": "中文"
}, {
  "code": "JA",
  "featured": false,
  "nativeName": "日本語"
}, {
  "code": "KO",
  "featured": false,
  "nativeName": "한국어"
}, {
  "code": "AR",
  "featured": false,
  "nativeName": "العربية"
}, {
  "code": "BG",
  "featured": false,
  "nativeName": "Български"
}, {
  "code": "CA",
  "featured": false,
  "nativeName": "Català"
}, {
  "code": "CY",
  "featured": false,
  "nativeName": "Cymraeg"
}, {
  "code": "DA",
  "featured": false,
  "nativeName": "Dansk"
}, {
  "code": "SV",
  "featured": false,
  "nativeName": "Svenska"
}, {
  "code": "DE",
  "featured": false,
  "nativeName": "Deutsch"
}, {
  "code": "FR",
  "featured": false,
  "nativeName": "Français"
}, {
  "code": "HR",
  "featured": false,
  "nativeName": "Hrvatski"
}, {
  "code": "IT",
  "featured": false,
  "nativeName": "Italiano"
}, {
  "code": "HU",
  "featured": false,
  "nativeName": "Magyar"
}, {
  "code": "NL",
  "featured": false,
  "nativeName": "Nederlands"
}, {
  "code": "NO",
  "featured": false,
  "nativeName": "Nynorsk"
}, {
  "code": "PL",
  "featured": false,
  "nativeName": "Polski"
}, {
  "code": "PT",
  "featured": false,
  "nativeName": "Português"
}, {
  "code": "RU",
  "featured": false,
  "nativeName": "Русский"
}, {
  "code": "FI",
  "featured": false,
  "nativeName": "Suomi"
}, {
  "code": "TR",
  "featured": false,
  "nativeName": "Türkçe"
}, {
  "code": "HI",
  "featured": false,
  "nativeName": "हिन्दी"
}];;

var languageToOption = function languageToOption(_ref) {
  var code = _ref.code,
      nativeName = _ref.nativeName;
  return {
    value: code,
    label: nativeName
  };
};

var options$3 = [].concat(toConsumableArray(languages.filter(function (l) {
  return l.featured;
}).map(languageToOption)), [{ disabled: true, value: '', label: '---' }], toConsumableArray(languages.filter(function (l) {
  return !l.featured;
}).map(languageToOption)));

function ViewerLanguageSelect(props) {
  var className = props.className,
      label = props.label,
      language = props.language,
      onChange = props.onChange;


  return jsx(AsyncSelectInput, {
    label: label != null ? label : '',
    className: cx('ViewerLanguageSelect', className),
    value: language.toUpperCase(),
    options: options$3,
    onChange: onChange
  });
}

var mapStateToProps$26 = function mapStateToProps$26(_ref2) {
  var language = _ref2.config.viewer.language;
  return {
    language: language
  };
};

var mapDispatchToProps$20 = function mapDispatchToProps$20(dispatch) {
  return {
    onChange: function onChange(language) {
      return dispatch(fireMutation(new ChangeViewerLanguageMutation({ language: language })));
    }
  };
};

var ViewerLanguageSelect$1 = readyImmediate(reactRedux.connect(mapStateToProps$26, mapDispatchToProps$20)(ViewerLanguageSelect));

var containerStyle = {
  position: 'relative',
  width: '100%',
  height: '0',
  paddingBottom: 9 / 16 * 100 + '%'
};

var frameStyle = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  left: '0',
  top: '0'
};

function VideoIframe(_ref) {
  var src = _ref.src;

  return jsx(Teleport, {}, void 0, jsx('div', {
    style: containerStyle
  }, void 0, jsx('iframe', {
    src: src,
    allowFullScreen: true,
    frameBorder: 'no',
    scrolling: 'no',
    style: frameStyle
  })));
}

var Vimeo = readyImmediate(VideoIframe);

var ENTER_KEY = 'Enter';
var ENTER_KEYCODE = 13;

var handleKeyDown = function handleKeyDown(form) {
  return function (e) {
    if (e.key === ENTER_KEY || e.keyCode === ENTER_KEYCODE) {
      form.submit();
    }
  };
};

function VoucherInput(props) {
  var form = props.form,
      label = props.label,
      placeholder = props.placeholder;


  return jsx(Field$1, {
    form: form,
    name: 'voucher',
    component: Input,
    type: 'text',
    label: label != null ? label : t('basket.discount.placeholder'),
    placeholder: placeholder,
    validateOn: ['change', 'blur'],
    onKeyDown: handleKeyDown(form)
  });
}

var VoucherInput$1 = withContext({
  voucher: voucherForm(VoucherInput)
});

var YouTube = readyImmediate(VideoIframe);



var widgets = Object.freeze({
	AddToBasket: AddToBasket$1,
	BasketCount: BasketCount$1,
	BasketPrice: BasketPrice$1,
	Checkout: Checkout$1,
	CityInput: CityInput$1,
	EmailInput: EmailInput$1,
	Facebook: Facebook$1,
	GatewayReception: GatewayReception$1,
	GoogleMap: GoogleMap,
	GroupSelect: GroupSelect$1,
	IFrame: IFrame,
	Image: Image$1,
	IndividualTrackPlayButton: IndividualTrackPlayButton$1,
	Instagram: Instagram$1,
	LoadingBar: LoadingBar$1,
	NextTrack: NextTrack$1,
	NowPlayingAuthor: NowPlayingAuthor$1,
	NowPlayingPlaylist: NowPlayingPlaylist$1,
	NowPlayingTitle: NowPlayingTitle$1,
	OptionSelect: OptionSelect$1,
	Partial: Partial$1,
	PasswordInput: PasswordInput$1,
	PrevTrack: PrevTrack,
	PriceInput: PriceInput$1,
	QuantitySelect: QuantitySelect$1,
	QuantityStepper: QuantityStepper$1,
	RemoveButton: RemoveButton$1,
	ReservationExpiry: ReservationExpiry$1,
	Soundcloud: Soundcloud,
	Spotify: Spotify,
	SubmitButton: SubmitButton$1,
	TogglePlayback: TogglePlayback$1,
	Total: Total$1,
	Twitter: Twitter$1,
	Upsells: Upsells$1,
	ViewerCountrySelect: ViewerCountrySelect$2,
	ViewerCurrencySelect: ViewerCurrencySelect$1,
	ViewerLanguageSelect: ViewerLanguageSelect$1,
	Vimeo: Vimeo,
	VoucherInput: VoucherInput$1,
	YouTube: YouTube
});

var loadWidget = memoize(function (name) {
  return Promise.resolve().then(function () {
    return widgets[name];
  });
});

var WidgetCache = function () {
  function WidgetCache() {
    classCallCheck(this, WidgetCache);

    this.widgets = {};
  }

  createClass(WidgetCache, [{
    key: 'save',
    value: function save(element) {
      var widgetName = element.dataset.component;
      var props = element.dataset.props;

      if (!this.widgets[widgetName]) this.widgets[widgetName] = {};
      if (!this.widgets[widgetName][props]) this.widgets[widgetName][props] = [];

      this.widgets[widgetName][props].push(element);
    }
  }, {
    key: 'restore',
    value: function restore(widgetName, encodedProps) {
      var elements = this.widgets[widgetName] && this.widgets[widgetName][encodedProps];

      return elements && elements.length ? elements.pop() : null;
    }
  }, {
    key: 'clear',
    value: function clear() {
      values(this.widgets).forEach(function (byProps) {
        return values(byProps).forEach(function (elements) {
          return elements.forEach(function (element) {
            return ReactDOM.unmountComponentAtNode(element);
          });
        });
      });

      this.widgets = {};
    }
  }]);
  return WidgetCache;
}();

var MountCancelledError = function (_Error) {
  inherits(MountCancelledError, _Error);

  function MountCancelledError() {
    classCallCheck(this, MountCancelledError);

    var _this = possibleConstructorReturn(this, (MountCancelledError.__proto__ || Object.getPrototypeOf(MountCancelledError)).call(this, 'Mounting cancelled'));

    _this.name = 'MountCancelledError';
    return _this;
  }

  return MountCancelledError;
}(Error);

var mountedClass = 'Component_mounted';

var WidgetMounter = function () {
  function WidgetMounter(store, target) {
    classCallCheck(this, WidgetMounter);
    this.mountId = 0;
    this.mounted = [];

    this.store = store;
    this.target = target;
    this.cache = new WidgetCache();
  }

  createClass(WidgetMounter, [{
    key: 'teardown',
    value: function teardown() {
      this.cache.clear();
      this.mounted.forEach(function (element) {
        return ReactDOM.unmountComponentAtNode(element);
      });
    }
  }, {
    key: 'mount',
    value: function mount() {
      var _this2 = this;

      this.mountId += 1;

      var elements = Array.from(this.target.querySelectorAll('[data-component]'));

      return Promise.all(elements.map(function (element) {
        return _this2.mountElement(element, _this2.mountId).then(function (newElement) {
          replaceElement(element, newElement);
          newElement.classList.add(mountedClass);
          return newElement;
        }).catch(function (e) {
          if (e && e.name !== 'MountCancelledError') return Promise.reject(e);
          return null;
        });
      }));
    }
  }, {
    key: 'mountElement',
    value: function mountElement(element, startMountId) {
      var _this3 = this;

      var widgetName = element.dataset.component;
      var encodedProps = element.dataset.props;
      var props = parseProps(encodedProps);

      var cached = this.cache.restore(widgetName, encodedProps);
      if (cached) {
        this.mounted.push(cached);
        return Promise.resolve(cached);
      }

      return loadWidget(widgetName).then(function (Widget) {
        if (startMountId !== _this3.mountId) throw new MountCancelledError();

        var newElement = element.cloneNode();
        return _this3.mountComponent(newElement, Widget, props, startMountId);
      });
    }
  }, {
    key: 'mountComponent',
    value: function mountComponent(element, Widget, props, startMountId) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var readyCallback = function readyCallback() {
          if (startMountId !== _this4.mountId) {
            reject(new MountCancelledError());
          } else {
            resolve(element);
          }
        };

        ReactDOM.render(jsx(reactRedux.Provider, {
          store: _this4.store
        }, void 0, React.createElement(Widget, _extends({}, props, { onReady: readyCallback }))), element);

        _this4.mounted.push(element);
      });
    }
  }, {
    key: 'unmount',
    value: function unmount() {
      var _this5 = this;

      this.mountId += 1;

      this.cache.clear();
      this.mounted.forEach(function (element) {
        if (element.classList.contains(mountedClass) && element.parentNode) {
          detachElement(element);
          element.classList.remove(mountedClass);
          _this5.cache.save(element);
        }
      });

      this.mounted = [];
    }
  }]);
  return WidgetMounter;
}();

var getContext = function getContext(element) {
  if (element instanceof HTMLElement && element.dataset.context) {
    return parseProps(element.dataset.context);
  }

  return element.parentElement ? getContext(element.parentElement) : null;
};

// eslint-disable-next-line no-new-func
var createCondition = function createCondition(expression) {
  return new Function('__storeData', '\n  try {\n    with (__storeData) {\n      return ' + expression + ';\n    }\n  } catch(e) {\n    console.log(\'Error evaluting expression:\', e);\n    return false;\n  }\n');
};

var subFormValues = function subFormValues(state, formId, prefix) {
  var form = state.form[formId];
  if (!form) return {};

  return fromPairs(entries(form.fields).filter(function (_ref) {
    var _ref2 = slicedToArray(_ref, 1),
        name = _ref2[0];

    return name.startsWith(prefix);
  }).map(function (_ref3) {
    var _ref4 = slicedToArray(_ref3, 2),
        name = _ref4[0],
        field = _ref4[1];

    return [name.substr(prefix.length), field.value];
  }));
};

var contextState = {
  'bundle.group': function bundleGroup(state, _ref5) {
    var id = _ref5.id,
        bundleId = _ref5.props.bundleId,
        groupId = _ref5.child.props.groupId;
    return subFormValues(state, 'bundleBuyActions.' + bundleId + '.' + id, 'group.' + groupId + '.');
  }
};

var getContextState = function getContextState(state, context) {
  var contextType = context.child ? context.type + '.' + context.child.type : context.type;

  return contextState[contextType] ? contextState[contextType](state, context) : {};
};

function attach$1(store, root) {
  var targets = toArray$1(root.querySelectorAll('[data-toggle-class]'));

  var unsubscribes = compact(targets.map(function (target) {
    var condition = createCondition(target.dataset.toggleWhen);
    var context = getContext(target);
    if (!context) return null;

    return store.subscribe(function () {
      var state = store.getState();
      var data = getContextState(state, context);

      if (Object.keys(data).length === 0) return;

      if (condition(data)) {
        target.classList.add(target.dataset.toggleClass);
      } else {
        target.classList.remove(target.dataset.toggleClass);
      }
    });
  }));

  return function () {
    return unsubscribes.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };
}

var scroll = function scroll() {
  return window.scrollY || window.pageYOffset;
};

var stuckClass = 'sticky';

var Sticky = function () {
  function Sticky(element) {
    var _this = this;

    classCallCheck(this, Sticky);
    this.measure = rafDebounce(function () {
      var _element$getBoundingC = _this.element.getBoundingClientRect(),
          width = _element$getBoundingC.width,
          height = _element$getBoundingC.height;

      var _placeholder$getBound = _this.placeholder.getBoundingClientRect(),
          top = _placeholder$getBound.top;

      _this.placeholder.style.width = width + 'px';
      _this.placeholder.style.height = height + 'px';
      _this.stickPoint = scroll() + top;

      _this.update();
    });
    this.update = rafDebounce(function () {
      var shouldStick = scroll() >= _this.stickPoint;

      if (shouldStick && !_this.stuck) _this.stick();
      if (!shouldStick && _this.stuck) _this.unstick();
    });

    this.element = element;
    this.unstick();

    this.placeholder = document.createElement('div');
    insertAfter(this.element, this.placeholder);
    this.measure();

    window.addEventListener('resize', this.measure);
    window.addEventListener('scroll', this.update);
  }

  createClass(Sticky, [{
    key: 'stick',
    value: function stick() {
      this.stuck = true;
      this.element.style.position = 'fixed';
      this.element.classList.add(stuckClass);
    }
  }, {
    key: 'unstick',
    value: function unstick() {
      this.stuck = false;
      this.element.style.position = 'absolute';
      this.element.classList.remove(stuckClass);
    }
  }, {
    key: 'teardown',
    value: function teardown() {
      detachElement(this.placeholder);
      this.element.style.position = '';

      window.removeEventListener('resize', this.measure);
      window.removeEventListener('scroll', this.update);
    }
  }]);
  return Sticky;
}();

var enhancements = {
  '[data-sticky]': Sticky
};

var Interactions = function () {
  function Interactions(store, target) {
    classCallCheck(this, Interactions);

    this.store = store;
    this.target = target;

    this.widgets = new WidgetMounter(store, target);
  }

  createClass(Interactions, [{
    key: 'attach',
    value: function attach() {
      this.widgets.mount();

      this.detachBindingIfAttached();
      this.detachBinding = attach$1(this.store, this.target);

      this.attachEnhancements();
    }
  }, {
    key: 'detach',
    value: function detach() {
      this.widgets.unmount();
      this.detachBindingIfAttached();
      this.detachEnhancements();
    }
  }, {
    key: 'teardown',
    value: function teardown() {
      this.widgets.teardown();
      this.detachBindingIfAttached();
      this.detachEnhancements();
    }
  }, {
    key: 'detachBindingIfAttached',
    value: function detachBindingIfAttached() {
      if (this.detachBinding) {
        this.detachBinding();
        this.detachBinding = null;
      }
    }
  }, {
    key: 'attachEnhancements',
    value: function attachEnhancements() {
      var _this = this;

      this.enhanced = flatMap(entries(enhancements), function (_ref) {
        var _ref2 = slicedToArray(_ref, 2),
            selector = _ref2[0],
            ActualEnhancement = _ref2[1];

        return toArray$1(_this.target.querySelectorAll(selector)).map(function (toEnhance) {
          return new ActualEnhancement(toEnhance);
        });
      });
    }
  }, {
    key: 'detachEnhancements',
    value: function detachEnhancements() {
      this.enhanced.forEach(function (enhancement) {
        return enhancement.teardown();
      });
      this.enhanced = [];
    }
  }]);
  return Interactions;
}();

var ContentContainer = function () {
  function ContentContainer(store, target) {
    var _this = this;

    classCallCheck(this, ContentContainer);

    this.handleUpdate = function () {
      var page = _this.store.getState().page;
      var lastPage = _this.lastPage;

      if (page === lastPage) return;
      _this.lastPage = page;

      if (page.content !== lastPage.content) {
        _this.updateContent(page.content);
      }

      if (page.title !== lastPage.title) {
        _this.updateTitle(page.title);
      }

      if (page.bodyAttrs !== lastPage.bodyAttrs) {
        _this.updateBodyAttrs(page.bodyAttrs);
      }
    };

    this.store = store;
    this.target = target;
    this.lastPage = defaultState$5;
    this.unsubscribe = store.subscribe(this.handleUpdate);

    this.interactions = new Interactions(store, target);
    this.interactions.attach();
  }

  createClass(ContentContainer, [{
    key: 'teardown',
    value: function teardown() {
      this.unsubscribe();
      this.interactions.teardown();
    }
  }, {
    key: 'updateContent',
    value: function updateContent(newContent) {
      if (newContent == null) return;

      this.interactions.detach();
      this.target.innerHTML = newContent;
      this.interactions.attach();
    }
  }, {
    key: 'updateTitle',
    value: function updateTitle(newTitle) {
      document.title = newTitle;
    }
  }, {
    key: 'updateBodyAttrs',
    value: function updateBodyAttrs(attrs) {
      entries(attrs).forEach(function (_ref) {
        var _ref2 = slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];

        return document.body.setAttribute('data-' + name.replace(/_/g, '-'), value);
      });
    }
  }]);
  return ContentContainer;
}();

var LogoutMutation = function (_Mutation) {
  inherits(LogoutMutation, _Mutation);

  function LogoutMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, LogoutMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = LogoutMutation.__proto__ || Object.getPrototypeOf(LogoutMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'UserLogout', _this.mutation = 'logout', _this.query = 'result', _this.invalidateQueries = function () {
      return [];
    }, _this.after = function (result) {
      if (result) {
        window.redirectPending = true;
        window.location.reload();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return LogoutMutation;
}(Mutation);

var TARGETED_ACTION_HANDLERS = {
  toggleClass: function toggleClass(target, element) {
    return target.classList.toggle(element.dataset.toggleClassValue);
  },

  addClass: function addClass(target, element) {
    return target.classList.add(element.dataset.addClassValue);
  },

  removeClass: function removeClass(target, element) {
    return target.classList.remove(element.dataset.removeClassValue);
  }
};

var QUERY_ATTR_RE = /^showModalQuery[A-Z]/;

var ACTION_HANDLERS = {
  dismissModal: function dismissModal() {
    return dispatch(dismissModal$1());
  },

  logout: function logout() {
    return dispatch(fireMutation(new LogoutMutation({})));
  },

  lightBox: function lightBox(element, ev) {
    var getHrefOrSrc = function getHrefOrSrc(el) {
      if (el instanceof HTMLAnchorElement) {
        return el.href;
      } else if (el instanceof HTMLImageElement) {
        return el.src;
      }

      return null;
    };

    var lightBoxSrc = getHrefOrSrc(element);

    if (!lightBoxSrc) {
      window.Bugsnag.notify('Attempt to LightBox element without src or href');
      return null;
    }

    ev.preventDefault();

    return dispatch(showModal$1(Lightbox, {
      className: 'LightBox',
      maxWidth: '100%',
      invoker: lightBoxSrc,
      images: [lightBoxSrc]
    }));
  },

  showModal: function showModal(element) {
    return dispatch(showModal$1(PartialModal, {
      name: element.dataset.showModalModal,
      query: fromPairs(entries(element.dataset).filter(function (_ref) {
        var _ref2 = slicedToArray(_ref, 1),
            name = _ref2[0];

        return QUERY_ATTR_RE.test(name);
      }).map(function (_ref3) {
        var _ref4 = slicedToArray(_ref3, 2),
            name = _ref4[0],
            value = _ref4[1];

        return [name.replace(QUERY_ATTR_RE, function (match$$1) {
          return match$$1[match$$1.length - 1].toLowerCase();
        }), value];
      }))
    }));
  },

  track: function track(element) {
    switch (element.dataset.trackName) {
      case trackingEvents.SOCIAL_SHARE:
        track$1({
          name: trackingEvents.SOCIAL_SHARE,
          action: 'share',
          network: element.dataset.trackNetwork,
          url: element.dataset.trackUrl || element.getAttribute('href') || window.location.pathname
        });
        break;
      case trackingEvents.VIEW_EVENT_DETAIL:
        track$1({ name: trackingEvents.VIEW_EVENT_DETAIL, eventId: element.dataset.trackId });
        break;
      case trackingEvents.VIEW_PRODUCT_DETAIL:
        track$1({ name: trackingEvents.VIEW_PRODUCT_DETAIL, productId: element.dataset.trackId });
        break;
      case trackingEvents.PAGE_VIEW:
        track$1({ name: trackingEvents.PAGE_VIEW, href: element.dataset.trackUrl || element.getAttribute('href') });
        break;
      default:
        window.Bugsnag.notify('Unknown tracking event %s', element.dataset.trackName);
    }
  }
};

var SUPPORTED_EVENTS = ['change', 'click'];

var findTarget$1 = function findTarget$1(el) {
  if (el && el instanceof HTMLElement) {
    return el.dataset.action ? el : findTarget$1(el.parentNode);
  }

  return null;
};

var performAction = function performAction(el, action, ev) {
  var targets = document.querySelectorAll(el.dataset[action + 'Target']);

  if (targets.length && TARGETED_ACTION_HANDLERS[action]) {
    toArray$1(targets).forEach(function (target) {
      return TARGETED_ACTION_HANDLERS[action](target, el, ev);
    });
  }

  if (ACTION_HANDLERS[action]) {
    ACTION_HANDLERS[action](el, ev);
  }
};

var attachEvents = (function () {
  SUPPORTED_EVENTS.forEach(function (event) {
    document.addEventListener(event, function (ev) {
      var target = findTarget$1(ev.target);
      if (target) {
        var actions = target.dataset.action.split(',');

        actions.forEach(function (action) {
          var targetEvent = target.dataset[action + 'Event'] || 'click';
          if (targetEvent === event) performAction(target, action, ev);
        });
      }
    });
  });
});

function always(a) {
  return function () {
    return a;
  };
}

var ADD_TO_BASKET = trackingEvents.ADD_TO_BASKET;
var CONFIRM_LOCATION = trackingEvents.CONFIRM_LOCATION;
var INITIATE_CHECKOUT$1 = trackingEvents.INITIATE_CHECKOUT;
var MAILING_LIST_SUBSCRIBE = trackingEvents.MAILING_LIST_SUBSCRIBE;
var VIEW_EVENT_DETAIL = trackingEvents.VIEW_EVENT_DETAIL;
var VIEW_PRODUCT_DETAIL = trackingEvents.VIEW_PRODUCT_DETAIL;
var TRACKING_EVENTS$1 = streamNames.TRACKING_EVENTS;
var CHECKOUTS$1 = streamNames.CHECKOUTS;


var allEvents$1 = grapevineStreams[TRACKING_EVENTS$1];
var checkoutEvents = grapevineStreams[CHECKOUTS$1];

var simpleEvent = function simpleEvent(eventName) {
  var fbq = window.fbq;

  if (!fbq) {
    return;
  }

  fbq('track', eventName);
};

var fbCheckout = function fbCheckout(_ref) {
  var basket = _ref.event.basket;

  var fbq = window.fbq;

  if (!fbq) {
    return;
  }

  fbq('track', 'Purchase', {
    value: normaliseFractional(basket.overview.totalPrice.amount.cents, basket.overview.totalPrice.amount.currency.toLowerCase()),
    currency: basket.overview.totalPrice.amount.currency
  });
};

function init() {
  merge$1([allEvents$1.filter(eventFilter(VIEW_EVENT_DETAIL)).filter(hasFilledProps(['eventId'])).map(function (_ref2) {
    var eventId = _ref2.eventId;
    return eventId;
  }).merge(allEvents$1.filter(eventFilter(VIEW_PRODUCT_DETAIL)).filter(hasFilledProps(['productId'])).map(function (_ref3) {
    var productId = _ref3.productId;
    return productId;
  })).skipDuplicates().map(always('ViewContent')), allEvents$1.filter(eventFilter(ADD_TO_BASKET)).map(always('AddToCart')), allEvents$1.filter(eventFilter(CONFIRM_LOCATION)).map(always('CompleteRegistration')), allEvents$1.filter(eventFilter(INITIATE_CHECKOUT$1)).map(always('InitiateCheckout')), allEvents$1.filter(eventFilter(MAILING_LIST_SUBSCRIBE)).map(always('Lead'))]).subscribe(simpleEvent);

  checkoutEvents.subscribe(fbCheckout);
}

var kebabSplit = /([a-z])([A-Z])/g;

function kebabCase(s) {
  return s.replace(kebabSplit, '$1-$2').toLowerCase();
}

var PAGE_VIEWS$1 = streamNames.PAGE_VIEWS;
var CHECKOUTS$2 = streamNames.CHECKOUTS;
var SOCIAL_SHARES$1 = streamNames.SOCIAL_SHARES;
var PERF_EVENTS$1 = streamNames.PERF_EVENTS;


var pageViewEvents = grapevineStreams[PAGE_VIEWS$1];
var checkoutEvents$1 = grapevineStreams[CHECKOUTS$2];
var socialShareEvents = grapevineStreams[SOCIAL_SHARES$1];
var perfEvents$1 = grapevineStreams[PERF_EVENTS$1];

var gaPageViews = function gaPageViews() {
  var trackerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var href = arguments[1];

  var ga = window.ga;

  if (!ga) {
    return;
  }

  ga(trackerName + 'set', 'page', href);
  ga(trackerName + 'send', 'pageview');
};

var gaCheckouts = function gaCheckouts() {
  var trackerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref = arguments[1];
  var _ref$event = _ref.event,
      basket = _ref$event.basket,
      profile = _ref$event.profile;

  var ga = window.ga;

  if (!ga) {
    return;
  }

  ga(trackerName + 'ecommerce:addTransaction', {
    id: basket.id,
    affiliation: profile,
    revenue: normaliseFractional(basket.overview.totalPrice.amount.cents, basket.overview.totalPrice.amount.currency.toLowerCase()),
    currency: basket.overview.totalPrice.amount.currency,
    shipping: '',
    tax: ''
  });

  basket.lines.filter(function (line) {
    return !line.product.error;
  }).forEach(function (line) {
    ga(trackerName + 'ecommerce:addItem', {
      id: basket.id,
      name: line.product.result.name,
      sku: line.product.result.id,
      category: '',
      price: '',
      quantity: line.quantity
    });
  });

  ga(trackerName + 'ecommerce:send');
};

function gaSocials() {
  var trackerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref2 = arguments[1];
  var network = _ref2.network,
      action = _ref2.action,
      url = _ref2.url;

  var ga = window.ga;

  if (!ga) {
    return;
  }

  ga(trackerName + 'send', 'social', network, action, url);
}

function gaPerfs() {
  var trackername = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref3 = arguments[1];
  var label = _ref3.label,
      timing = _ref3.timing,
      _ref3$action = _ref3.action,
      action = _ref3$action === undefined ? 'timing' : _ref3$action;

  var ga = window.ga;

  if (!ga) {
    return;
  }

  ga(trackername + 'send', {
    hitType: 'timing',
    timingCategory: 'performance',
    timingVar: action + '-' + kebabCase(label),
    timingLabel: label,
    timingValue: Math.round(timing)
  });
}

var getTrackerPrefix = function getTrackerPrefix() {
  var trackerName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return trackerName.length > 0 ? trackerName + '.' : '';
};

var applyAll = function applyAll(fns) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return fns.forEach(function (fn) {
      return fn.apply(undefined, toConsumableArray(args));
    });
  };
};

var MG_TRACKER = 'mgTracker';

function init$1(profileKey) {
  var trackers = compact([process.env.NODE_ENV === 'production' ? MG_TRACKER : null, profileKey !== null ? 'profileTracker' : null]).map(getTrackerPrefix);

  if (trackers.length > 0) {
    pageViewEvents.subscribe(applyAll(trackers.map(function (trackerName) {
      return gaPageViews.bind(null, trackerName);
    })));

    checkoutEvents$1.subscribe(applyAll(trackers.map(function (trackerName) {
      return gaCheckouts.bind(null, trackerName);
    })));

    socialShareEvents.subscribe(applyAll(trackers.map(function (trackerName) {
      return gaSocials.bind(null, trackerName);
    })));

    if (trackers.includes(MG_TRACKER)) {
      perfEvents$1.subscribe(gaPerfs.bind(null, getTrackerPrefix(MG_TRACKER)));
    }
  }
}

var CHECKOUTS$3 = streamNames.CHECKOUTS;
var PAGE_VIEWS$2 = streamNames.PAGE_VIEWS;


var pageViews$1 = grapevineStreams[PAGE_VIEWS$2];
var checkouts$1 = grapevineStreams[CHECKOUTS$3];

var twPageView = function twPageView() {
  var twq = window.twq;

  if (!twq) {
    return;
  }

  twq('track', 'PageView');
};

function init$2() {
  pageViews$1.merge(checkouts$1).subscribe(twPageView);
}

function initPixelTracking(trackingProps) {
  var wasInitialised = false;

  // Production has Music Glue GA tracking enabled, but that isn't sourced from the graph
  if (trackingProps.googleAnalytics || process.env.NODE_ENV === 'production') {
    init$1(trackingProps.googleAnalytics);
    wasInitialised = true;
  }

  if (trackingProps.facebookPixel) {
    init();
    wasInitialised = true;
  }

  if (trackingProps.twitterTag) {
    init$2();
    wasInitialised = true;
  }

  return wasInitialised;
}

var UNAUTHED_ITEMS = 'UNAUTHED_ITEMS';
var PRICES_CHANGED = 'PRICES_CHANGED';

var showAlert = function showAlert(props) {
  return dispatch(showModal$1(SimpleModal, props));
};

var authorisationWorkflow = function authorisationWorkflow() {
  return dispatch(fireMutation(new AuthorizeBasketMutation({}))).then(function (_ref) {
    var basketItemsRemoved = _ref.basketItemsRemoved;

    if (!basketItemsRemoved) return;

    showAlert({ content: t('basket.itemsRemoved') });
    throw new Error(UNAUTHED_ITEMS);
  });
};

var priceValidationWorkflow = function priceValidationWorkflow() {
  return dispatch(fireMutation(new ValidateBasketPricesMutation({}))).then(function (_ref2) {
    var somethingChanged = _ref2.somethingChanged;

    if (!somethingChanged) return;

    dispatch(showModal$1(PricesChangedModal, { content: t('basket.priceChanged') }));
    throw new Error(PRICES_CHANGED);
  });
};

var authorizeAndValidateBasket$1 = function authorizeAndValidateBasket$1() {
  return Promise.all([authorisationWorkflow(), priceValidationWorkflow()]);
};

var handleCheckoutPath = function handleCheckoutPath() {
  return authorizeAndValidateBasket$1().then(function () {
    return dispatch(fireMutation(new ExtendReservationMutation({})));
  }).then(function (_ref3) {
    var reservationErrors = _ref3.reservationErrors;

    if (reservationErrors) dispatch(showModal$1(FailureToReserveAlert, { reservationErrors: reservationErrors }));
  }).catch(function (err) {
    switch (err.message) {
      case UNAUTHED_ITEMS:
      case PRICES_CHANGED:
        Bugsnag.notifyException(err);

        break;
      default:
        showAlert({
          title: t('alerts.titles.error'),
          content: t('basket.error.reservationFailed')
        });
    }
  });
};

var listenedPaths = {
  basket: authorizeAndValidateBasket$1,
  checkout: handleCheckoutPath
};

var basketEvents = (function (location) {
  var processedPath = last(location.pathname.split('/'));
  if (listenedPaths[processedPath]) listenedPaths[processedPath]();
});

var BaseModal = function (_React$Component) {
  inherits(BaseModal, _React$Component);

  function BaseModal() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, BaseModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = BaseModal.__proto__ || Object.getPrototypeOf(BaseModal)).call.apply(_ref, [this].concat(args))), _this), _this.dismiss = function (e) {
      if (_this.props.onDismiss) {
        _this.props.onDismiss();
        e.stopPropagation();
      }
    }, _this.handleKeyDown = function (e) {
      if (e.keyCode === 27) _this.dismiss(e); // ESC
    }, _this.stopPropagation = function (e) {
      return e.stopPropagation();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(BaseModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.contentEl) this.contentEl.focus();
    } // eslint-disable-line react/sort-comp

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          _props$maxWidth = _props.maxWidth,
          maxWidth = _props$maxWidth === undefined ? '520px' : _props$maxWidth,
          className = _props.className;


      return jsx('div', {
        className: cx('Modal', className)
      }, void 0, jsx('div', {
        className: 'Modal-colourOverlay',
        onClick: this.dismiss
      }), jsx('div', {
        className: 'Modal-contentWrapper',
        onClick: this.dismiss
      }, void 0, React.createElement(
        'div',
        {
          className: 'Modal-content',
          style: { maxWidth: maxWidth },
          onKeyDown: this.handleKeyDown,
          tabIndex: '-1',
          ref: function ref(c) {
            _this2.contentEl = c;
          },
          onClick: this.stopPropagation
        },
        children
      )));
    }
  }]);
  return BaseModal;
}(React.Component);

function ModalContainer(_ref) {
  var modal = _ref.modal,
      onDismiss = _ref.onDismiss;

  if (!modal) return null;

  var Component = modal.modal,
      props = modal.props,
      options = modal.options;


  return React.createElement(
    BaseModal,
    _extends({}, props, { onDismiss: options.preventDismiss ? noop : onDismiss }),
    React.createElement(Component, _extends({}, props, { onDismiss: onDismiss }))
  );
}

var mapDispatchToProps$21 = function mapDispatchToProps$21(dispatch) {
  return {
    onDismiss: function onDismiss() {
      return dispatch(dismissModal$1());
    }
  };
};

var mapStateToProps$27 = function mapStateToProps$27(state) {
  return {
    modal: state.modals[state.modals.length - 1] || null
  };
};

var ModalContainer$1 = reactRedux.connect(mapStateToProps$27, mapDispatchToProps$21)(ModalContainer);

var FetchStreamUrl = function (_Mutation) {
  inherits(FetchStreamUrl, _Mutation);

  function FetchStreamUrl() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, FetchStreamUrl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = FetchStreamUrl.__proto__ || Object.getPrototypeOf(FetchStreamUrl)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'FetchStreamUrl', _this.mutation = 'fetchStreamUrl', _this.invalidateQueries = function () {
      return [];
    }, _this.query = 'url,expires,playCount', _temp), possibleConstructorReturn(_this, _ret);
  }

  return FetchStreamUrl;
}(Mutation);

var SILENCE = 'https://d22bt6rnnycqv7.cloudfront.net/audio/preloadsound.mp3'; // silence

var isAbortError = function isAbortError(err) {
  return err.code === 20 || err.name === 'AbortError';
};

var play = function play(audio) {
  Promise.resolve(audio.play()).catch(function (err) {
    return isAbortError(err) ? null : Promise.reject(err);
  });
};

var StreamPlayer = function (_React$Component) {
  inherits(StreamPlayer, _React$Component);

  function StreamPlayer() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, StreamPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = StreamPlayer.__proto__ || Object.getPrototypeOf(StreamPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.audio = null, _this.source = null, _temp), possibleConstructorReturn(_this, _ret);
  } // eslint-disable-line react/sort-comp


  createClass(StreamPlayer, [{
    key: 'componentDidMount',
    // eslint-disable-line react/sort-comp

    value: function componentDidMount() {
      this.initializePlayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.killPlayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var streamId = this.props.playback.streamId;


      var changingTrack = streamId !== prevProps.playback.streamId;

      if (changingTrack) {
        this.killPlayer();
        this.initializePlayer();
      }

      this.playOrPause();
    }
  }, {
    key: 'fetchStreamUrl',
    value: function fetchStreamUrl() {
      var _this2 = this;

      var audio = this.audio,
          source = this.source;
      var _props = this.props,
          onFetchStreamUrl = _props.onFetchStreamUrl,
          streamId = _props.playback.streamId;


      if (audio == null || source == null || streamId == null) {
        return Promise.reject(new Error('Unexpected null value'));
      }

      source.src = SILENCE;
      play(audio);

      return onFetchStreamUrl(streamId).then(function (_ref2) {
        var streamUrl = _ref2.url;

        audio.pause();
        source.src = streamUrl;
        audio.load();

        _this2.audio = audio;
        _this2.source = source;
      });
    }
  }, {
    key: 'initializePlayer',
    value: function initializePlayer() {
      // build: <audio><source type='audio/mpeg' src='' /></audio>
      var audio = document.createElement('audio');
      var source = document.createElement('source');

      source.type = 'audio/mpeg';
      audio.appendChild(source);
      audio.addEventListener('ended', this.props.onNextTrack);
      audio.addEventListener('canplaythrough', this.props.onLoadedTrack);

      this.audio = audio;
      this.source = source;
    }
  }, {
    key: 'killPlayer',
    value: function killPlayer() {
      var audio = this.audio;
      var source = this.source;
      // http://stackoverflow.com/questions/4071872/html5-video-force-abort-of-buffering#answer-13302599
      if (audio != null && source != null) {
        audio.pause();
        source.src = '';
        audio.load();
        audio.removeEventListener('ended', this.props.onNextTrack);
        audio.removeEventListener('canplaythrough', this.props.onLoadedTrack);
        this.source = null;
        this.audio = null;
      }
    }
  }, {
    key: 'playOrPause',
    value: function playOrPause() {
      var _this3 = this;

      var _props$playback = this.props.playback,
          pending = _props$playback.pending,
          active = _props$playback.active;


      if (pending && active) {
        this.fetchStreamUrl().then(function () {
          if (active) _this3.playAudio();
        });
      } else if (this.audio != null) {
        if (active) {
          this.playAudio();
        } else {
          this.audio.pause();
        }
      }
    }
  }, {
    key: 'playAudio',
    value: function playAudio() {
      var audio = this.audio;


      if (audio != null) {
        play(audio);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return StreamPlayer;
}(React.Component);

var mapStateToProps$28 = function mapStateToProps$28(_ref3) {
  var playback = _ref3.streamPlayer.playback;
  return { playback: playback };
};

var mapDispatchToProps$22 = function mapDispatchToProps$22(dispatch) {
  return {
    onLoadedTrack: function onLoadedTrack() {
      return dispatch(loadedTrack());
    },
    onNextTrack: function onNextTrack() {
      return dispatch(nextTrack$1());
    },
    onFetchStreamUrl: function onFetchStreamUrl(streamId) {
      return dispatch(fireMutation(new FetchStreamUrl({ streamId: streamId })));
    }
  };
};

var StreamPlayer$1 = reactRedux.connect(mapStateToProps$28, mapDispatchToProps$22)(StreamPlayer);

var AbandonReservablesMutation = function (_Mutation) {
  inherits(AbandonReservablesMutation, _Mutation);

  function AbandonReservablesMutation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AbandonReservablesMutation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AbandonReservablesMutation.__proto__ || Object.getPrototypeOf(AbandonReservablesMutation)).call.apply(_ref, [this].concat(args))), _this), _this.type = 'AbandonReservables', _this.mutation = 'abandonReservables', _this.invalidateQueries = function (_, queryIds) {
      return queryIds.filter(match(/^(productPurchasables|basket)\./));
    }, _this.invalidatePartials = function () {
      return ['basket'];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return AbandonReservablesMutation;
}(Mutation);

var ReservationExpiryModal = function (_React$Component) {
  inherits(ReservationExpiryModal, _React$Component);

  function ReservationExpiryModal() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ReservationExpiryModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ReservationExpiryModal.__proto__ || Object.getPrototypeOf(ReservationExpiryModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = { processing: false }, _this.handleExtendResponse = function (_ref2) {
      var reservationErrors = _ref2.reservationErrors;

      if (reservationErrors) _this.props.onReservationError(reservationErrors);else _this.props.onDismiss();
    }, _this.extendReservations = function () {
      _this.setState({ processing: true });

      _this.props.onExtend().then(_this.handleExtendResponse).catch(function () {
        return _this.props.onError();
      });
    }, _this.abandonReservation = function () {
      _this.setState({ processing: true });
      _this.props.onAbandon().then(function () {
        return _this.props.onDismiss();
      }).catch(function () {
        return _this.props.onError();
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ReservationExpiryModal, [{
    key: 'render',
    value: function render() {
      var conveys = this.props.conveys;

      var translateType = function translateType(a, b) {
        return conveys === 'expired' ? a : b;
      };

      return jsx('div', {
        className: 'ReservationExpiryModal'
      }, void 0, jsx('h2', {}, void 0, t('basket.error.' + translateType('expired', 'expiring'))), jsx('p', {}, void 0, t('basket.error.' + translateType('attemptRereserve', 'reReserve'))), jsx(Button, {
        onClick: this.extendReservations,
        disabled: this.state.processing
      }, void 0, t('alerts.buttons.' + translateType('attemptRereserve', 'reReserve'))), jsx(Button, {
        onClick: this.abandonReservation,
        disabled: this.state.processing
      }, void 0, t('alerts.buttons.abandon')));
    }
  }]);
  return ReservationExpiryModal;
}(React.Component);

var mapDispatchToProps$24 = function mapDispatchToProps$24(dispatch) {
  return {
    onExtend: function onExtend() {
      return dispatch(fireMutation(new ExtendReservationMutation({})));
    },
    onAbandon: function onAbandon() {
      return dispatch(fireMutation(new AbandonReservablesMutation({})));
    },
    onReservationError: function onReservationError(errors) {
      return dispatch(replaceModal(FailureToReserveAlert, { errors: errors }));
    },
    onError: function onError() {
      return dispatch(replaceModal(SimpleModal, { title: t('alerts.titles.error'), content: t('basket.error.reservationFailed') }));
    }
  };
};

var ReservationExpiryModal$1 = reactRedux.connect(null, mapDispatchToProps$24)(ReservationExpiryModal);

var EXPIRING_SLEEP_MILLISECONDS$1 = 1000;
var IDLING_SLEEP_MILLISECONDS$1 = 10000;
var EXPIRY_MODE_THRESHOLD$1 = 60000;

var ReservationExpiry$2 = function (_React$Component) {
  inherits(ReservationExpiry, _React$Component);

  function ReservationExpiry() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ReservationExpiry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ReservationExpiry.__proto__ || Object.getPrototypeOf(ReservationExpiry)).call.apply(_ref, [this].concat(args))), _this), _this.sleep = IDLING_SLEEP_MILLISECONDS$1, _this.lastIteration = new Date(0), _this.warningSent = false, _this.expirySent = false, _this.tuneSleep = function (remainingTime) {
      _this.sleep = remainingTime < EXPIRY_MODE_THRESHOLD$1 ? EXPIRING_SLEEP_MILLISECONDS$1 : IDLING_SLEEP_MILLISECONDS$1;
    }, _this.tick = function () {
      var iterationTimestamp = Date.now();

      if (_this.lastIteration < new Date(iterationTimestamp - _this.sleep)) {
        _this.lastIteration = iterationTimestamp;
        _this.iterate(iterationTimestamp);
      }
    }, _this.iterate = function () {
      var _this$props = _this.props,
          onExpiring = _this$props.onExpiring,
          onExpired = _this$props.onExpired,
          dismiss = _this$props.dismiss,
          overview = _this$props.overview;

      var expiry = overview.reservationExpiresAt;

      if (expiry) {
        var remaining = new Date(expiry) - Date.now();
        _this.tuneSleep(remaining);

        if (remaining <= 0 && !_this.expirySent) {
          _this.warningSent = true;
          _this.expirySent = true;
          dismiss();
          onExpired();
        }

        if (remaining < EXPIRY_MODE_THRESHOLD$1 && !_this.warningSent) {
          _this.warningSent = true;
          onExpiring();
        }

        if (remaining > EXPIRY_MODE_THRESHOLD$1 && _this.warningSent) {
          _this.warningSent = false;
          _this.expirySent = false;
        }
      }
    }, _this.render = function () {
      return null;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ReservationExpiry, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.timer = setInterval(this.tick, EXPIRING_SLEEP_MILLISECONDS$1);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }]);
  return ReservationExpiry;
}(React.Component);

var queries$6 = { overview: basketOverviewQuery };

var mapDispatchToProps$23 = function mapDispatchToProps$23(dispatch) {
  return {
    onExpiring: function onExpiring() {
      return dispatch(showModal$1(ReservationExpiryModal$1, { conveys: 'expiring' }, { preventDismiss: true }));
    },
    onExpired: function onExpired() {
      return dispatch(showModal$1(ReservationExpiryModal$1, { conveys: 'expired' }, { preventDismiss: true }));
    },
    dismiss: function dismiss() {
      return dispatch(dismissModal$1());
    }
  };
};

var ReservationExpiry$3 = withQueries$1(reactRedux.connect(null, mapDispatchToProps$23)(ReservationExpiry$2), queries$6);

var _ref2$7 = jsx('div', {}, void 0, jsx(ReservationExpiry$3, {}), jsx(ModalContainer$1, {}), jsx(StreamPlayer$1, {}), jsx('div', {
  id: 'fb-root'
}));

function App(_ref) {
  var store = _ref.store;

  return jsx(reactRedux.Provider, {
    store: store
  }, void 0, _ref2$7);
}

FastClick.attach(document.body);

var root = document.getElementById('root');
var navigation = new Navigation();
var content = new ContentContainer(store, root);
attachEvents();

navigation.onNavigate(basketEvents);
navigation.onNavigate(navigationListener);

var appContainer = document.createElement('div');
document.body.appendChild(appContainer);
ReactDOM.render(jsx(App, {
  store: store
}), appContainer);

window.breakwater = {
  content: content,
  navigation: navigation,
  store: store,
  dispatch: dispatch
};

window.hydrateStore = function () {
  dispatch(updateConfig(window.initialStore));
  dispatch(initialLoad$1(window.initialStore.streams));
  dispatch(addSecret(window.initialStore.page.secret));

  if (initPixelTracking(getState().config.pixelTracking)) {
    navigation.onNavigate(function (_ref) {
      var pathname = _ref.pathname;
      return track$1({ name: trackingEvents.PAGE_VIEW, pathname: pathname });
    });
  }

  exec();
};

if (window.initialStore) window.hydrateStore();

if (process.env.NODE_ENV !== 'production' && module.hot) {
  // $FlowFixMe
  module.hot.accept('./lib/ContentContainer', function () {
    content.teardown();

    // eslint-disable-next-line global-require
    var NextContentContainer = require('./lib/ContentContainer').default;

    content = new NextContentContainer(store, root);
  });
}



//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 0
// module chunks = 0